function tr(a) {
  if (a === void 0)
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  return a;
}
function Vo(a, e) {
  (a.prototype = Object.create(e.prototype)),
    (a.prototype.constructor = a),
    (a.__proto__ = e);
}
/*!
 * GSAP 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */ var Tt = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: { lineHeight: "" },
  },
  di = { duration: 0.5, overwrite: !1, delay: 0 },
  As,
  Ie,
  ae,
  Mt = 1e8,
  re = 1 / Mt,
  us = Math.PI * 2,
  cu = us / 4,
  hu = 0,
  Uo = Math.sqrt,
  _u = Math.cos,
  du = Math.sin,
  Re = function (e) {
    return typeof e == "string";
  },
  _e = function (e) {
    return typeof e == "function";
  },
  or = function (e) {
    return typeof e == "number";
  },
  zs = function (e) {
    return typeof e > "u";
  },
  Kt = function (e) {
    return typeof e == "object";
  },
  at = function (e) {
    return e !== !1;
  },
  Fs = function () {
    return typeof window < "u";
  },
  un = function (e) {
    return _e(e) || Re(e);
  },
  $o =
    (typeof ArrayBuffer == "function" && ArrayBuffer.isView) || function () {},
  Ge = Array.isArray,
  ls = /(?:-?\.?\d|\.)+/gi,
  Wo = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
  si = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
  Hn = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
  Go = /[+-]=-?[.\d]+/,
  Ho = /[^,'"\[\]\s]+/gi,
  pu = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
  le,
  Vt,
  fs,
  Ls,
  wt = {},
  Dn = {},
  qo,
  Ko = function (e) {
    return (Dn = pi(e, wt)) && ct;
  },
  Is = function (e, r) {
    return console.warn(
      "Invalid property",
      e,
      "set to",
      r,
      "Missing plugin? gsap.registerPlugin()"
    );
  },
  qi = function (e, r) {
    return !r && console.warn(e);
  },
  Qo = function (e, r) {
    return (e && (wt[e] = r) && Dn && (Dn[e] = r)) || wt;
  },
  Ki = function () {
    return 0;
  },
  gu = { suppressEvents: !0, isStart: !0, kill: !1 },
  bn = { suppressEvents: !0, kill: !1 },
  mu = { suppressEvents: !0 },
  Ns = {},
  xr = [],
  cs = {},
  Zo,
  mt = {},
  qn = {},
  so = 30,
  Tn = [],
  Ys = "",
  Bs = function (e) {
    var r = e[0],
      t,
      i;
    if ((Kt(r) || _e(r) || (e = [e]), !(t = (r._gsap || {}).harness))) {
      for (i = Tn.length; i-- && !Tn[i].targetTest(r); );
      t = Tn[i];
    }
    for (i = e.length; i--; )
      (e[i] && (e[i]._gsap || (e[i]._gsap = new ba(e[i], t)))) ||
        e.splice(i, 1);
    return e;
  },
  Yr = function (e) {
    return e._gsap || Bs(Dt(e))[0]._gsap;
  },
  Jo = function (e, r, t) {
    return (t = e[r]) && _e(t)
      ? e[r]()
      : (zs(t) && e.getAttribute && e.getAttribute(r)) || t;
  },
  ut = function (e, r) {
    return (e = e.split(",")).forEach(r) || e;
  },
  ye = function (e) {
    return Math.round(e * 1e5) / 1e5 || 0;
  },
  Se = function (e) {
    return Math.round(e * 1e7) / 1e7 || 0;
  },
  ui = function (e, r) {
    var t = r.charAt(0),
      i = parseFloat(r.substr(2));
    return (
      (e = parseFloat(e)),
      t === "+" ? e + i : t === "-" ? e - i : t === "*" ? e * i : e / i
    );
  },
  yu = function (e, r) {
    for (var t = r.length, i = 0; e.indexOf(r[i]) < 0 && ++i < t; );
    return i < t;
  },
  En = function () {
    var e = xr.length,
      r = xr.slice(0),
      t,
      i;
    for (cs = {}, xr.length = 0, t = 0; t < e; t++)
      (i = r[t]),
        i && i._lazy && (i.render(i._lazy[0], i._lazy[1], !0)._lazy = 0);
  },
  jo = function (e, r, t, i) {
    xr.length && !Ie && En(),
      e.render(r, t, Ie && r < 0 && (e._initted || e._startAt)),
      xr.length && !Ie && En();
  },
  ea = function (e) {
    var r = parseFloat(e);
    return (r || r === 0) && (e + "").match(Ho).length < 2
      ? r
      : Re(e)
      ? e.trim()
      : e;
  },
  ta = function (e) {
    return e;
  },
  St = function (e, r) {
    for (var t in r) t in e || (e[t] = r[t]);
    return e;
  },
  vu = function (e) {
    return function (r, t) {
      for (var i in t)
        i in r || (i === "duration" && e) || i === "ease" || (r[i] = t[i]);
    };
  },
  pi = function (e, r) {
    for (var t in r) e[t] = r[t];
    return e;
  },
  oo = function a(e, r) {
    for (var t in r)
      t !== "__proto__" &&
        t !== "constructor" &&
        t !== "prototype" &&
        (e[t] = Kt(r[t]) ? a(e[t] || (e[t] = {}), r[t]) : r[t]);
    return e;
  },
  Rn = function (e, r) {
    var t = {},
      i;
    for (i in e) i in r || (t[i] = e[i]);
    return t;
  },
  Li = function (e) {
    var r = e.parent || le,
      t = e.keyframes ? vu(Ge(e.keyframes)) : St;
    if (at(e.inherit))
      for (; r; ) t(e, r.vars.defaults), (r = r.parent || r._dp);
    return e;
  },
  xu = function (e, r) {
    for (var t = e.length, i = t === r.length; i && t-- && e[t] === r[t]; );
    return t < 0;
  },
  ra = function (e, r, t, i, n) {
    var s = e[i],
      o;
    if (n) for (o = r[n]; s && s[n] > o; ) s = s._prev;
    return (
      s ? ((r._next = s._next), (s._next = r)) : ((r._next = e[t]), (e[t] = r)),
      r._next ? (r._next._prev = r) : (e[i] = r),
      (r._prev = s),
      (r.parent = r._dp = e),
      r
    );
  },
  Vn = function (e, r, t, i) {
    t === void 0 && (t = "_first"), i === void 0 && (i = "_last");
    var n = r._prev,
      s = r._next;
    n ? (n._next = s) : e[t] === r && (e[t] = s),
      s ? (s._prev = n) : e[i] === r && (e[i] = n),
      (r._next = r._prev = r.parent = null);
  },
  wr = function (e, r) {
    e.parent &&
      (!r || e.parent.autoRemoveChildren) &&
      e.parent.remove &&
      e.parent.remove(e),
      (e._act = 0);
  },
  Br = function (e, r) {
    if (e && (!r || r._end > e._dur || r._start < 0))
      for (var t = e; t; ) (t._dirty = 1), (t = t.parent);
    return e;
  },
  bu = function (e) {
    for (var r = e.parent; r && r.parent; )
      (r._dirty = 1), r.totalDuration(), (r = r.parent);
    return e;
  },
  hs = function (e, r, t, i) {
    return (
      e._startAt &&
      (Ie
        ? e._startAt.revert(bn)
        : (e.vars.immediateRender && !e.vars.autoRevert) ||
          e._startAt.render(r, !0, i))
    );
  },
  Tu = function a(e) {
    return !e || (e._ts && a(e.parent));
  },
  ao = function (e) {
    return e._repeat ? gi(e._tTime, (e = e.duration() + e._rDelay)) * e : 0;
  },
  gi = function (e, r) {
    var t = Math.floor((e = Se(e / r)));
    return e && t === e ? t - 1 : t;
  },
  An = function (e, r) {
    return (
      (e - r._start) * r._ts +
      (r._ts >= 0 ? 0 : r._dirty ? r.totalDuration() : r._tDur)
    );
  },
  Un = function (e) {
    return (e._end = Se(
      e._start + (e._tDur / Math.abs(e._ts || e._rts || re) || 0)
    ));
  },
  $n = function (e, r) {
    var t = e._dp;
    return (
      t &&
        t.smoothChildTiming &&
        e._ts &&
        ((e._start = Se(
          t._time -
            (e._ts > 0
              ? r / e._ts
              : ((e._dirty ? e.totalDuration() : e._tDur) - r) / -e._ts)
        )),
        Un(e),
        t._dirty || Br(t, e)),
      e
    );
  },
  ia = function (e, r) {
    var t;
    if (
      ((r._time ||
        (!r._dur && r._initted) ||
        (r._start < e._time && (r._dur || !r.add))) &&
        ((t = An(e.rawTime(), r)),
        (!r._dur || nn(0, r.totalDuration(), t) - r._tTime > re) &&
          r.render(t, !0)),
      Br(e, r)._dp && e._initted && e._time >= e._dur && e._ts)
    ) {
      if (e._dur < e.duration())
        for (t = e; t._dp; )
          t.rawTime() >= 0 && t.totalTime(t._tTime), (t = t._dp);
      e._zTime = -re;
    }
  },
  $t = function (e, r, t, i) {
    return (
      r.parent && wr(r),
      (r._start = Se(
        (or(t) ? t : t || e !== le ? Ct(e, t, r) : e._time) + r._delay
      )),
      (r._end = Se(
        r._start + (r.totalDuration() / Math.abs(r.timeScale()) || 0)
      )),
      ra(e, r, "_first", "_last", e._sort ? "_start" : 0),
      _s(r) || (e._recent = r),
      i || ia(e, r),
      e._ts < 0 && $n(e, e._tTime),
      e
    );
  },
  na = function (e, r) {
    return (
      (wt.ScrollTrigger || Is("scrollTrigger", r)) &&
      wt.ScrollTrigger.create(r, e)
    );
  },
  sa = function (e, r, t, i, n) {
    if ((Vs(e, r, n), !e._initted)) return 1;
    if (
      !t &&
      e._pt &&
      !Ie &&
      ((e._dur && e.vars.lazy !== !1) || (!e._dur && e.vars.lazy)) &&
      Zo !== vt.frame
    )
      return xr.push(e), (e._lazy = [n, i]), 1;
  },
  wu = function a(e) {
    var r = e.parent;
    return r && r._ts && r._initted && !r._lock && (r.rawTime() < 0 || a(r));
  },
  _s = function (e) {
    var r = e.data;
    return r === "isFromStart" || r === "isStart";
  },
  Su = function (e, r, t, i) {
    var n = e.ratio,
      s =
        r < 0 ||
        (!r &&
          ((!e._start && wu(e) && !(!e._initted && _s(e))) ||
            ((e._ts < 0 || e._dp._ts < 0) && !_s(e))))
          ? 0
          : 1,
      o = e._rDelay,
      u = 0,
      l,
      f,
      _;
    if (
      (o &&
        e._repeat &&
        ((u = nn(0, e._tDur, r)),
        (f = gi(u, o)),
        e._yoyo && f & 1 && (s = 1 - s),
        f !== gi(e._tTime, o) &&
          ((n = 1 - s), e.vars.repeatRefresh && e._initted && e.invalidate())),
      s !== n || Ie || i || e._zTime === re || (!r && e._zTime))
    ) {
      if (!e._initted && sa(e, r, i, t, u)) return;
      for (
        _ = e._zTime,
          e._zTime = r || (t ? re : 0),
          t || (t = r && !_),
          e.ratio = s,
          e._from && (s = 1 - s),
          e._time = 0,
          e._tTime = u,
          l = e._pt;
        l;

      )
        l.r(s, l.d), (l = l._next);
      r < 0 && hs(e, r, t, !0),
        e._onUpdate && !t && bt(e, "onUpdate"),
        u && e._repeat && !t && e.parent && bt(e, "onRepeat"),
        (r >= e._tDur || r < 0) &&
          e.ratio === s &&
          (s && wr(e, 1),
          !t &&
            !Ie &&
            (bt(e, s ? "onComplete" : "onReverseComplete", !0),
            e._prom && e._prom()));
    } else e._zTime || (e._zTime = r);
  },
  ku = function (e, r, t) {
    var i;
    if (t > r)
      for (i = e._first; i && i._start <= t; ) {
        if (i.data === "isPause" && i._start > r) return i;
        i = i._next;
      }
    else
      for (i = e._last; i && i._start >= t; ) {
        if (i.data === "isPause" && i._start < r) return i;
        i = i._prev;
      }
  },
  mi = function (e, r, t, i) {
    var n = e._repeat,
      s = Se(r) || 0,
      o = e._tTime / e._tDur;
    return (
      o && !i && (e._time *= s / e._dur),
      (e._dur = s),
      (e._tDur = n ? (n < 0 ? 1e10 : Se(s * (n + 1) + e._rDelay * n)) : s),
      o > 0 && !i && $n(e, (e._tTime = e._tDur * o)),
      e.parent && Un(e),
      t || Br(e.parent, e),
      e
    );
  },
  uo = function (e) {
    return e instanceof rt ? Br(e) : mi(e, e._dur);
  },
  Cu = { _start: 0, endTime: Ki, totalDuration: Ki },
  Ct = function a(e, r, t) {
    var i = e.labels,
      n = e._recent || Cu,
      s = e.duration() >= Mt ? n.endTime(!1) : e._dur,
      o,
      u,
      l;
    return Re(r) && (isNaN(r) || r in i)
      ? ((u = r.charAt(0)),
        (l = r.substr(-1) === "%"),
        (o = r.indexOf("=")),
        u === "<" || u === ">"
          ? (o >= 0 && (r = r.replace(/=/, "")),
            (u === "<" ? n._start : n.endTime(n._repeat >= 0)) +
              (parseFloat(r.substr(1)) || 0) *
                (l ? (o < 0 ? n : t).totalDuration() / 100 : 1))
          : o < 0
          ? (r in i || (i[r] = s), i[r])
          : ((u = parseFloat(r.charAt(o - 1) + r.substr(o + 1))),
            l && t && (u = (u / 100) * (Ge(t) ? t[0] : t).totalDuration()),
            o > 1 ? a(e, r.substr(0, o - 1), t) + u : s + u))
      : r == null
      ? s
      : +r;
  },
  Ii = function (e, r, t) {
    var i = or(r[1]),
      n = (i ? 2 : 1) + (e < 2 ? 0 : 1),
      s = r[n],
      o,
      u;
    if ((i && (s.duration = r[1]), (s.parent = t), e)) {
      for (o = s, u = t; u && !("immediateRender" in o); )
        (o = u.vars.defaults || {}), (u = at(u.vars.inherit) && u.parent);
      (s.immediateRender = at(o.immediateRender)),
        e < 2 ? (s.runBackwards = 1) : (s.startAt = r[n - 1]);
    }
    return new we(r[0], s, r[n + 1]);
  },
  Cr = function (e, r) {
    return e || e === 0 ? r(e) : r;
  },
  nn = function (e, r, t) {
    return t < e ? e : t > r ? r : t;
  },
  $e = function (e, r) {
    return !Re(e) || !(r = pu.exec(e)) ? "" : r[1];
  },
  Pu = function (e, r, t) {
    return Cr(t, function (i) {
      return nn(e, r, i);
    });
  },
  ds = [].slice,
  oa = function (e, r) {
    return (
      e &&
      Kt(e) &&
      "length" in e &&
      ((!r && !e.length) || (e.length - 1 in e && Kt(e[0]))) &&
      !e.nodeType &&
      e !== Vt
    );
  },
  Ou = function (e, r, t) {
    return (
      t === void 0 && (t = []),
      e.forEach(function (i) {
        var n;
        return (Re(i) && !r) || oa(i, 1)
          ? (n = t).push.apply(n, Dt(i))
          : t.push(i);
      }) || t
    );
  },
  Dt = function (e, r, t) {
    return ae && !r && ae.selector
      ? ae.selector(e)
      : Re(e) && !t && (fs || !yi())
      ? ds.call((r || Ls).querySelectorAll(e), 0)
      : Ge(e)
      ? Ou(e, t)
      : oa(e)
      ? ds.call(e, 0)
      : e
      ? [e]
      : [];
  },
  ps = function (e) {
    return (
      (e = Dt(e)[0] || qi("Invalid scope") || {}),
      function (r) {
        var t = e.current || e.nativeElement || e;
        return Dt(
          r,
          t.querySelectorAll
            ? t
            : t === e
            ? qi("Invalid scope") || Ls.createElement("div")
            : e
        );
      }
    );
  },
  aa = function (e) {
    return e.sort(function () {
      return 0.5 - Math.random();
    });
  },
  ua = function (e) {
    if (_e(e)) return e;
    var r = Kt(e) ? e : { each: e },
      t = Xr(r.ease),
      i = r.from || 0,
      n = parseFloat(r.base) || 0,
      s = {},
      o = i > 0 && i < 1,
      u = isNaN(i) || o,
      l = r.axis,
      f = i,
      _ = i;
    return (
      Re(i)
        ? (f = _ = { center: 0.5, edges: 0.5, end: 1 }[i] || 0)
        : !o && u && ((f = i[0]), (_ = i[1])),
      function (d, c, p) {
        var h = (p || r).length,
          m = s[h],
          T,
          b,
          S,
          v,
          w,
          C,
          x,
          O,
          k;
        if (!m) {
          if (((k = r.grid === "auto" ? 0 : (r.grid || [1, Mt])[1]), !k)) {
            for (
              x = -Mt;
              x < (x = p[k++].getBoundingClientRect().left) && k < h;

            );
            k < h && k--;
          }
          for (
            m = s[h] = [],
              T = u ? Math.min(k, h) * f - 0.5 : i % k,
              b = k === Mt ? 0 : u ? (h * _) / k - 0.5 : (i / k) | 0,
              x = 0,
              O = Mt,
              C = 0;
            C < h;
            C++
          )
            (S = (C % k) - T),
              (v = b - ((C / k) | 0)),
              (m[C] = w = l ? Math.abs(l === "y" ? v : S) : Uo(S * S + v * v)),
              w > x && (x = w),
              w < O && (O = w);
          i === "random" && aa(m),
            (m.max = x - O),
            (m.min = O),
            (m.v = h =
              (parseFloat(r.amount) ||
                parseFloat(r.each) *
                  (k > h
                    ? h - 1
                    : l
                    ? l === "y"
                      ? h / k
                      : k
                    : Math.max(k, h / k)) ||
                0) * (i === "edges" ? -1 : 1)),
            (m.b = h < 0 ? n - h : n),
            (m.u = $e(r.amount || r.each) || 0),
            (t = t && h < 0 ? ya(t) : t);
        }
        return (
          (h = (m[d] - m.min) / m.max || 0),
          Se(m.b + (t ? t(h) : h) * m.v) + m.u
        );
      }
    );
  },
  gs = function (e) {
    var r = Math.pow(10, ((e + "").split(".")[1] || "").length);
    return function (t) {
      var i = Se(Math.round(parseFloat(t) / e) * e * r);
      return (i - (i % 1)) / r + (or(t) ? 0 : $e(t));
    };
  },
  la = function (e, r) {
    var t = Ge(e),
      i,
      n;
    return (
      !t &&
        Kt(e) &&
        ((i = t = e.radius || Mt),
        e.values
          ? ((e = Dt(e.values)), (n = !or(e[0])) && (i *= i))
          : (e = gs(e.increment))),
      Cr(
        r,
        t
          ? _e(e)
            ? function (s) {
                return (n = e(s)), Math.abs(n - s) <= i ? n : s;
              }
            : function (s) {
                for (
                  var o = parseFloat(n ? s.x : s),
                    u = parseFloat(n ? s.y : 0),
                    l = Mt,
                    f = 0,
                    _ = e.length,
                    d,
                    c;
                  _--;

                )
                  n
                    ? ((d = e[_].x - o), (c = e[_].y - u), (d = d * d + c * c))
                    : (d = Math.abs(e[_] - o)),
                    d < l && ((l = d), (f = _));
                return (
                  (f = !i || l <= i ? e[f] : s),
                  n || f === s || or(s) ? f : f + $e(s)
                );
              }
          : gs(e)
      )
    );
  },
  fa = function (e, r, t, i) {
    return Cr(Ge(e) ? !r : t === !0 ? !!(t = 0) : !i, function () {
      return Ge(e)
        ? e[~~(Math.random() * e.length)]
        : (t = t || 1e-5) &&
            (i = t < 1 ? Math.pow(10, (t + "").length - 2) : 1) &&
            Math.floor(
              Math.round((e - t / 2 + Math.random() * (r - e + t * 0.99)) / t) *
                t *
                i
            ) / i;
    });
  },
  Mu = function () {
    for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
      r[t] = arguments[t];
    return function (i) {
      return r.reduce(function (n, s) {
        return s(n);
      }, i);
    };
  },
  Du = function (e, r) {
    return function (t) {
      return e(parseFloat(t)) + (r || $e(t));
    };
  },
  Eu = function (e, r, t) {
    return ha(e, r, 0, 1, t);
  },
  ca = function (e, r, t) {
    return Cr(t, function (i) {
      return e[~~r(i)];
    });
  },
  Ru = function a(e, r, t) {
    var i = r - e;
    return Ge(e)
      ? ca(e, a(0, e.length), r)
      : Cr(t, function (n) {
          return ((i + ((n - e) % i)) % i) + e;
        });
  },
  Au = function a(e, r, t) {
    var i = r - e,
      n = i * 2;
    return Ge(e)
      ? ca(e, a(0, e.length - 1), r)
      : Cr(t, function (s) {
          return (s = (n + ((s - e) % n)) % n || 0), e + (s > i ? n - s : s);
        });
  },
  Qi = function (e) {
    for (var r = 0, t = "", i, n, s, o; ~(i = e.indexOf("random(", r)); )
      (s = e.indexOf(")", i)),
        (o = e.charAt(i + 7) === "["),
        (n = e.substr(i + 7, s - i - 7).match(o ? Ho : ls)),
        (t +=
          e.substr(r, i - r) + fa(o ? n : +n[0], o ? 0 : +n[1], +n[2] || 1e-5)),
        (r = s + 1);
    return t + e.substr(r, e.length - r);
  },
  ha = function (e, r, t, i, n) {
    var s = r - e,
      o = i - t;
    return Cr(n, function (u) {
      return t + (((u - e) / s) * o || 0);
    });
  },
  zu = function a(e, r, t, i) {
    var n = isNaN(e + r)
      ? 0
      : function (c) {
          return (1 - c) * e + c * r;
        };
    if (!n) {
      var s = Re(e),
        o = {},
        u,
        l,
        f,
        _,
        d;
      if ((t === !0 && (i = 1) && (t = null), s))
        (e = { p: e }), (r = { p: r });
      else if (Ge(e) && !Ge(r)) {
        for (f = [], _ = e.length, d = _ - 2, l = 1; l < _; l++)
          f.push(a(e[l - 1], e[l]));
        _--,
          (n = function (p) {
            p *= _;
            var h = Math.min(d, ~~p);
            return f[h](p - h);
          }),
          (t = r);
      } else i || (e = pi(Ge(e) ? [] : {}, e));
      if (!f) {
        for (u in r) Xs.call(o, e, u, "get", r[u]);
        n = function (p) {
          return Ws(p, o) || (s ? e.p : e);
        };
      }
    }
    return Cr(t, n);
  },
  lo = function (e, r, t) {
    var i = e.labels,
      n = Mt,
      s,
      o,
      u;
    for (s in i)
      (o = i[s] - r),
        o < 0 == !!t && o && n > (o = Math.abs(o)) && ((u = s), (n = o));
    return u;
  },
  bt = function (e, r, t) {
    var i = e.vars,
      n = i[r],
      s = ae,
      o = e._ctx,
      u,
      l,
      f;
    if (n)
      return (
        (u = i[r + "Params"]),
        (l = i.callbackScope || e),
        t && xr.length && En(),
        o && (ae = o),
        (f = u ? n.apply(l, u) : n.call(l)),
        (ae = s),
        f
      );
  },
  Mi = function (e) {
    return (
      wr(e),
      e.scrollTrigger && e.scrollTrigger.kill(!!Ie),
      e.progress() < 1 && bt(e, "onInterrupt"),
      e
    );
  },
  oi,
  _a = [],
  da = function (e) {
    if (e)
      if (((e = (!e.name && e.default) || e), Fs() || e.headless)) {
        var r = e.name,
          t = _e(e),
          i =
            r && !t && e.init
              ? function () {
                  this._props = [];
                }
              : e,
          n = {
            init: Ki,
            render: Ws,
            add: Xs,
            kill: Qu,
            modifier: Ku,
            rawVars: 0,
          },
          s = {
            targetTest: 0,
            get: 0,
            getSetter: $s,
            aliases: {},
            register: 0,
          };
        if ((yi(), e !== i)) {
          if (mt[r]) return;
          St(i, St(Rn(e, n), s)),
            pi(i.prototype, pi(n, Rn(e, s))),
            (mt[(i.prop = r)] = i),
            e.targetTest && (Tn.push(i), (Ns[r] = 1)),
            (r =
              (r === "css" ? "CSS" : r.charAt(0).toUpperCase() + r.substr(1)) +
              "Plugin");
        }
        Qo(r, i), e.register && e.register(ct, i, lt);
      } else _a.push(e);
  },
  te = 255,
  Di = {
    aqua: [0, te, te],
    lime: [0, te, 0],
    silver: [192, 192, 192],
    black: [0, 0, 0],
    maroon: [128, 0, 0],
    teal: [0, 128, 128],
    blue: [0, 0, te],
    navy: [0, 0, 128],
    white: [te, te, te],
    olive: [128, 128, 0],
    yellow: [te, te, 0],
    orange: [te, 165, 0],
    gray: [128, 128, 128],
    purple: [128, 0, 128],
    green: [0, 128, 0],
    red: [te, 0, 0],
    pink: [te, 192, 203],
    cyan: [0, te, te],
    transparent: [te, te, te, 0],
  },
  Kn = function (e, r, t) {
    return (
      (e += e < 0 ? 1 : e > 1 ? -1 : 0),
      ((e * 6 < 1
        ? r + (t - r) * e * 6
        : e < 0.5
        ? t
        : e * 3 < 2
        ? r + (t - r) * (2 / 3 - e) * 6
        : r) *
        te +
        0.5) |
        0
    );
  },
  pa = function (e, r, t) {
    var i = e ? (or(e) ? [e >> 16, (e >> 8) & te, e & te] : 0) : Di.black,
      n,
      s,
      o,
      u,
      l,
      f,
      _,
      d,
      c,
      p;
    if (!i) {
      if ((e.substr(-1) === "," && (e = e.substr(0, e.length - 1)), Di[e]))
        i = Di[e];
      else if (e.charAt(0) === "#") {
        if (
          (e.length < 6 &&
            ((n = e.charAt(1)),
            (s = e.charAt(2)),
            (o = e.charAt(3)),
            (e =
              "#" +
              n +
              n +
              s +
              s +
              o +
              o +
              (e.length === 5 ? e.charAt(4) + e.charAt(4) : ""))),
          e.length === 9)
        )
          return (
            (i = parseInt(e.substr(1, 6), 16)),
            [i >> 16, (i >> 8) & te, i & te, parseInt(e.substr(7), 16) / 255]
          );
        (e = parseInt(e.substr(1), 16)), (i = [e >> 16, (e >> 8) & te, e & te]);
      } else if (e.substr(0, 3) === "hsl") {
        if (((i = p = e.match(ls)), !r))
          (u = (+i[0] % 360) / 360),
            (l = +i[1] / 100),
            (f = +i[2] / 100),
            (s = f <= 0.5 ? f * (l + 1) : f + l - f * l),
            (n = f * 2 - s),
            i.length > 3 && (i[3] *= 1),
            (i[0] = Kn(u + 1 / 3, n, s)),
            (i[1] = Kn(u, n, s)),
            (i[2] = Kn(u - 1 / 3, n, s));
        else if (~e.indexOf("="))
          return (i = e.match(Wo)), t && i.length < 4 && (i[3] = 1), i;
      } else i = e.match(ls) || Di.transparent;
      i = i.map(Number);
    }
    return (
      r &&
        !p &&
        ((n = i[0] / te),
        (s = i[1] / te),
        (o = i[2] / te),
        (_ = Math.max(n, s, o)),
        (d = Math.min(n, s, o)),
        (f = (_ + d) / 2),
        _ === d
          ? (u = l = 0)
          : ((c = _ - d),
            (l = f > 0.5 ? c / (2 - _ - d) : c / (_ + d)),
            (u =
              _ === n
                ? (s - o) / c + (s < o ? 6 : 0)
                : _ === s
                ? (o - n) / c + 2
                : (n - s) / c + 4),
            (u *= 60)),
        (i[0] = ~~(u + 0.5)),
        (i[1] = ~~(l * 100 + 0.5)),
        (i[2] = ~~(f * 100 + 0.5))),
      t && i.length < 4 && (i[3] = 1),
      i
    );
  },
  ga = function (e) {
    var r = [],
      t = [],
      i = -1;
    return (
      e.split(br).forEach(function (n) {
        var s = n.match(si) || [];
        r.push.apply(r, s), t.push((i += s.length + 1));
      }),
      (r.c = t),
      r
    );
  },
  fo = function (e, r, t) {
    var i = "",
      n = (e + i).match(br),
      s = r ? "hsla(" : "rgba(",
      o = 0,
      u,
      l,
      f,
      _;
    if (!n) return e;
    if (
      ((n = n.map(function (d) {
        return (
          (d = pa(d, r, 1)) &&
          s +
            (r ? d[0] + "," + d[1] + "%," + d[2] + "%," + d[3] : d.join(",")) +
            ")"
        );
      })),
      t && ((f = ga(e)), (u = t.c), u.join(i) !== f.c.join(i)))
    )
      for (l = e.replace(br, "1").split(si), _ = l.length - 1; o < _; o++)
        i +=
          l[o] +
          (~u.indexOf(o)
            ? n.shift() || s + "0,0,0,0)"
            : (f.length ? f : n.length ? n : t).shift());
    if (!l)
      for (l = e.split(br), _ = l.length - 1; o < _; o++) i += l[o] + n[o];
    return i + l[_];
  },
  br = (function () {
    var a =
        "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b",
      e;
    for (e in Di) a += "|" + e + "\\b";
    return new RegExp(a + ")", "gi");
  })(),
  Fu = /hsl[a]?\(/,
  ma = function (e) {
    var r = e.join(" "),
      t;
    if (((br.lastIndex = 0), br.test(r)))
      return (
        (t = Fu.test(r)),
        (e[1] = fo(e[1], t)),
        (e[0] = fo(e[0], t, ga(e[1]))),
        !0
      );
  },
  Zi,
  vt = (function () {
    var a = Date.now,
      e = 500,
      r = 33,
      t = a(),
      i = t,
      n = 1e3 / 240,
      s = n,
      o = [],
      u,
      l,
      f,
      _,
      d,
      c,
      p = function h(m) {
        var T = a() - i,
          b = m === !0,
          S,
          v,
          w,
          C;
        if (
          ((T > e || T < 0) && (t += T - r),
          (i += T),
          (w = i - t),
          (S = w - s),
          (S > 0 || b) &&
            ((C = ++_.frame),
            (d = w - _.time * 1e3),
            (_.time = w = w / 1e3),
            (s += S + (S >= n ? 4 : n - S)),
            (v = 1)),
          b || (u = l(h)),
          v)
        )
          for (c = 0; c < o.length; c++) o[c](w, d, C, m);
      };
    return (
      (_ = {
        time: 0,
        frame: 0,
        tick: function () {
          p(!0);
        },
        deltaRatio: function (m) {
          return d / (1e3 / (m || 60));
        },
        wake: function () {
          qo &&
            (!fs &&
              Fs() &&
              ((Vt = fs = window),
              (Ls = Vt.document || {}),
              (wt.gsap = ct),
              (Vt.gsapVersions || (Vt.gsapVersions = [])).push(ct.version),
              Ko(Dn || Vt.GreenSockGlobals || (!Vt.gsap && Vt) || {}),
              _a.forEach(da)),
            (f = typeof requestAnimationFrame < "u" && requestAnimationFrame),
            u && _.sleep(),
            (l =
              f ||
              function (m) {
                return setTimeout(m, (s - _.time * 1e3 + 1) | 0);
              }),
            (Zi = 1),
            p(2));
        },
        sleep: function () {
          (f ? cancelAnimationFrame : clearTimeout)(u), (Zi = 0), (l = Ki);
        },
        lagSmoothing: function (m, T) {
          (e = m || 1 / 0), (r = Math.min(T || 33, e));
        },
        fps: function (m) {
          (n = 1e3 / (m || 240)), (s = _.time * 1e3 + n);
        },
        add: function (m, T, b) {
          var S = T
            ? function (v, w, C, x) {
                m(v, w, C, x), _.remove(S);
              }
            : m;
          return _.remove(m), o[b ? "unshift" : "push"](S), yi(), S;
        },
        remove: function (m, T) {
          ~(T = o.indexOf(m)) && o.splice(T, 1) && c >= T && c--;
        },
        _listeners: o,
      }),
      _
    );
  })(),
  yi = function () {
    return !Zi && vt.wake();
  },
  q = {},
  Lu = /^[\d.\-M][\d.\-,\s]/,
  Iu = /["']/g,
  Nu = function (e) {
    for (
      var r = {},
        t = e.substr(1, e.length - 3).split(":"),
        i = t[0],
        n = 1,
        s = t.length,
        o,
        u,
        l;
      n < s;
      n++
    )
      (u = t[n]),
        (o = n !== s - 1 ? u.lastIndexOf(",") : u.length),
        (l = u.substr(0, o)),
        (r[i] = isNaN(l) ? l.replace(Iu, "").trim() : +l),
        (i = u.substr(o + 1).trim());
    return r;
  },
  Yu = function (e) {
    var r = e.indexOf("(") + 1,
      t = e.indexOf(")"),
      i = e.indexOf("(", r);
    return e.substring(r, ~i && i < t ? e.indexOf(")", t + 1) : t);
  },
  Bu = function (e) {
    var r = (e + "").split("("),
      t = q[r[0]];
    return t && r.length > 1 && t.config
      ? t.config.apply(
          null,
          ~e.indexOf("{") ? [Nu(r[1])] : Yu(e).split(",").map(ea)
        )
      : q._CE && Lu.test(e)
      ? q._CE("", e)
      : t;
  },
  ya = function (e) {
    return function (r) {
      return 1 - e(1 - r);
    };
  },
  va = function a(e, r) {
    for (var t = e._first, i; t; )
      t instanceof rt
        ? a(t, r)
        : t.vars.yoyoEase &&
          (!t._yoyo || !t._repeat) &&
          t._yoyo !== r &&
          (t.timeline
            ? a(t.timeline, r)
            : ((i = t._ease),
              (t._ease = t._yEase),
              (t._yEase = i),
              (t._yoyo = r))),
        (t = t._next);
  },
  Xr = function (e, r) {
    return (e && (_e(e) ? e : q[e] || Bu(e))) || r;
  },
  Qr = function (e, r, t, i) {
    t === void 0 &&
      (t = function (u) {
        return 1 - r(1 - u);
      }),
      i === void 0 &&
        (i = function (u) {
          return u < 0.5 ? r(u * 2) / 2 : 1 - r((1 - u) * 2) / 2;
        });
    var n = { easeIn: r, easeOut: t, easeInOut: i },
      s;
    return (
      ut(e, function (o) {
        (q[o] = wt[o] = n), (q[(s = o.toLowerCase())] = t);
        for (var u in n)
          q[
            s + (u === "easeIn" ? ".in" : u === "easeOut" ? ".out" : ".inOut")
          ] = q[o + "." + u] = n[u];
      }),
      n
    );
  },
  xa = function (e) {
    return function (r) {
      return r < 0.5 ? (1 - e(1 - r * 2)) / 2 : 0.5 + e((r - 0.5) * 2) / 2;
    };
  },
  Qn = function a(e, r, t) {
    var i = r >= 1 ? r : 1,
      n = (t || (e ? 0.3 : 0.45)) / (r < 1 ? r : 1),
      s = (n / us) * (Math.asin(1 / i) || 0),
      o = function (f) {
        return f === 1 ? 1 : i * Math.pow(2, -10 * f) * du((f - s) * n) + 1;
      },
      u =
        e === "out"
          ? o
          : e === "in"
          ? function (l) {
              return 1 - o(1 - l);
            }
          : xa(o);
    return (
      (n = us / n),
      (u.config = function (l, f) {
        return a(e, l, f);
      }),
      u
    );
  },
  Zn = function a(e, r) {
    r === void 0 && (r = 1.70158);
    var t = function (s) {
        return s ? --s * s * ((r + 1) * s + r) + 1 : 0;
      },
      i =
        e === "out"
          ? t
          : e === "in"
          ? function (n) {
              return 1 - t(1 - n);
            }
          : xa(t);
    return (
      (i.config = function (n) {
        return a(e, n);
      }),
      i
    );
  };
ut("Linear,Quad,Cubic,Quart,Quint,Strong", function (a, e) {
  var r = e < 5 ? e + 1 : e;
  Qr(
    a + ",Power" + (r - 1),
    e
      ? function (t) {
          return Math.pow(t, r);
        }
      : function (t) {
          return t;
        },
    function (t) {
      return 1 - Math.pow(1 - t, r);
    },
    function (t) {
      return t < 0.5
        ? Math.pow(t * 2, r) / 2
        : 1 - Math.pow((1 - t) * 2, r) / 2;
    }
  );
});
q.Linear.easeNone = q.none = q.Linear.easeIn;
Qr("Elastic", Qn("in"), Qn("out"), Qn());
(function (a, e) {
  var r = 1 / e,
    t = 2 * r,
    i = 2.5 * r,
    n = function (o) {
      return o < r
        ? a * o * o
        : o < t
        ? a * Math.pow(o - 1.5 / e, 2) + 0.75
        : o < i
        ? a * (o -= 2.25 / e) * o + 0.9375
        : a * Math.pow(o - 2.625 / e, 2) + 0.984375;
    };
  Qr(
    "Bounce",
    function (s) {
      return 1 - n(1 - s);
    },
    n
  );
})(7.5625, 2.75);
Qr("Expo", function (a) {
  return Math.pow(2, 10 * (a - 1)) * a + a * a * a * a * a * a * (1 - a);
});
Qr("Circ", function (a) {
  return -(Uo(1 - a * a) - 1);
});
Qr("Sine", function (a) {
  return a === 1 ? 1 : -_u(a * cu) + 1;
});
Qr("Back", Zn("in"), Zn("out"), Zn());
q.SteppedEase =
  q.steps =
  wt.SteppedEase =
    {
      config: function (e, r) {
        e === void 0 && (e = 1);
        var t = 1 / e,
          i = e + (r ? 0 : 1),
          n = r ? 1 : 0,
          s = 1 - re;
        return function (o) {
          return (((i * nn(0, s, o)) | 0) + n) * t;
        };
      },
    };
di.ease = q["quad.out"];
ut(
  "onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt",
  function (a) {
    return (Ys += a + "," + a + "Params,");
  }
);
var ba = function (e, r) {
    (this.id = hu++),
      (e._gsap = this),
      (this.target = e),
      (this.harness = r),
      (this.get = r ? r.get : Jo),
      (this.set = r ? r.getSetter : $s);
  },
  Ji = (function () {
    function a(r) {
      (this.vars = r),
        (this._delay = +r.delay || 0),
        (this._repeat = r.repeat === 1 / 0 ? -2 : r.repeat || 0) &&
          ((this._rDelay = r.repeatDelay || 0),
          (this._yoyo = !!r.yoyo || !!r.yoyoEase)),
        (this._ts = 1),
        mi(this, +r.duration, 1, 1),
        (this.data = r.data),
        ae && ((this._ctx = ae), ae.data.push(this)),
        Zi || vt.wake();
    }
    var e = a.prototype;
    return (
      (e.delay = function (t) {
        return t || t === 0
          ? (this.parent &&
              this.parent.smoothChildTiming &&
              this.startTime(this._start + t - this._delay),
            (this._delay = t),
            this)
          : this._delay;
      }),
      (e.duration = function (t) {
        return arguments.length
          ? this.totalDuration(
              this._repeat > 0 ? t + (t + this._rDelay) * this._repeat : t
            )
          : this.totalDuration() && this._dur;
      }),
      (e.totalDuration = function (t) {
        return arguments.length
          ? ((this._dirty = 0),
            mi(
              this,
              this._repeat < 0
                ? t
                : (t - this._repeat * this._rDelay) / (this._repeat + 1)
            ))
          : this._tDur;
      }),
      (e.totalTime = function (t, i) {
        if ((yi(), !arguments.length)) return this._tTime;
        var n = this._dp;
        if (n && n.smoothChildTiming && this._ts) {
          for ($n(this, t), !n._dp || n.parent || ia(n, this); n && n.parent; )
            n.parent._time !==
              n._start +
                (n._ts >= 0
                  ? n._tTime / n._ts
                  : (n.totalDuration() - n._tTime) / -n._ts) &&
              n.totalTime(n._tTime, !0),
              (n = n.parent);
          !this.parent &&
            this._dp.autoRemoveChildren &&
            ((this._ts > 0 && t < this._tDur) ||
              (this._ts < 0 && t > 0) ||
              (!this._tDur && !t)) &&
            $t(this._dp, this, this._start - this._delay);
        }
        return (
          (this._tTime !== t ||
            (!this._dur && !i) ||
            (this._initted && Math.abs(this._zTime) === re) ||
            (!t && !this._initted && (this.add || this._ptLookup))) &&
            (this._ts || (this._pTime = t), jo(this, t, i)),
          this
        );
      }),
      (e.time = function (t, i) {
        return arguments.length
          ? this.totalTime(
              Math.min(this.totalDuration(), t + ao(this)) %
                (this._dur + this._rDelay) || (t ? this._dur : 0),
              i
            )
          : this._time;
      }),
      (e.totalProgress = function (t, i) {
        return arguments.length
          ? this.totalTime(this.totalDuration() * t, i)
          : this.totalDuration()
          ? Math.min(1, this._tTime / this._tDur)
          : this.rawTime() >= 0 && this._initted
          ? 1
          : 0;
      }),
      (e.progress = function (t, i) {
        return arguments.length
          ? this.totalTime(
              this.duration() *
                (this._yoyo && !(this.iteration() & 1) ? 1 - t : t) +
                ao(this),
              i
            )
          : this.duration()
          ? Math.min(1, this._time / this._dur)
          : this.rawTime() > 0
          ? 1
          : 0;
      }),
      (e.iteration = function (t, i) {
        var n = this.duration() + this._rDelay;
        return arguments.length
          ? this.totalTime(this._time + (t - 1) * n, i)
          : this._repeat
          ? gi(this._tTime, n) + 1
          : 1;
      }),
      (e.timeScale = function (t, i) {
        if (!arguments.length) return this._rts === -re ? 0 : this._rts;
        if (this._rts === t) return this;
        var n =
          this.parent && this._ts ? An(this.parent._time, this) : this._tTime;
        return (
          (this._rts = +t || 0),
          (this._ts = this._ps || t === -re ? 0 : this._rts),
          this.totalTime(nn(-Math.abs(this._delay), this._tDur, n), i !== !1),
          Un(this),
          bu(this)
        );
      }),
      (e.paused = function (t) {
        return arguments.length
          ? (this._ps !== t &&
              ((this._ps = t),
              t
                ? ((this._pTime =
                    this._tTime || Math.max(-this._delay, this.rawTime())),
                  (this._ts = this._act = 0))
                : (yi(),
                  (this._ts = this._rts),
                  this.totalTime(
                    this.parent && !this.parent.smoothChildTiming
                      ? this.rawTime()
                      : this._tTime || this._pTime,
                    this.progress() === 1 &&
                      Math.abs(this._zTime) !== re &&
                      (this._tTime -= re)
                  ))),
            this)
          : this._ps;
      }),
      (e.startTime = function (t) {
        if (arguments.length) {
          this._start = t;
          var i = this.parent || this._dp;
          return (
            i && (i._sort || !this.parent) && $t(i, this, t - this._delay), this
          );
        }
        return this._start;
      }),
      (e.endTime = function (t) {
        return (
          this._start +
          (at(t) ? this.totalDuration() : this.duration()) /
            Math.abs(this._ts || 1)
        );
      }),
      (e.rawTime = function (t) {
        var i = this.parent || this._dp;
        return i
          ? t &&
            (!this._ts ||
              (this._repeat && this._time && this.totalProgress() < 1))
            ? this._tTime % (this._dur + this._rDelay)
            : this._ts
            ? An(i.rawTime(t), this)
            : this._tTime
          : this._tTime;
      }),
      (e.revert = function (t) {
        t === void 0 && (t = mu);
        var i = Ie;
        return (
          (Ie = t),
          (this._initted || this._startAt) &&
            (this.timeline && this.timeline.revert(t),
            this.totalTime(-0.01, t.suppressEvents)),
          this.data !== "nested" && t.kill !== !1 && this.kill(),
          (Ie = i),
          this
        );
      }),
      (e.globalTime = function (t) {
        for (var i = this, n = arguments.length ? t : i.rawTime(); i; )
          (n = i._start + n / (Math.abs(i._ts) || 1)), (i = i._dp);
        return !this.parent && this._sat ? this._sat.globalTime(t) : n;
      }),
      (e.repeat = function (t) {
        return arguments.length
          ? ((this._repeat = t === 1 / 0 ? -2 : t), uo(this))
          : this._repeat === -2
          ? 1 / 0
          : this._repeat;
      }),
      (e.repeatDelay = function (t) {
        if (arguments.length) {
          var i = this._time;
          return (this._rDelay = t), uo(this), i ? this.time(i) : this;
        }
        return this._rDelay;
      }),
      (e.yoyo = function (t) {
        return arguments.length ? ((this._yoyo = t), this) : this._yoyo;
      }),
      (e.seek = function (t, i) {
        return this.totalTime(Ct(this, t), at(i));
      }),
      (e.restart = function (t, i) {
        return (
          this.play().totalTime(t ? -this._delay : 0, at(i)),
          this._dur || (this._zTime = -re),
          this
        );
      }),
      (e.play = function (t, i) {
        return t != null && this.seek(t, i), this.reversed(!1).paused(!1);
      }),
      (e.reverse = function (t, i) {
        return (
          t != null && this.seek(t || this.totalDuration(), i),
          this.reversed(!0).paused(!1)
        );
      }),
      (e.pause = function (t, i) {
        return t != null && this.seek(t, i), this.paused(!0);
      }),
      (e.resume = function () {
        return this.paused(!1);
      }),
      (e.reversed = function (t) {
        return arguments.length
          ? (!!t !== this.reversed() &&
              this.timeScale(-this._rts || (t ? -re : 0)),
            this)
          : this._rts < 0;
      }),
      (e.invalidate = function () {
        return (this._initted = this._act = 0), (this._zTime = -re), this;
      }),
      (e.isActive = function () {
        var t = this.parent || this._dp,
          i = this._start,
          n;
        return !!(
          !t ||
          (this._ts &&
            this._initted &&
            t.isActive() &&
            (n = t.rawTime(!0)) >= i &&
            n < this.endTime(!0) - re)
        );
      }),
      (e.eventCallback = function (t, i, n) {
        var s = this.vars;
        return arguments.length > 1
          ? (i
              ? ((s[t] = i),
                n && (s[t + "Params"] = n),
                t === "onUpdate" && (this._onUpdate = i))
              : delete s[t],
            this)
          : s[t];
      }),
      (e.then = function (t) {
        var i = this;
        return new Promise(function (n) {
          var s = _e(t) ? t : ta,
            o = function () {
              var l = i.then;
              (i.then = null),
                _e(s) && (s = s(i)) && (s.then || s === i) && (i.then = l),
                n(s),
                (i.then = l);
            };
          (i._initted && i.totalProgress() === 1 && i._ts >= 0) ||
          (!i._tTime && i._ts < 0)
            ? o()
            : (i._prom = o);
        });
      }),
      (e.kill = function () {
        Mi(this);
      }),
      a
    );
  })();
St(Ji.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -re,
  _prom: 0,
  _ps: !1,
  _rts: 1,
});
var rt = (function (a) {
  Vo(e, a);
  function e(t, i) {
    var n;
    return (
      t === void 0 && (t = {}),
      (n = a.call(this, t) || this),
      (n.labels = {}),
      (n.smoothChildTiming = !!t.smoothChildTiming),
      (n.autoRemoveChildren = !!t.autoRemoveChildren),
      (n._sort = at(t.sortChildren)),
      le && $t(t.parent || le, tr(n), i),
      t.reversed && n.reverse(),
      t.paused && n.paused(!0),
      t.scrollTrigger && na(tr(n), t.scrollTrigger),
      n
    );
  }
  var r = e.prototype;
  return (
    (r.to = function (i, n, s) {
      return Ii(0, arguments, this), this;
    }),
    (r.from = function (i, n, s) {
      return Ii(1, arguments, this), this;
    }),
    (r.fromTo = function (i, n, s, o) {
      return Ii(2, arguments, this), this;
    }),
    (r.set = function (i, n, s) {
      return (
        (n.duration = 0),
        (n.parent = this),
        Li(n).repeatDelay || (n.repeat = 0),
        (n.immediateRender = !!n.immediateRender),
        new we(i, n, Ct(this, s), 1),
        this
      );
    }),
    (r.call = function (i, n, s) {
      return $t(this, we.delayedCall(0, i, n), s);
    }),
    (r.staggerTo = function (i, n, s, o, u, l, f) {
      return (
        (s.duration = n),
        (s.stagger = s.stagger || o),
        (s.onComplete = l),
        (s.onCompleteParams = f),
        (s.parent = this),
        new we(i, s, Ct(this, u)),
        this
      );
    }),
    (r.staggerFrom = function (i, n, s, o, u, l, f) {
      return (
        (s.runBackwards = 1),
        (Li(s).immediateRender = at(s.immediateRender)),
        this.staggerTo(i, n, s, o, u, l, f)
      );
    }),
    (r.staggerFromTo = function (i, n, s, o, u, l, f, _) {
      return (
        (o.startAt = s),
        (Li(o).immediateRender = at(o.immediateRender)),
        this.staggerTo(i, n, o, u, l, f, _)
      );
    }),
    (r.render = function (i, n, s) {
      var o = this._time,
        u = this._dirty ? this.totalDuration() : this._tDur,
        l = this._dur,
        f = i <= 0 ? 0 : Se(i),
        _ = this._zTime < 0 != i < 0 && (this._initted || !l),
        d,
        c,
        p,
        h,
        m,
        T,
        b,
        S,
        v,
        w,
        C,
        x;
      if (
        (this !== le && f > u && i >= 0 && (f = u), f !== this._tTime || s || _)
      ) {
        if (
          (o !== this._time &&
            l &&
            ((f += this._time - o), (i += this._time - o)),
          (d = f),
          (v = this._start),
          (S = this._ts),
          (T = !S),
          _ && (l || (o = this._zTime), (i || !n) && (this._zTime = i)),
          this._repeat)
        ) {
          if (
            ((C = this._yoyo),
            (m = l + this._rDelay),
            this._repeat < -1 && i < 0)
          )
            return this.totalTime(m * 100 + i, n, s);
          if (
            ((d = Se(f % m)),
            f === u
              ? ((h = this._repeat), (d = l))
              : ((w = Se(f / m)),
                (h = ~~w),
                h && h === w && ((d = l), h--),
                d > l && (d = l)),
            (w = gi(this._tTime, m)),
            !o &&
              this._tTime &&
              w !== h &&
              this._tTime - w * m - this._dur <= 0 &&
              (w = h),
            C && h & 1 && ((d = l - d), (x = 1)),
            h !== w && !this._lock)
          ) {
            var O = C && w & 1,
              k = O === (C && h & 1);
            if (
              (h < w && (O = !O),
              (o = O ? 0 : f % l ? l : f),
              (this._lock = 1),
              (this.render(o || (x ? 0 : Se(h * m)), n, !l)._lock = 0),
              (this._tTime = f),
              !n && this.parent && bt(this, "onRepeat"),
              this.vars.repeatRefresh && !x && (this.invalidate()._lock = 1),
              (o && o !== this._time) ||
                T !== !this._ts ||
                (this.vars.onRepeat && !this.parent && !this._act))
            )
              return this;
            if (
              ((l = this._dur),
              (u = this._tDur),
              k &&
                ((this._lock = 2),
                (o = O ? l : -1e-4),
                this.render(o, !0),
                this.vars.repeatRefresh && !x && this.invalidate()),
              (this._lock = 0),
              !this._ts && !T)
            )
              return this;
            va(this, x);
          }
        }
        if (
          (this._hasPause &&
            !this._forcing &&
            this._lock < 2 &&
            ((b = ku(this, Se(o), Se(d))), b && (f -= d - (d = b._start))),
          (this._tTime = f),
          (this._time = d),
          (this._act = !S),
          this._initted ||
            ((this._onUpdate = this.vars.onUpdate),
            (this._initted = 1),
            (this._zTime = i),
            (o = 0)),
          !o && d && !n && !h && (bt(this, "onStart"), this._tTime !== f))
        )
          return this;
        if (d >= o && i >= 0)
          for (c = this._first; c; ) {
            if (
              ((p = c._next), (c._act || d >= c._start) && c._ts && b !== c)
            ) {
              if (c.parent !== this) return this.render(i, n, s);
              if (
                (c.render(
                  c._ts > 0
                    ? (d - c._start) * c._ts
                    : (c._dirty ? c.totalDuration() : c._tDur) +
                        (d - c._start) * c._ts,
                  n,
                  s
                ),
                d !== this._time || (!this._ts && !T))
              ) {
                (b = 0), p && (f += this._zTime = -re);
                break;
              }
            }
            c = p;
          }
        else {
          c = this._last;
          for (var P = i < 0 ? i : d; c; ) {
            if (((p = c._prev), (c._act || P <= c._end) && c._ts && b !== c)) {
              if (c.parent !== this) return this.render(i, n, s);
              if (
                (c.render(
                  c._ts > 0
                    ? (P - c._start) * c._ts
                    : (c._dirty ? c.totalDuration() : c._tDur) +
                        (P - c._start) * c._ts,
                  n,
                  s || (Ie && (c._initted || c._startAt))
                ),
                d !== this._time || (!this._ts && !T))
              ) {
                (b = 0), p && (f += this._zTime = P ? -re : re);
                break;
              }
            }
            c = p;
          }
        }
        if (
          b &&
          !n &&
          (this.pause(),
          (b.render(d >= o ? 0 : -re)._zTime = d >= o ? 1 : -1),
          this._ts)
        )
          return (this._start = v), Un(this), this.render(i, n, s);
        this._onUpdate && !n && bt(this, "onUpdate", !0),
          ((f === u && this._tTime >= this.totalDuration()) || (!f && o)) &&
            (v === this._start || Math.abs(S) !== Math.abs(this._ts)) &&
            (this._lock ||
              ((i || !l) &&
                ((f === u && this._ts > 0) || (!f && this._ts < 0)) &&
                wr(this, 1),
              !n &&
                !(i < 0 && !o) &&
                (f || o || !u) &&
                (bt(
                  this,
                  f === u && i >= 0 ? "onComplete" : "onReverseComplete",
                  !0
                ),
                this._prom &&
                  !(f < u && this.timeScale() > 0) &&
                  this._prom())));
      }
      return this;
    }),
    (r.add = function (i, n) {
      var s = this;
      if ((or(n) || (n = Ct(this, n, i)), !(i instanceof Ji))) {
        if (Ge(i))
          return (
            i.forEach(function (o) {
              return s.add(o, n);
            }),
            this
          );
        if (Re(i)) return this.addLabel(i, n);
        if (_e(i)) i = we.delayedCall(0, i);
        else return this;
      }
      return this !== i ? $t(this, i, n) : this;
    }),
    (r.getChildren = function (i, n, s, o) {
      i === void 0 && (i = !0),
        n === void 0 && (n = !0),
        s === void 0 && (s = !0),
        o === void 0 && (o = -Mt);
      for (var u = [], l = this._first; l; )
        l._start >= o &&
          (l instanceof we
            ? n && u.push(l)
            : (s && u.push(l), i && u.push.apply(u, l.getChildren(!0, n, s)))),
          (l = l._next);
      return u;
    }),
    (r.getById = function (i) {
      for (var n = this.getChildren(1, 1, 1), s = n.length; s--; )
        if (n[s].vars.id === i) return n[s];
    }),
    (r.remove = function (i) {
      return Re(i)
        ? this.removeLabel(i)
        : _e(i)
        ? this.killTweensOf(i)
        : (i.parent === this && Vn(this, i),
          i === this._recent && (this._recent = this._last),
          Br(this));
    }),
    (r.totalTime = function (i, n) {
      return arguments.length
        ? ((this._forcing = 1),
          !this._dp &&
            this._ts &&
            (this._start = Se(
              vt.time -
                (this._ts > 0
                  ? i / this._ts
                  : (this.totalDuration() - i) / -this._ts)
            )),
          a.prototype.totalTime.call(this, i, n),
          (this._forcing = 0),
          this)
        : this._tTime;
    }),
    (r.addLabel = function (i, n) {
      return (this.labels[i] = Ct(this, n)), this;
    }),
    (r.removeLabel = function (i) {
      return delete this.labels[i], this;
    }),
    (r.addPause = function (i, n, s) {
      var o = we.delayedCall(0, n || Ki, s);
      return (
        (o.data = "isPause"), (this._hasPause = 1), $t(this, o, Ct(this, i))
      );
    }),
    (r.removePause = function (i) {
      var n = this._first;
      for (i = Ct(this, i); n; )
        n._start === i && n.data === "isPause" && wr(n), (n = n._next);
    }),
    (r.killTweensOf = function (i, n, s) {
      for (var o = this.getTweensOf(i, s), u = o.length; u--; )
        pr !== o[u] && o[u].kill(i, n);
      return this;
    }),
    (r.getTweensOf = function (i, n) {
      for (var s = [], o = Dt(i), u = this._first, l = or(n), f; u; )
        u instanceof we
          ? yu(u._targets, o) &&
            (l
              ? (!pr || (u._initted && u._ts)) &&
                u.globalTime(0) <= n &&
                u.globalTime(u.totalDuration()) > n
              : !n || u.isActive()) &&
            s.push(u)
          : (f = u.getTweensOf(o, n)).length && s.push.apply(s, f),
          (u = u._next);
      return s;
    }),
    (r.tweenTo = function (i, n) {
      n = n || {};
      var s = this,
        o = Ct(s, i),
        u = n,
        l = u.startAt,
        f = u.onStart,
        _ = u.onStartParams,
        d = u.immediateRender,
        c,
        p = we.to(
          s,
          St(
            {
              ease: n.ease || "none",
              lazy: !1,
              immediateRender: !1,
              time: o,
              overwrite: "auto",
              duration:
                n.duration ||
                Math.abs(
                  (o - (l && "time" in l ? l.time : s._time)) / s.timeScale()
                ) ||
                re,
              onStart: function () {
                if ((s.pause(), !c)) {
                  var m =
                    n.duration ||
                    Math.abs(
                      (o - (l && "time" in l ? l.time : s._time)) /
                        s.timeScale()
                    );
                  p._dur !== m && mi(p, m, 0, 1).render(p._time, !0, !0),
                    (c = 1);
                }
                f && f.apply(p, _ || []);
              },
            },
            n
          )
        );
      return d ? p.render(0) : p;
    }),
    (r.tweenFromTo = function (i, n, s) {
      return this.tweenTo(n, St({ startAt: { time: Ct(this, i) } }, s));
    }),
    (r.recent = function () {
      return this._recent;
    }),
    (r.nextLabel = function (i) {
      return i === void 0 && (i = this._time), lo(this, Ct(this, i));
    }),
    (r.previousLabel = function (i) {
      return i === void 0 && (i = this._time), lo(this, Ct(this, i), 1);
    }),
    (r.currentLabel = function (i) {
      return arguments.length
        ? this.seek(i, !0)
        : this.previousLabel(this._time + re);
    }),
    (r.shiftChildren = function (i, n, s) {
      s === void 0 && (s = 0);
      for (var o = this._first, u = this.labels, l; o; )
        o._start >= s && ((o._start += i), (o._end += i)), (o = o._next);
      if (n) for (l in u) u[l] >= s && (u[l] += i);
      return Br(this);
    }),
    (r.invalidate = function (i) {
      var n = this._first;
      for (this._lock = 0; n; ) n.invalidate(i), (n = n._next);
      return a.prototype.invalidate.call(this, i);
    }),
    (r.clear = function (i) {
      i === void 0 && (i = !0);
      for (var n = this._first, s; n; ) (s = n._next), this.remove(n), (n = s);
      return (
        this._dp && (this._time = this._tTime = this._pTime = 0),
        i && (this.labels = {}),
        Br(this)
      );
    }),
    (r.totalDuration = function (i) {
      var n = 0,
        s = this,
        o = s._last,
        u = Mt,
        l,
        f,
        _;
      if (arguments.length)
        return s.timeScale(
          (s._repeat < 0 ? s.duration() : s.totalDuration()) /
            (s.reversed() ? -i : i)
        );
      if (s._dirty) {
        for (_ = s.parent; o; )
          (l = o._prev),
            o._dirty && o.totalDuration(),
            (f = o._start),
            f > u && s._sort && o._ts && !s._lock
              ? ((s._lock = 1), ($t(s, o, f - o._delay, 1)._lock = 0))
              : (u = f),
            f < 0 &&
              o._ts &&
              ((n -= f),
              ((!_ && !s._dp) || (_ && _.smoothChildTiming)) &&
                ((s._start += f / s._ts), (s._time -= f), (s._tTime -= f)),
              s.shiftChildren(-f, !1, -1 / 0),
              (u = 0)),
            o._end > n && o._ts && (n = o._end),
            (o = l);
        mi(s, s === le && s._time > n ? s._time : n, 1, 1), (s._dirty = 0);
      }
      return s._tDur;
    }),
    (e.updateRoot = function (i) {
      if ((le._ts && (jo(le, An(i, le)), (Zo = vt.frame)), vt.frame >= so)) {
        so += Tt.autoSleep || 120;
        var n = le._first;
        if ((!n || !n._ts) && Tt.autoSleep && vt._listeners.length < 2) {
          for (; n && !n._ts; ) n = n._next;
          n || vt.sleep();
        }
      }
    }),
    e
  );
})(Ji);
St(rt.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
var Xu = function (e, r, t, i, n, s, o) {
    var u = new lt(this._pt, e, r, 0, 1, Pa, null, n),
      l = 0,
      f = 0,
      _,
      d,
      c,
      p,
      h,
      m,
      T,
      b;
    for (
      u.b = t,
        u.e = i,
        t += "",
        i += "",
        (T = ~i.indexOf("random(")) && (i = Qi(i)),
        s && ((b = [t, i]), s(b, e, r), (t = b[0]), (i = b[1])),
        d = t.match(Hn) || [];
      (_ = Hn.exec(i));

    )
      (p = _[0]),
        (h = i.substring(l, _.index)),
        c ? (c = (c + 1) % 5) : h.substr(-5) === "rgba(" && (c = 1),
        p !== d[f++] &&
          ((m = parseFloat(d[f - 1]) || 0),
          (u._pt = {
            _next: u._pt,
            p: h || f === 1 ? h : ",",
            s: m,
            c: p.charAt(1) === "=" ? ui(m, p) - m : parseFloat(p) - m,
            m: c && c < 4 ? Math.round : 0,
          }),
          (l = Hn.lastIndex));
    return (
      (u.c = l < i.length ? i.substring(l, i.length) : ""),
      (u.fp = o),
      (Go.test(i) || T) && (u.e = 0),
      (this._pt = u),
      u
    );
  },
  Xs = function (e, r, t, i, n, s, o, u, l, f) {
    _e(i) && (i = i(n || 0, e, s));
    var _ = e[r],
      d =
        t !== "get"
          ? t
          : _e(_)
          ? l
            ? e[
                r.indexOf("set") || !_e(e["get" + r.substr(3)])
                  ? r
                  : "get" + r.substr(3)
              ](l)
            : e[r]()
          : _,
      c = _e(_) ? (l ? Gu : ka) : Us,
      p;
    if (
      (Re(i) &&
        (~i.indexOf("random(") && (i = Qi(i)),
        i.charAt(1) === "=" &&
          ((p = ui(d, i) + ($e(d) || 0)), (p || p === 0) && (i = p))),
      !f || d !== i || ms)
    )
      return !isNaN(d * i) && i !== ""
        ? ((p = new lt(
            this._pt,
            e,
            r,
            +d || 0,
            i - (d || 0),
            typeof _ == "boolean" ? qu : Ca,
            0,
            c
          )),
          l && (p.fp = l),
          o && p.modifier(o, this, e),
          (this._pt = p))
        : (!_ && !(r in e) && Is(r, i),
          Xu.call(this, e, r, d, i, c, u || Tt.stringFilter, l));
  },
  Vu = function (e, r, t, i, n) {
    if (
      (_e(e) && (e = Ni(e, n, r, t, i)),
      !Kt(e) || (e.style && e.nodeType) || Ge(e) || $o(e))
    )
      return Re(e) ? Ni(e, n, r, t, i) : e;
    var s = {},
      o;
    for (o in e) s[o] = Ni(e[o], n, r, t, i);
    return s;
  },
  Ta = function (e, r, t, i, n, s) {
    var o, u, l, f;
    if (
      mt[e] &&
      (o = new mt[e]()).init(
        n,
        o.rawVars ? r[e] : Vu(r[e], i, n, s, t),
        t,
        i,
        s
      ) !== !1 &&
      ((t._pt = u = new lt(t._pt, n, e, 0, 1, o.render, o, 0, o.priority)),
      t !== oi)
    )
      for (l = t._ptLookup[t._targets.indexOf(n)], f = o._props.length; f--; )
        l[o._props[f]] = u;
    return o;
  },
  pr,
  ms,
  Vs = function a(e, r, t) {
    var i = e.vars,
      n = i.ease,
      s = i.startAt,
      o = i.immediateRender,
      u = i.lazy,
      l = i.onUpdate,
      f = i.runBackwards,
      _ = i.yoyoEase,
      d = i.keyframes,
      c = i.autoRevert,
      p = e._dur,
      h = e._startAt,
      m = e._targets,
      T = e.parent,
      b = T && T.data === "nested" ? T.vars.targets : m,
      S = e._overwrite === "auto" && !As,
      v = e.timeline,
      w,
      C,
      x,
      O,
      k,
      P,
      F,
      M,
      W,
      U,
      K,
      G,
      z;
    if (
      (v && (!d || !n) && (n = "none"),
      (e._ease = Xr(n, di.ease)),
      (e._yEase = _ ? ya(Xr(_ === !0 ? n : _, di.ease)) : 0),
      _ &&
        e._yoyo &&
        !e._repeat &&
        ((_ = e._yEase), (e._yEase = e._ease), (e._ease = _)),
      (e._from = !v && !!i.runBackwards),
      !v || (d && !i.stagger))
    ) {
      if (
        ((M = m[0] ? Yr(m[0]).harness : 0),
        (G = M && i[M.prop]),
        (w = Rn(i, Ns)),
        h &&
          (h._zTime < 0 && h.progress(1),
          r < 0 && f && o && !c ? h.render(-1, !0) : h.revert(f && p ? bn : gu),
          (h._lazy = 0)),
        s)
      ) {
        if (
          (wr(
            (e._startAt = we.set(
              m,
              St(
                {
                  data: "isStart",
                  overwrite: !1,
                  parent: T,
                  immediateRender: !0,
                  lazy: !h && at(u),
                  startAt: null,
                  delay: 0,
                  onUpdate:
                    l &&
                    function () {
                      return bt(e, "onUpdate");
                    },
                  stagger: 0,
                },
                s
              )
            ))
          ),
          (e._startAt._dp = 0),
          (e._startAt._sat = e),
          r < 0 && (Ie || (!o && !c)) && e._startAt.revert(bn),
          o && p && r <= 0 && t <= 0)
        ) {
          r && (e._zTime = r);
          return;
        }
      } else if (f && p && !h) {
        if (
          (r && (o = !1),
          (x = St(
            {
              overwrite: !1,
              data: "isFromStart",
              lazy: o && !h && at(u),
              immediateRender: o,
              stagger: 0,
              parent: T,
            },
            w
          )),
          G && (x[M.prop] = G),
          wr((e._startAt = we.set(m, x))),
          (e._startAt._dp = 0),
          (e._startAt._sat = e),
          r < 0 && (Ie ? e._startAt.revert(bn) : e._startAt.render(-1, !0)),
          (e._zTime = r),
          !o)
        )
          a(e._startAt, re, re);
        else if (!r) return;
      }
      for (
        e._pt = e._ptCache = 0, u = (p && at(u)) || (u && !p), C = 0;
        C < m.length;
        C++
      ) {
        if (
          ((k = m[C]),
          (F = k._gsap || Bs(m)[C]._gsap),
          (e._ptLookup[C] = U = {}),
          cs[F.id] && xr.length && En(),
          (K = b === m ? C : b.indexOf(k)),
          M &&
            (W = new M()).init(k, G || w, e, K, b) !== !1 &&
            ((e._pt = O =
              new lt(e._pt, k, W.name, 0, 1, W.render, W, 0, W.priority)),
            W._props.forEach(function (Z) {
              U[Z] = O;
            }),
            W.priority && (P = 1)),
          !M || G)
        )
          for (x in w)
            mt[x] && (W = Ta(x, w, e, K, k, b))
              ? W.priority && (P = 1)
              : (U[x] = O =
                  Xs.call(e, k, x, "get", w[x], K, b, 0, i.stringFilter));
        e._op && e._op[C] && e.kill(k, e._op[C]),
          S &&
            e._pt &&
            ((pr = e),
            le.killTweensOf(k, U, e.globalTime(r)),
            (z = !e.parent),
            (pr = 0)),
          e._pt && u && (cs[F.id] = 1);
      }
      P && Oa(e), e._onInit && e._onInit(e);
    }
    (e._onUpdate = l),
      (e._initted = (!e._op || e._pt) && !z),
      d && r <= 0 && v.render(Mt, !0, !0);
  },
  Uu = function (e, r, t, i, n, s, o, u) {
    var l = ((e._pt && e._ptCache) || (e._ptCache = {}))[r],
      f,
      _,
      d,
      c;
    if (!l)
      for (
        l = e._ptCache[r] = [], d = e._ptLookup, c = e._targets.length;
        c--;

      ) {
        if (((f = d[c][r]), f && f.d && f.d._pt))
          for (f = f.d._pt; f && f.p !== r && f.fp !== r; ) f = f._next;
        if (!f)
          return (
            (ms = 1),
            (e.vars[r] = "+=0"),
            Vs(e, o),
            (ms = 0),
            u ? qi(r + " not eligible for reset") : 1
          );
        l.push(f);
      }
    for (c = l.length; c--; )
      (_ = l[c]),
        (f = _._pt || _),
        (f.s = (i || i === 0) && !n ? i : f.s + (i || 0) + s * f.c),
        (f.c = t - f.s),
        _.e && (_.e = ye(t) + $e(_.e)),
        _.b && (_.b = f.s + $e(_.b));
  },
  $u = function (e, r) {
    var t = e[0] ? Yr(e[0]).harness : 0,
      i = t && t.aliases,
      n,
      s,
      o,
      u;
    if (!i) return r;
    n = pi({}, r);
    for (s in i)
      if (s in n) for (u = i[s].split(","), o = u.length; o--; ) n[u[o]] = n[s];
    return n;
  },
  Wu = function (e, r, t, i) {
    var n = r.ease || i || "power1.inOut",
      s,
      o;
    if (Ge(r))
      (o = t[e] || (t[e] = [])),
        r.forEach(function (u, l) {
          return o.push({ t: (l / (r.length - 1)) * 100, v: u, e: n });
        });
    else
      for (s in r)
        (o = t[s] || (t[s] = [])),
          s === "ease" || o.push({ t: parseFloat(e), v: r[s], e: n });
  },
  Ni = function (e, r, t, i, n) {
    return _e(e)
      ? e.call(r, t, i, n)
      : Re(e) && ~e.indexOf("random(")
      ? Qi(e)
      : e;
  },
  wa = Ys + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
  Sa = {};
ut(wa + ",id,stagger,delay,duration,paused,scrollTrigger", function (a) {
  return (Sa[a] = 1);
});
var we = (function (a) {
  Vo(e, a);
  function e(t, i, n, s) {
    var o;
    typeof i == "number" && ((n.duration = i), (i = n), (n = null)),
      (o = a.call(this, s ? i : Li(i)) || this);
    var u = o.vars,
      l = u.duration,
      f = u.delay,
      _ = u.immediateRender,
      d = u.stagger,
      c = u.overwrite,
      p = u.keyframes,
      h = u.defaults,
      m = u.scrollTrigger,
      T = u.yoyoEase,
      b = i.parent || le,
      S = (Ge(t) || $o(t) ? or(t[0]) : "length" in i) ? [t] : Dt(t),
      v,
      w,
      C,
      x,
      O,
      k,
      P,
      F;
    if (
      ((o._targets = S.length
        ? Bs(S)
        : qi(
            "GSAP target " + t + " not found. https://gsap.com",
            !Tt.nullTargetWarn
          ) || []),
      (o._ptLookup = []),
      (o._overwrite = c),
      p || d || un(l) || un(f))
    ) {
      if (
        ((i = o.vars),
        (v = o.timeline =
          new rt({
            data: "nested",
            defaults: h || {},
            targets: b && b.data === "nested" ? b.vars.targets : S,
          })),
        v.kill(),
        (v.parent = v._dp = tr(o)),
        (v._start = 0),
        d || un(l) || un(f))
      ) {
        if (((x = S.length), (P = d && ua(d)), Kt(d)))
          for (O in d) ~wa.indexOf(O) && (F || (F = {}), (F[O] = d[O]));
        for (w = 0; w < x; w++)
          (C = Rn(i, Sa)),
            (C.stagger = 0),
            T && (C.yoyoEase = T),
            F && pi(C, F),
            (k = S[w]),
            (C.duration = +Ni(l, tr(o), w, k, S)),
            (C.delay = (+Ni(f, tr(o), w, k, S) || 0) - o._delay),
            !d &&
              x === 1 &&
              C.delay &&
              ((o._delay = f = C.delay), (o._start += f), (C.delay = 0)),
            v.to(k, C, P ? P(w, k, S) : 0),
            (v._ease = q.none);
        v.duration() ? (l = f = 0) : (o.timeline = 0);
      } else if (p) {
        Li(St(v.vars.defaults, { ease: "none" })),
          (v._ease = Xr(p.ease || i.ease || "none"));
        var M = 0,
          W,
          U,
          K;
        if (Ge(p))
          p.forEach(function (G) {
            return v.to(S, G, ">");
          }),
            v.duration();
        else {
          C = {};
          for (O in p)
            O === "ease" || O === "easeEach" || Wu(O, p[O], C, p.easeEach);
          for (O in C)
            for (
              W = C[O].sort(function (G, z) {
                return G.t - z.t;
              }),
                M = 0,
                w = 0;
              w < W.length;
              w++
            )
              (U = W[w]),
                (K = {
                  ease: U.e,
                  duration: ((U.t - (w ? W[w - 1].t : 0)) / 100) * l,
                }),
                (K[O] = U.v),
                v.to(S, K, M),
                (M += K.duration);
          v.duration() < l && v.to({}, { duration: l - v.duration() });
        }
      }
      l || o.duration((l = v.duration()));
    } else o.timeline = 0;
    return (
      c === !0 && !As && ((pr = tr(o)), le.killTweensOf(S), (pr = 0)),
      $t(b, tr(o), n),
      i.reversed && o.reverse(),
      i.paused && o.paused(!0),
      (_ ||
        (!l &&
          !p &&
          o._start === Se(b._time) &&
          at(_) &&
          Tu(tr(o)) &&
          b.data !== "nested")) &&
        ((o._tTime = -re), o.render(Math.max(0, -f) || 0)),
      m && na(tr(o), m),
      o
    );
  }
  var r = e.prototype;
  return (
    (r.render = function (i, n, s) {
      var o = this._time,
        u = this._tDur,
        l = this._dur,
        f = i < 0,
        _ = i > u - re && !f ? u : i < re ? 0 : i,
        d,
        c,
        p,
        h,
        m,
        T,
        b,
        S,
        v;
      if (!l) Su(this, i, n, s);
      else if (
        _ !== this._tTime ||
        !i ||
        s ||
        (!this._initted && this._tTime) ||
        (this._startAt && this._zTime < 0 !== f) ||
        this._lazy
      ) {
        if (((d = _), (S = this.timeline), this._repeat)) {
          if (((h = l + this._rDelay), this._repeat < -1 && f))
            return this.totalTime(h * 100 + i, n, s);
          if (
            ((d = Se(_ % h)),
            _ === u
              ? ((p = this._repeat), (d = l))
              : ((m = Se(_ / h)),
                (p = ~~m),
                p && p === m ? ((d = l), p--) : d > l && (d = l)),
            (T = this._yoyo && p & 1),
            T && ((v = this._yEase), (d = l - d)),
            (m = gi(this._tTime, h)),
            d === o && !s && this._initted && p === m)
          )
            return (this._tTime = _), this;
          p !== m &&
            (S && this._yEase && va(S, T),
            this.vars.repeatRefresh &&
              !T &&
              !this._lock &&
              d !== h &&
              this._initted &&
              ((this._lock = s = 1),
              (this.render(Se(h * p), !0).invalidate()._lock = 0)));
        }
        if (!this._initted) {
          if (sa(this, f ? i : d, s, n, _)) return (this._tTime = 0), this;
          if (o !== this._time && !(s && this.vars.repeatRefresh && p !== m))
            return this;
          if (l !== this._dur) return this.render(i, n, s);
        }
        if (
          ((this._tTime = _),
          (this._time = d),
          !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
          (this.ratio = b = (v || this._ease)(d / l)),
          this._from && (this.ratio = b = 1 - b),
          d && !o && !n && !p && (bt(this, "onStart"), this._tTime !== _))
        )
          return this;
        for (c = this._pt; c; ) c.r(b, c.d), (c = c._next);
        (S && S.render(i < 0 ? i : S._dur * S._ease(d / this._dur), n, s)) ||
          (this._startAt && (this._zTime = i)),
          this._onUpdate &&
            !n &&
            (f && hs(this, i, n, s), bt(this, "onUpdate")),
          this._repeat &&
            p !== m &&
            this.vars.onRepeat &&
            !n &&
            this.parent &&
            bt(this, "onRepeat"),
          (_ === this._tDur || !_) &&
            this._tTime === _ &&
            (f && !this._onUpdate && hs(this, i, !0, !0),
            (i || !l) &&
              ((_ === this._tDur && this._ts > 0) || (!_ && this._ts < 0)) &&
              wr(this, 1),
            !n &&
              !(f && !o) &&
              (_ || o || T) &&
              (bt(this, _ === u ? "onComplete" : "onReverseComplete", !0),
              this._prom && !(_ < u && this.timeScale() > 0) && this._prom()));
      }
      return this;
    }),
    (r.targets = function () {
      return this._targets;
    }),
    (r.invalidate = function (i) {
      return (
        (!i || !this.vars.runBackwards) && (this._startAt = 0),
        (this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0),
        (this._ptLookup = []),
        this.timeline && this.timeline.invalidate(i),
        a.prototype.invalidate.call(this, i)
      );
    }),
    (r.resetTo = function (i, n, s, o, u) {
      Zi || vt.wake(), this._ts || this.play();
      var l = Math.min(this._dur, (this._dp._time - this._start) * this._ts),
        f;
      return (
        this._initted || Vs(this, l),
        (f = this._ease(l / this._dur)),
        Uu(this, i, n, s, o, f, l, u)
          ? this.resetTo(i, n, s, o, 1)
          : ($n(this, 0),
            this.parent ||
              ra(
                this._dp,
                this,
                "_first",
                "_last",
                this._dp._sort ? "_start" : 0
              ),
            this.render(0))
      );
    }),
    (r.kill = function (i, n) {
      if ((n === void 0 && (n = "all"), !i && (!n || n === "all")))
        return (
          (this._lazy = this._pt = 0),
          this.parent
            ? Mi(this)
            : this.scrollTrigger && this.scrollTrigger.kill(!!Ie),
          this
        );
      if (this.timeline) {
        var s = this.timeline.totalDuration();
        return (
          this.timeline.killTweensOf(i, n, pr && pr.vars.overwrite !== !0)
            ._first || Mi(this),
          this.parent &&
            s !== this.timeline.totalDuration() &&
            mi(this, (this._dur * this.timeline._tDur) / s, 0, 1),
          this
        );
      }
      var o = this._targets,
        u = i ? Dt(i) : o,
        l = this._ptLookup,
        f = this._pt,
        _,
        d,
        c,
        p,
        h,
        m,
        T;
      if ((!n || n === "all") && xu(o, u))
        return n === "all" && (this._pt = 0), Mi(this);
      for (
        _ = this._op = this._op || [],
          n !== "all" &&
            (Re(n) &&
              ((h = {}),
              ut(n, function (b) {
                return (h[b] = 1);
              }),
              (n = h)),
            (n = $u(o, n))),
          T = o.length;
        T--;

      )
        if (~u.indexOf(o[T])) {
          (d = l[T]),
            n === "all"
              ? ((_[T] = n), (p = d), (c = {}))
              : ((c = _[T] = _[T] || {}), (p = n));
          for (h in p)
            (m = d && d[h]),
              m &&
                ((!("kill" in m.d) || m.d.kill(h) === !0) && Vn(this, m, "_pt"),
                delete d[h]),
              c !== "all" && (c[h] = 1);
        }
      return this._initted && !this._pt && f && Mi(this), this;
    }),
    (e.to = function (i, n) {
      return new e(i, n, arguments[2]);
    }),
    (e.from = function (i, n) {
      return Ii(1, arguments);
    }),
    (e.delayedCall = function (i, n, s, o) {
      return new e(n, 0, {
        immediateRender: !1,
        lazy: !1,
        overwrite: !1,
        delay: i,
        onComplete: n,
        onReverseComplete: n,
        onCompleteParams: s,
        onReverseCompleteParams: s,
        callbackScope: o,
      });
    }),
    (e.fromTo = function (i, n, s) {
      return Ii(2, arguments);
    }),
    (e.set = function (i, n) {
      return (n.duration = 0), n.repeatDelay || (n.repeat = 0), new e(i, n);
    }),
    (e.killTweensOf = function (i, n, s) {
      return le.killTweensOf(i, n, s);
    }),
    e
  );
})(Ji);
St(we.prototype, { _targets: [], _lazy: 0, _startAt: 0, _op: 0, _onInit: 0 });
ut("staggerTo,staggerFrom,staggerFromTo", function (a) {
  we[a] = function () {
    var e = new rt(),
      r = ds.call(arguments, 0);
    return r.splice(a === "staggerFromTo" ? 5 : 4, 0, 0), e[a].apply(e, r);
  };
});
var Us = function (e, r, t) {
    return (e[r] = t);
  },
  ka = function (e, r, t) {
    return e[r](t);
  },
  Gu = function (e, r, t, i) {
    return e[r](i.fp, t);
  },
  Hu = function (e, r, t) {
    return e.setAttribute(r, t);
  },
  $s = function (e, r) {
    return _e(e[r]) ? ka : zs(e[r]) && e.setAttribute ? Hu : Us;
  },
  Ca = function (e, r) {
    return r.set(r.t, r.p, Math.round((r.s + r.c * e) * 1e6) / 1e6, r);
  },
  qu = function (e, r) {
    return r.set(r.t, r.p, !!(r.s + r.c * e), r);
  },
  Pa = function (e, r) {
    var t = r._pt,
      i = "";
    if (!e && r.b) i = r.b;
    else if (e === 1 && r.e) i = r.e;
    else {
      for (; t; )
        (i =
          t.p +
          (t.m ? t.m(t.s + t.c * e) : Math.round((t.s + t.c * e) * 1e4) / 1e4) +
          i),
          (t = t._next);
      i += r.c;
    }
    r.set(r.t, r.p, i, r);
  },
  Ws = function (e, r) {
    for (var t = r._pt; t; ) t.r(e, t.d), (t = t._next);
  },
  Ku = function (e, r, t, i) {
    for (var n = this._pt, s; n; )
      (s = n._next), n.p === i && n.modifier(e, r, t), (n = s);
  },
  Qu = function (e) {
    for (var r = this._pt, t, i; r; )
      (i = r._next),
        (r.p === e && !r.op) || r.op === e
          ? Vn(this, r, "_pt")
          : r.dep || (t = 1),
        (r = i);
    return !t;
  },
  Zu = function (e, r, t, i) {
    i.mSet(e, r, i.m.call(i.tween, t, i.mt), i);
  },
  Oa = function (e) {
    for (var r = e._pt, t, i, n, s; r; ) {
      for (t = r._next, i = n; i && i.pr > r.pr; ) i = i._next;
      (r._prev = i ? i._prev : s) ? (r._prev._next = r) : (n = r),
        (r._next = i) ? (i._prev = r) : (s = r),
        (r = t);
    }
    e._pt = n;
  },
  lt = (function () {
    function a(r, t, i, n, s, o, u, l, f) {
      (this.t = t),
        (this.s = n),
        (this.c = s),
        (this.p = i),
        (this.r = o || Ca),
        (this.d = u || this),
        (this.set = l || Us),
        (this.pr = f || 0),
        (this._next = r),
        r && (r._prev = this);
    }
    var e = a.prototype;
    return (
      (e.modifier = function (t, i, n) {
        (this.mSet = this.mSet || this.set),
          (this.set = Zu),
          (this.m = t),
          (this.mt = n),
          (this.tween = i);
      }),
      a
    );
  })();
ut(
  Ys +
    "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",
  function (a) {
    return (Ns[a] = 1);
  }
);
wt.TweenMax = wt.TweenLite = we;
wt.TimelineLite = wt.TimelineMax = rt;
le = new rt({
  sortChildren: !1,
  defaults: di,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0,
});
Tt.stringFilter = ma;
var Vr = [],
  wn = {},
  Ju = [],
  co = 0,
  ju = 0,
  Jn = function (e) {
    return (wn[e] || Ju).map(function (r) {
      return r();
    });
  },
  ys = function () {
    var e = Date.now(),
      r = [];
    e - co > 2 &&
      (Jn("matchMediaInit"),
      Vr.forEach(function (t) {
        var i = t.queries,
          n = t.conditions,
          s,
          o,
          u,
          l;
        for (o in i)
          (s = Vt.matchMedia(i[o]).matches),
            s && (u = 1),
            s !== n[o] && ((n[o] = s), (l = 1));
        l && (t.revert(), u && r.push(t));
      }),
      Jn("matchMediaRevert"),
      r.forEach(function (t) {
        return t.onMatch(t, function (i) {
          return t.add(null, i);
        });
      }),
      (co = e),
      Jn("matchMedia"));
  },
  Ma = (function () {
    function a(r, t) {
      (this.selector = t && ps(t)),
        (this.data = []),
        (this._r = []),
        (this.isReverted = !1),
        (this.id = ju++),
        r && this.add(r);
    }
    var e = a.prototype;
    return (
      (e.add = function (t, i, n) {
        _e(t) && ((n = i), (i = t), (t = _e));
        var s = this,
          o = function () {
            var l = ae,
              f = s.selector,
              _;
            return (
              l && l !== s && l.data.push(s),
              n && (s.selector = ps(n)),
              (ae = s),
              (_ = i.apply(s, arguments)),
              _e(_) && s._r.push(_),
              (ae = l),
              (s.selector = f),
              (s.isReverted = !1),
              _
            );
          };
        return (
          (s.last = o),
          t === _e
            ? o(s, function (u) {
                return s.add(null, u);
              })
            : t
            ? (s[t] = o)
            : o
        );
      }),
      (e.ignore = function (t) {
        var i = ae;
        (ae = null), t(this), (ae = i);
      }),
      (e.getTweens = function () {
        var t = [];
        return (
          this.data.forEach(function (i) {
            return i instanceof a
              ? t.push.apply(t, i.getTweens())
              : i instanceof we &&
                  !(i.parent && i.parent.data === "nested") &&
                  t.push(i);
          }),
          t
        );
      }),
      (e.clear = function () {
        this._r.length = this.data.length = 0;
      }),
      (e.kill = function (t, i) {
        var n = this;
        if (
          (t
            ? (function () {
                for (var o = n.getTweens(), u = n.data.length, l; u--; )
                  (l = n.data[u]),
                    l.data === "isFlip" &&
                      (l.revert(),
                      l.getChildren(!0, !0, !1).forEach(function (f) {
                        return o.splice(o.indexOf(f), 1);
                      }));
                for (
                  o
                    .map(function (f) {
                      return {
                        g:
                          f._dur ||
                          f._delay ||
                          (f._sat && !f._sat.vars.immediateRender)
                            ? f.globalTime(0)
                            : -1 / 0,
                        t: f,
                      };
                    })
                    .sort(function (f, _) {
                      return _.g - f.g || -1 / 0;
                    })
                    .forEach(function (f) {
                      return f.t.revert(t);
                    }),
                    u = n.data.length;
                  u--;

                )
                  (l = n.data[u]),
                    l instanceof rt
                      ? l.data !== "nested" &&
                        (l.scrollTrigger && l.scrollTrigger.revert(), l.kill())
                      : !(l instanceof we) && l.revert && l.revert(t);
                n._r.forEach(function (f) {
                  return f(t, n);
                }),
                  (n.isReverted = !0);
              })()
            : this.data.forEach(function (o) {
                return o.kill && o.kill();
              }),
          this.clear(),
          i)
        )
          for (var s = Vr.length; s--; )
            Vr[s].id === this.id && Vr.splice(s, 1);
      }),
      (e.revert = function (t) {
        this.kill(t || {});
      }),
      a
    );
  })(),
  el = (function () {
    function a(r) {
      (this.contexts = []), (this.scope = r), ae && ae.data.push(this);
    }
    var e = a.prototype;
    return (
      (e.add = function (t, i, n) {
        Kt(t) || (t = { matches: t });
        var s = new Ma(0, n || this.scope),
          o = (s.conditions = {}),
          u,
          l,
          f;
        ae && !s.selector && (s.selector = ae.selector),
          this.contexts.push(s),
          (i = s.add("onMatch", i)),
          (s.queries = t);
        for (l in t)
          l === "all"
            ? (f = 1)
            : ((u = Vt.matchMedia(t[l])),
              u &&
                (Vr.indexOf(s) < 0 && Vr.push(s),
                (o[l] = u.matches) && (f = 1),
                u.addListener
                  ? u.addListener(ys)
                  : u.addEventListener("change", ys)));
        return (
          f &&
            i(s, function (_) {
              return s.add(null, _);
            }),
          this
        );
      }),
      (e.revert = function (t) {
        this.kill(t || {});
      }),
      (e.kill = function (t) {
        this.contexts.forEach(function (i) {
          return i.kill(t, !0);
        });
      }),
      a
    );
  })(),
  zn = {
    registerPlugin: function () {
      for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
        r[t] = arguments[t];
      r.forEach(function (i) {
        return da(i);
      });
    },
    timeline: function (e) {
      return new rt(e);
    },
    getTweensOf: function (e, r) {
      return le.getTweensOf(e, r);
    },
    getProperty: function (e, r, t, i) {
      Re(e) && (e = Dt(e)[0]);
      var n = Yr(e || {}).get,
        s = t ? ta : ea;
      return (
        t === "native" && (t = ""),
        e &&
          (r
            ? s(((mt[r] && mt[r].get) || n)(e, r, t, i))
            : function (o, u, l) {
                return s(((mt[o] && mt[o].get) || n)(e, o, u, l));
              })
      );
    },
    quickSetter: function (e, r, t) {
      if (((e = Dt(e)), e.length > 1)) {
        var i = e.map(function (f) {
            return ct.quickSetter(f, r, t);
          }),
          n = i.length;
        return function (f) {
          for (var _ = n; _--; ) i[_](f);
        };
      }
      e = e[0] || {};
      var s = mt[r],
        o = Yr(e),
        u = (o.harness && (o.harness.aliases || {})[r]) || r,
        l = s
          ? function (f) {
              var _ = new s();
              (oi._pt = 0),
                _.init(e, t ? f + t : f, oi, 0, [e]),
                _.render(1, _),
                oi._pt && Ws(1, oi);
            }
          : o.set(e, u);
      return s
        ? l
        : function (f) {
            return l(e, u, t ? f + t : f, o, 1);
          };
    },
    quickTo: function (e, r, t) {
      var i,
        n = ct.to(
          e,
          St(
            ((i = {}), (i[r] = "+=0.1"), (i.paused = !0), (i.stagger = 0), i),
            t || {}
          )
        ),
        s = function (u, l, f) {
          return n.resetTo(r, u, l, f);
        };
      return (s.tween = n), s;
    },
    isTweening: function (e) {
      return le.getTweensOf(e, !0).length > 0;
    },
    defaults: function (e) {
      return e && e.ease && (e.ease = Xr(e.ease, di.ease)), oo(di, e || {});
    },
    config: function (e) {
      return oo(Tt, e || {});
    },
    registerEffect: function (e) {
      var r = e.name,
        t = e.effect,
        i = e.plugins,
        n = e.defaults,
        s = e.extendTimeline;
      (i || "").split(",").forEach(function (o) {
        return (
          o && !mt[o] && !wt[o] && qi(r + " effect requires " + o + " plugin.")
        );
      }),
        (qn[r] = function (o, u, l) {
          return t(Dt(o), St(u || {}, n), l);
        }),
        s &&
          (rt.prototype[r] = function (o, u, l) {
            return this.add(qn[r](o, Kt(u) ? u : (l = u) && {}, this), l);
          });
    },
    registerEase: function (e, r) {
      q[e] = Xr(r);
    },
    parseEase: function (e, r) {
      return arguments.length ? Xr(e, r) : q;
    },
    getById: function (e) {
      return le.getById(e);
    },
    exportRoot: function (e, r) {
      e === void 0 && (e = {});
      var t = new rt(e),
        i,
        n;
      for (
        t.smoothChildTiming = at(e.smoothChildTiming),
          le.remove(t),
          t._dp = 0,
          t._time = t._tTime = le._time,
          i = le._first;
        i;

      )
        (n = i._next),
          (r ||
            !(
              !i._dur &&
              i instanceof we &&
              i.vars.onComplete === i._targets[0]
            )) &&
            $t(t, i, i._start - i._delay),
          (i = n);
      return $t(le, t, 0), t;
    },
    context: function (e, r) {
      return e ? new Ma(e, r) : ae;
    },
    matchMedia: function (e) {
      return new el(e);
    },
    matchMediaRefresh: function () {
      return (
        Vr.forEach(function (e) {
          var r = e.conditions,
            t,
            i;
          for (i in r) r[i] && ((r[i] = !1), (t = 1));
          t && e.revert();
        }) || ys()
      );
    },
    addEventListener: function (e, r) {
      var t = wn[e] || (wn[e] = []);
      ~t.indexOf(r) || t.push(r);
    },
    removeEventListener: function (e, r) {
      var t = wn[e],
        i = t && t.indexOf(r);
      i >= 0 && t.splice(i, 1);
    },
    utils: {
      wrap: Ru,
      wrapYoyo: Au,
      distribute: ua,
      random: fa,
      snap: la,
      normalize: Eu,
      getUnit: $e,
      clamp: Pu,
      splitColor: pa,
      toArray: Dt,
      selector: ps,
      mapRange: ha,
      pipe: Mu,
      unitize: Du,
      interpolate: zu,
      shuffle: aa,
    },
    install: Ko,
    effects: qn,
    ticker: vt,
    updateRoot: rt.updateRoot,
    plugins: mt,
    globalTimeline: le,
    core: {
      PropTween: lt,
      globals: Qo,
      Tween: we,
      Timeline: rt,
      Animation: Ji,
      getCache: Yr,
      _removeLinkedListItem: Vn,
      reverting: function () {
        return Ie;
      },
      context: function (e) {
        return e && ae && (ae.data.push(e), (e._ctx = ae)), ae;
      },
      suppressOverwrites: function (e) {
        return (As = e);
      },
    },
  };
ut("to,from,fromTo,delayedCall,set,killTweensOf", function (a) {
  return (zn[a] = we[a]);
});
vt.add(rt.updateRoot);
oi = zn.to({}, { duration: 0 });
var tl = function (e, r) {
    for (var t = e._pt; t && t.p !== r && t.op !== r && t.fp !== r; )
      t = t._next;
    return t;
  },
  rl = function (e, r) {
    var t = e._targets,
      i,
      n,
      s;
    for (i in r)
      for (n = t.length; n--; )
        (s = e._ptLookup[n][i]),
          s &&
            (s = s.d) &&
            (s._pt && (s = tl(s, i)),
            s && s.modifier && s.modifier(r[i], e, t[n], i));
  },
  jn = function (e, r) {
    return {
      name: e,
      rawVars: 1,
      init: function (i, n, s) {
        s._onInit = function (o) {
          var u, l;
          if (
            (Re(n) &&
              ((u = {}),
              ut(n, function (f) {
                return (u[f] = 1);
              }),
              (n = u)),
            r)
          ) {
            u = {};
            for (l in n) u[l] = r(n[l]);
            n = u;
          }
          rl(o, n);
        };
      },
    };
  },
  ct =
    zn.registerPlugin(
      {
        name: "attr",
        init: function (e, r, t, i, n) {
          var s, o, u;
          this.tween = t;
          for (s in r)
            (u = e.getAttribute(s) || ""),
              (o = this.add(
                e,
                "setAttribute",
                (u || 0) + "",
                r[s],
                i,
                n,
                0,
                0,
                s
              )),
              (o.op = s),
              (o.b = u),
              this._props.push(s);
        },
        render: function (e, r) {
          for (var t = r._pt; t; )
            Ie ? t.set(t.t, t.p, t.b, t) : t.r(e, t.d), (t = t._next);
        },
      },
      {
        name: "endArray",
        init: function (e, r) {
          for (var t = r.length; t--; )
            this.add(e, t, e[t] || 0, r[t], 0, 0, 0, 0, 0, 1);
        },
      },
      jn("roundProps", gs),
      jn("modifiers"),
      jn("snap", la)
    ) || zn;
we.version = rt.version = ct.version = "3.12.7";
qo = 1;
Fs() && yi();
q.Power0;
q.Power1;
q.Power2;
q.Power3;
q.Power4;
q.Linear;
q.Quad;
q.Cubic;
q.Quart;
q.Quint;
q.Strong;
q.Elastic;
q.Back;
q.SteppedEase;
q.Bounce;
q.Sine;
q.Expo;
q.Circ;
/*!
 * CSSPlugin 3.12.7
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */ var ho,
  gr,
  li,
  Gs,
  Ir,
  _o,
  Hs,
  il = function () {
    return typeof window < "u";
  },
  ar = {},
  zr = 180 / Math.PI,
  fi = Math.PI / 180,
  ei = Math.atan2,
  po = 1e8,
  qs = /([A-Z])/g,
  nl = /(left|right|width|margin|padding|x)/i,
  sl = /[\s,\(]\S/,
  Wt = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity",
  },
  vs = function (e, r) {
    return r.set(r.t, r.p, Math.round((r.s + r.c * e) * 1e4) / 1e4 + r.u, r);
  },
  ol = function (e, r) {
    return r.set(
      r.t,
      r.p,
      e === 1 ? r.e : Math.round((r.s + r.c * e) * 1e4) / 1e4 + r.u,
      r
    );
  },
  al = function (e, r) {
    return r.set(
      r.t,
      r.p,
      e ? Math.round((r.s + r.c * e) * 1e4) / 1e4 + r.u : r.b,
      r
    );
  },
  ul = function (e, r) {
    var t = r.s + r.c * e;
    r.set(r.t, r.p, ~~(t + (t < 0 ? -0.5 : 0.5)) + r.u, r);
  },
  Da = function (e, r) {
    return r.set(r.t, r.p, e ? r.e : r.b, r);
  },
  Ea = function (e, r) {
    return r.set(r.t, r.p, e !== 1 ? r.b : r.e, r);
  },
  ll = function (e, r, t) {
    return (e.style[r] = t);
  },
  fl = function (e, r, t) {
    return e.style.setProperty(r, t);
  },
  cl = function (e, r, t) {
    return (e._gsap[r] = t);
  },
  hl = function (e, r, t) {
    return (e._gsap.scaleX = e._gsap.scaleY = t);
  },
  _l = function (e, r, t, i, n) {
    var s = e._gsap;
    (s.scaleX = s.scaleY = t), s.renderTransform(n, s);
  },
  dl = function (e, r, t, i, n) {
    var s = e._gsap;
    (s[r] = t), s.renderTransform(n, s);
  },
  fe = "transform",
  ft = fe + "Origin",
  pl = function a(e, r) {
    var t = this,
      i = this.target,
      n = i.style,
      s = i._gsap;
    if (e in ar && n) {
      if (((this.tfm = this.tfm || {}), e !== "transform"))
        (e = Wt[e] || e),
          ~e.indexOf(",")
            ? e.split(",").forEach(function (o) {
                return (t.tfm[o] = rr(i, o));
              })
            : (this.tfm[e] = s.x ? s[e] : rr(i, e)),
          e === ft && (this.tfm.zOrigin = s.zOrigin);
      else
        return Wt.transform.split(",").forEach(function (o) {
          return a.call(t, o, r);
        });
      if (this.props.indexOf(fe) >= 0) return;
      s.svg &&
        ((this.svgo = i.getAttribute("data-svg-origin")),
        this.props.push(ft, r, "")),
        (e = fe);
    }
    (n || r) && this.props.push(e, r, n[e]);
  },
  Ra = function (e) {
    e.translate &&
      (e.removeProperty("translate"),
      e.removeProperty("scale"),
      e.removeProperty("rotate"));
  },
  gl = function () {
    var e = this.props,
      r = this.target,
      t = r.style,
      i = r._gsap,
      n,
      s;
    for (n = 0; n < e.length; n += 3)
      e[n + 1]
        ? e[n + 1] === 2
          ? r[e[n]](e[n + 2])
          : (r[e[n]] = e[n + 2])
        : e[n + 2]
        ? (t[e[n]] = e[n + 2])
        : t.removeProperty(
            e[n].substr(0, 2) === "--"
              ? e[n]
              : e[n].replace(qs, "-$1").toLowerCase()
          );
    if (this.tfm) {
      for (s in this.tfm) i[s] = this.tfm[s];
      i.svg &&
        (i.renderTransform(),
        r.setAttribute("data-svg-origin", this.svgo || "")),
        (n = Hs()),
        (!n || !n.isStart) &&
          !t[fe] &&
          (Ra(t),
          i.zOrigin &&
            t[ft] &&
            ((t[ft] += " " + i.zOrigin + "px"),
            (i.zOrigin = 0),
            i.renderTransform()),
          (i.uncache = 1));
    }
  },
  Aa = function (e, r) {
    var t = { target: e, props: [], revert: gl, save: pl };
    return (
      e._gsap || ct.core.getCache(e),
      r &&
        e.style &&
        e.nodeType &&
        r.split(",").forEach(function (i) {
          return t.save(i);
        }),
      t
    );
  },
  za,
  xs = function (e, r) {
    var t = gr.createElementNS
      ? gr.createElementNS(
          (r || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"),
          e
        )
      : gr.createElement(e);
    return t && t.style ? t : gr.createElement(e);
  },
  Ht = function a(e, r, t) {
    var i = getComputedStyle(e);
    return (
      i[r] ||
      i.getPropertyValue(r.replace(qs, "-$1").toLowerCase()) ||
      i.getPropertyValue(r) ||
      (!t && a(e, vi(r) || r, 1)) ||
      ""
    );
  },
  go = "O,Moz,ms,Ms,Webkit".split(","),
  vi = function (e, r, t) {
    var i = r || Ir,
      n = i.style,
      s = 5;
    if (e in n && !t) return e;
    for (
      e = e.charAt(0).toUpperCase() + e.substr(1);
      s-- && !(go[s] + e in n);

    );
    return s < 0 ? null : (s === 3 ? "ms" : s >= 0 ? go[s] : "") + e;
  },
  bs = function () {
    il() &&
      window.document &&
      ((ho = window),
      (gr = ho.document),
      (li = gr.documentElement),
      (Ir = xs("div") || { style: {} }),
      xs("div"),
      (fe = vi(fe)),
      (ft = fe + "Origin"),
      (Ir.style.cssText =
        "border-width:0;line-height:0;position:absolute;padding:0"),
      (za = !!vi("perspective")),
      (Hs = ct.core.reverting),
      (Gs = 1));
  },
  mo = function (e) {
    var r = e.ownerSVGElement,
      t = xs(
        "svg",
        (r && r.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"
      ),
      i = e.cloneNode(!0),
      n;
    (i.style.display = "block"), t.appendChild(i), li.appendChild(t);
    try {
      n = i.getBBox();
    } catch {}
    return t.removeChild(i), li.removeChild(t), n;
  },
  yo = function (e, r) {
    for (var t = r.length; t--; )
      if (e.hasAttribute(r[t])) return e.getAttribute(r[t]);
  },
  Fa = function (e) {
    var r, t;
    try {
      r = e.getBBox();
    } catch {
      (r = mo(e)), (t = 1);
    }
    return (
      (r && (r.width || r.height)) || t || (r = mo(e)),
      r && !r.width && !r.x && !r.y
        ? {
            x: +yo(e, ["x", "cx", "x1"]) || 0,
            y: +yo(e, ["y", "cy", "y1"]) || 0,
            width: 0,
            height: 0,
          }
        : r
    );
  },
  La = function (e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && Fa(e));
  },
  Gr = function (e, r) {
    if (r) {
      var t = e.style,
        i;
      r in ar && r !== ft && (r = fe),
        t.removeProperty
          ? ((i = r.substr(0, 2)),
            (i === "ms" || r.substr(0, 6) === "webkit") && (r = "-" + r),
            t.removeProperty(
              i === "--" ? r : r.replace(qs, "-$1").toLowerCase()
            ))
          : t.removeAttribute(r);
    }
  },
  mr = function (e, r, t, i, n, s) {
    var o = new lt(e._pt, r, t, 0, 1, s ? Ea : Da);
    return (e._pt = o), (o.b = i), (o.e = n), e._props.push(t), o;
  },
  vo = { deg: 1, rad: 1, turn: 1 },
  ml = { grid: 1, flex: 1 },
  Sr = function a(e, r, t, i) {
    var n = parseFloat(t) || 0,
      s = (t + "").trim().substr((n + "").length) || "px",
      o = Ir.style,
      u = nl.test(r),
      l = e.tagName.toLowerCase() === "svg",
      f = (l ? "client" : "offset") + (u ? "Width" : "Height"),
      _ = 100,
      d = i === "px",
      c = i === "%",
      p,
      h,
      m,
      T;
    if (i === s || !n || vo[i] || vo[s]) return n;
    if (
      (s !== "px" && !d && (n = a(e, r, t, "px")),
      (T = e.getCTM && La(e)),
      (c || s === "%") && (ar[r] || ~r.indexOf("adius")))
    )
      return (
        (p = T ? e.getBBox()[u ? "width" : "height"] : e[f]),
        ye(c ? (n / p) * _ : (n / 100) * p)
      );
    if (
      ((o[u ? "width" : "height"] = _ + (d ? s : i)),
      (h =
        (i !== "rem" && ~r.indexOf("adius")) ||
        (i === "em" && e.appendChild && !l)
          ? e
          : e.parentNode),
      T && (h = (e.ownerSVGElement || {}).parentNode),
      (!h || h === gr || !h.appendChild) && (h = gr.body),
      (m = h._gsap),
      m && c && m.width && u && m.time === vt.time && !m.uncache)
    )
      return ye((n / m.width) * _);
    if (c && (r === "height" || r === "width")) {
      var b = e.style[r];
      (e.style[r] = _ + i), (p = e[f]), b ? (e.style[r] = b) : Gr(e, r);
    } else
      (c || s === "%") &&
        !ml[Ht(h, "display")] &&
        (o.position = Ht(e, "position")),
        h === e && (o.position = "static"),
        h.appendChild(Ir),
        (p = Ir[f]),
        h.removeChild(Ir),
        (o.position = "absolute");
    return (
      u && c && ((m = Yr(h)), (m.time = vt.time), (m.width = h[f])),
      ye(d ? (p * n) / _ : p && n ? (_ / p) * n : 0)
    );
  },
  rr = function (e, r, t, i) {
    var n;
    return (
      Gs || bs(),
      r in Wt &&
        r !== "transform" &&
        ((r = Wt[r]), ~r.indexOf(",") && (r = r.split(",")[0])),
      ar[r] && r !== "transform"
        ? ((n = en(e, i)),
          (n =
            r !== "transformOrigin"
              ? n[r]
              : n.svg
              ? n.origin
              : Ln(Ht(e, ft)) + " " + n.zOrigin + "px"))
        : ((n = e.style[r]),
          (!n || n === "auto" || i || ~(n + "").indexOf("calc(")) &&
            (n =
              (Fn[r] && Fn[r](e, r, t)) ||
              Ht(e, r) ||
              Jo(e, r) ||
              (r === "opacity" ? 1 : 0))),
      t && !~(n + "").trim().indexOf(" ") ? Sr(e, r, n, t) + t : n
    );
  },
  yl = function (e, r, t, i) {
    if (!t || t === "none") {
      var n = vi(r, e, 1),
        s = n && Ht(e, n, 1);
      s && s !== t
        ? ((r = n), (t = s))
        : r === "borderColor" && (t = Ht(e, "borderTopColor"));
    }
    var o = new lt(this._pt, e.style, r, 0, 1, Pa),
      u = 0,
      l = 0,
      f,
      _,
      d,
      c,
      p,
      h,
      m,
      T,
      b,
      S,
      v,
      w;
    if (
      ((o.b = t),
      (o.e = i),
      (t += ""),
      (i += ""),
      i === "auto" &&
        ((h = e.style[r]),
        (e.style[r] = i),
        (i = Ht(e, r) || i),
        h ? (e.style[r] = h) : Gr(e, r)),
      (f = [t, i]),
      ma(f),
      (t = f[0]),
      (i = f[1]),
      (d = t.match(si) || []),
      (w = i.match(si) || []),
      w.length)
    ) {
      for (; (_ = si.exec(i)); )
        (m = _[0]),
          (b = i.substring(u, _.index)),
          p
            ? (p = (p + 1) % 5)
            : (b.substr(-5) === "rgba(" || b.substr(-5) === "hsla(") && (p = 1),
          m !== (h = d[l++] || "") &&
            ((c = parseFloat(h) || 0),
            (v = h.substr((c + "").length)),
            m.charAt(1) === "=" && (m = ui(c, m) + v),
            (T = parseFloat(m)),
            (S = m.substr((T + "").length)),
            (u = si.lastIndex - S.length),
            S ||
              ((S = S || Tt.units[r] || v),
              u === i.length && ((i += S), (o.e += S))),
            v !== S && (c = Sr(e, r, h, S) || 0),
            (o._pt = {
              _next: o._pt,
              p: b || l === 1 ? b : ",",
              s: c,
              c: T - c,
              m: (p && p < 4) || r === "zIndex" ? Math.round : 0,
            }));
      o.c = u < i.length ? i.substring(u, i.length) : "";
    } else o.r = r === "display" && i === "none" ? Ea : Da;
    return Go.test(i) && (o.e = 0), (this._pt = o), o;
  },
  xo = { top: "0%", bottom: "100%", left: "0%", right: "100%", center: "50%" },
  vl = function (e) {
    var r = e.split(" "),
      t = r[0],
      i = r[1] || "50%";
    return (
      (t === "top" || t === "bottom" || i === "left" || i === "right") &&
        ((e = t), (t = i), (i = e)),
      (r[0] = xo[t] || t),
      (r[1] = xo[i] || i),
      r.join(" ")
    );
  },
  xl = function (e, r) {
    if (r.tween && r.tween._time === r.tween._dur) {
      var t = r.t,
        i = t.style,
        n = r.u,
        s = t._gsap,
        o,
        u,
        l;
      if (n === "all" || n === !0) (i.cssText = ""), (u = 1);
      else
        for (n = n.split(","), l = n.length; --l > -1; )
          (o = n[l]),
            ar[o] && ((u = 1), (o = o === "transformOrigin" ? ft : fe)),
            Gr(t, o);
      u &&
        (Gr(t, fe),
        s &&
          (s.svg && t.removeAttribute("transform"),
          (i.scale = i.rotate = i.translate = "none"),
          en(t, 1),
          (s.uncache = 1),
          Ra(i)));
    }
  },
  Fn = {
    clearProps: function (e, r, t, i, n) {
      if (n.data !== "isFromStart") {
        var s = (e._pt = new lt(e._pt, r, t, 0, 0, xl));
        return (s.u = i), (s.pr = -10), (s.tween = n), e._props.push(t), 1;
      }
    },
  },
  ji = [1, 0, 0, 1, 0, 0],
  Ia = {},
  Na = function (e) {
    return e === "matrix(1, 0, 0, 1, 0, 0)" || e === "none" || !e;
  },
  bo = function (e) {
    var r = Ht(e, fe);
    return Na(r) ? ji : r.substr(7).match(Wo).map(ye);
  },
  Ks = function (e, r) {
    var t = e._gsap || Yr(e),
      i = e.style,
      n = bo(e),
      s,
      o,
      u,
      l;
    return t.svg && e.getAttribute("transform")
      ? ((u = e.transform.baseVal.consolidate().matrix),
        (n = [u.a, u.b, u.c, u.d, u.e, u.f]),
        n.join(",") === "1,0,0,1,0,0" ? ji : n)
      : (n === ji &&
          !e.offsetParent &&
          e !== li &&
          !t.svg &&
          ((u = i.display),
          (i.display = "block"),
          (s = e.parentNode),
          (!s || (!e.offsetParent && !e.getBoundingClientRect().width)) &&
            ((l = 1), (o = e.nextElementSibling), li.appendChild(e)),
          (n = bo(e)),
          u ? (i.display = u) : Gr(e, "display"),
          l &&
            (o
              ? s.insertBefore(e, o)
              : s
              ? s.appendChild(e)
              : li.removeChild(e))),
        r && n.length > 6 ? [n[0], n[1], n[4], n[5], n[12], n[13]] : n);
  },
  Ts = function (e, r, t, i, n, s) {
    var o = e._gsap,
      u = n || Ks(e, !0),
      l = o.xOrigin || 0,
      f = o.yOrigin || 0,
      _ = o.xOffset || 0,
      d = o.yOffset || 0,
      c = u[0],
      p = u[1],
      h = u[2],
      m = u[3],
      T = u[4],
      b = u[5],
      S = r.split(" "),
      v = parseFloat(S[0]) || 0,
      w = parseFloat(S[1]) || 0,
      C,
      x,
      O,
      k;
    t
      ? u !== ji &&
        (x = c * m - p * h) &&
        ((O = v * (m / x) + w * (-h / x) + (h * b - m * T) / x),
        (k = v * (-p / x) + w * (c / x) - (c * b - p * T) / x),
        (v = O),
        (w = k))
      : ((C = Fa(e)),
        (v = C.x + (~S[0].indexOf("%") ? (v / 100) * C.width : v)),
        (w = C.y + (~(S[1] || S[0]).indexOf("%") ? (w / 100) * C.height : w))),
      i || (i !== !1 && o.smooth)
        ? ((T = v - l),
          (b = w - f),
          (o.xOffset = _ + (T * c + b * h) - T),
          (o.yOffset = d + (T * p + b * m) - b))
        : (o.xOffset = o.yOffset = 0),
      (o.xOrigin = v),
      (o.yOrigin = w),
      (o.smooth = !!i),
      (o.origin = r),
      (o.originIsAbsolute = !!t),
      (e.style[ft] = "0px 0px"),
      s &&
        (mr(s, o, "xOrigin", l, v),
        mr(s, o, "yOrigin", f, w),
        mr(s, o, "xOffset", _, o.xOffset),
        mr(s, o, "yOffset", d, o.yOffset)),
      e.setAttribute("data-svg-origin", v + " " + w);
  },
  en = function (e, r) {
    var t = e._gsap || new ba(e);
    if ("x" in t && !r && !t.uncache) return t;
    var i = e.style,
      n = t.scaleX < 0,
      s = "px",
      o = "deg",
      u = getComputedStyle(e),
      l = Ht(e, ft) || "0",
      f,
      _,
      d,
      c,
      p,
      h,
      m,
      T,
      b,
      S,
      v,
      w,
      C,
      x,
      O,
      k,
      P,
      F,
      M,
      W,
      U,
      K,
      G,
      z,
      Z,
      ne,
      g,
      se,
      He,
      Rt,
      ce,
      Ae;
    return (
      (f = _ = d = h = m = T = b = S = v = 0),
      (c = p = 1),
      (t.svg = !!(e.getCTM && La(e))),
      u.translate &&
        ((u.translate !== "none" ||
          u.scale !== "none" ||
          u.rotate !== "none") &&
          (i[fe] =
            (u.translate !== "none"
              ? "translate3d(" +
                (u.translate + " 0 0").split(" ").slice(0, 3).join(", ") +
                ") "
              : "") +
            (u.rotate !== "none" ? "rotate(" + u.rotate + ") " : "") +
            (u.scale !== "none"
              ? "scale(" + u.scale.split(" ").join(",") + ") "
              : "") +
            (u[fe] !== "none" ? u[fe] : "")),
        (i.scale = i.rotate = i.translate = "none")),
      (x = Ks(e, t.svg)),
      t.svg &&
        (t.uncache
          ? ((Z = e.getBBox()),
            (l = t.xOrigin - Z.x + "px " + (t.yOrigin - Z.y) + "px"),
            (z = ""))
          : (z = !r && e.getAttribute("data-svg-origin")),
        Ts(e, z || l, !!z || t.originIsAbsolute, t.smooth !== !1, x)),
      (w = t.xOrigin || 0),
      (C = t.yOrigin || 0),
      x !== ji &&
        ((F = x[0]),
        (M = x[1]),
        (W = x[2]),
        (U = x[3]),
        (f = K = x[4]),
        (_ = G = x[5]),
        x.length === 6
          ? ((c = Math.sqrt(F * F + M * M)),
            (p = Math.sqrt(U * U + W * W)),
            (h = F || M ? ei(M, F) * zr : 0),
            (b = W || U ? ei(W, U) * zr + h : 0),
            b && (p *= Math.abs(Math.cos(b * fi))),
            t.svg && ((f -= w - (w * F + C * W)), (_ -= C - (w * M + C * U))))
          : ((Ae = x[6]),
            (Rt = x[7]),
            (g = x[8]),
            (se = x[9]),
            (He = x[10]),
            (ce = x[11]),
            (f = x[12]),
            (_ = x[13]),
            (d = x[14]),
            (O = ei(Ae, He)),
            (m = O * zr),
            O &&
              ((k = Math.cos(-O)),
              (P = Math.sin(-O)),
              (z = K * k + g * P),
              (Z = G * k + se * P),
              (ne = Ae * k + He * P),
              (g = K * -P + g * k),
              (se = G * -P + se * k),
              (He = Ae * -P + He * k),
              (ce = Rt * -P + ce * k),
              (K = z),
              (G = Z),
              (Ae = ne)),
            (O = ei(-W, He)),
            (T = O * zr),
            O &&
              ((k = Math.cos(-O)),
              (P = Math.sin(-O)),
              (z = F * k - g * P),
              (Z = M * k - se * P),
              (ne = W * k - He * P),
              (ce = U * P + ce * k),
              (F = z),
              (M = Z),
              (W = ne)),
            (O = ei(M, F)),
            (h = O * zr),
            O &&
              ((k = Math.cos(O)),
              (P = Math.sin(O)),
              (z = F * k + M * P),
              (Z = K * k + G * P),
              (M = M * k - F * P),
              (G = G * k - K * P),
              (F = z),
              (K = Z)),
            m &&
              Math.abs(m) + Math.abs(h) > 359.9 &&
              ((m = h = 0), (T = 180 - T)),
            (c = ye(Math.sqrt(F * F + M * M + W * W))),
            (p = ye(Math.sqrt(G * G + Ae * Ae))),
            (O = ei(K, G)),
            (b = Math.abs(O) > 2e-4 ? O * zr : 0),
            (v = ce ? 1 / (ce < 0 ? -ce : ce) : 0)),
        t.svg &&
          ((z = e.getAttribute("transform")),
          (t.forceCSS = e.setAttribute("transform", "") || !Na(Ht(e, fe))),
          z && e.setAttribute("transform", z))),
      Math.abs(b) > 90 &&
        Math.abs(b) < 270 &&
        (n
          ? ((c *= -1), (b += h <= 0 ? 180 : -180), (h += h <= 0 ? 180 : -180))
          : ((p *= -1), (b += b <= 0 ? 180 : -180))),
      (r = r || t.uncache),
      (t.x =
        f -
        ((t.xPercent =
          f &&
          ((!r && t.xPercent) ||
            (Math.round(e.offsetWidth / 2) === Math.round(-f) ? -50 : 0)))
          ? (e.offsetWidth * t.xPercent) / 100
          : 0) +
        s),
      (t.y =
        _ -
        ((t.yPercent =
          _ &&
          ((!r && t.yPercent) ||
            (Math.round(e.offsetHeight / 2) === Math.round(-_) ? -50 : 0)))
          ? (e.offsetHeight * t.yPercent) / 100
          : 0) +
        s),
      (t.z = d + s),
      (t.scaleX = ye(c)),
      (t.scaleY = ye(p)),
      (t.rotation = ye(h) + o),
      (t.rotationX = ye(m) + o),
      (t.rotationY = ye(T) + o),
      (t.skewX = b + o),
      (t.skewY = S + o),
      (t.transformPerspective = v + s),
      (t.zOrigin = parseFloat(l.split(" ")[2]) || (!r && t.zOrigin) || 0) &&
        (i[ft] = Ln(l)),
      (t.xOffset = t.yOffset = 0),
      (t.force3D = Tt.force3D),
      (t.renderTransform = t.svg ? Tl : za ? Ya : bl),
      (t.uncache = 0),
      t
    );
  },
  Ln = function (e) {
    return (e = e.split(" "))[0] + " " + e[1];
  },
  es = function (e, r, t) {
    var i = $e(r);
    return ye(parseFloat(r) + parseFloat(Sr(e, "x", t + "px", i))) + i;
  },
  bl = function (e, r) {
    (r.z = "0px"),
      (r.rotationY = r.rotationX = "0deg"),
      (r.force3D = 0),
      Ya(e, r);
  },
  Rr = "0deg",
  Ci = "0px",
  Ar = ") ",
  Ya = function (e, r) {
    var t = r || this,
      i = t.xPercent,
      n = t.yPercent,
      s = t.x,
      o = t.y,
      u = t.z,
      l = t.rotation,
      f = t.rotationY,
      _ = t.rotationX,
      d = t.skewX,
      c = t.skewY,
      p = t.scaleX,
      h = t.scaleY,
      m = t.transformPerspective,
      T = t.force3D,
      b = t.target,
      S = t.zOrigin,
      v = "",
      w = (T === "auto" && e && e !== 1) || T === !0;
    if (S && (_ !== Rr || f !== Rr)) {
      var C = parseFloat(f) * fi,
        x = Math.sin(C),
        O = Math.cos(C),
        k;
      (C = parseFloat(_) * fi),
        (k = Math.cos(C)),
        (s = es(b, s, x * k * -S)),
        (o = es(b, o, -Math.sin(C) * -S)),
        (u = es(b, u, O * k * -S + S));
    }
    m !== Ci && (v += "perspective(" + m + Ar),
      (i || n) && (v += "translate(" + i + "%, " + n + "%) "),
      (w || s !== Ci || o !== Ci || u !== Ci) &&
        (v +=
          u !== Ci || w
            ? "translate3d(" + s + ", " + o + ", " + u + ") "
            : "translate(" + s + ", " + o + Ar),
      l !== Rr && (v += "rotate(" + l + Ar),
      f !== Rr && (v += "rotateY(" + f + Ar),
      _ !== Rr && (v += "rotateX(" + _ + Ar),
      (d !== Rr || c !== Rr) && (v += "skew(" + d + ", " + c + Ar),
      (p !== 1 || h !== 1) && (v += "scale(" + p + ", " + h + Ar),
      (b.style[fe] = v || "translate(0, 0)");
  },
  Tl = function (e, r) {
    var t = r || this,
      i = t.xPercent,
      n = t.yPercent,
      s = t.x,
      o = t.y,
      u = t.rotation,
      l = t.skewX,
      f = t.skewY,
      _ = t.scaleX,
      d = t.scaleY,
      c = t.target,
      p = t.xOrigin,
      h = t.yOrigin,
      m = t.xOffset,
      T = t.yOffset,
      b = t.forceCSS,
      S = parseFloat(s),
      v = parseFloat(o),
      w,
      C,
      x,
      O,
      k;
    (u = parseFloat(u)),
      (l = parseFloat(l)),
      (f = parseFloat(f)),
      f && ((f = parseFloat(f)), (l += f), (u += f)),
      u || l
        ? ((u *= fi),
          (l *= fi),
          (w = Math.cos(u) * _),
          (C = Math.sin(u) * _),
          (x = Math.sin(u - l) * -d),
          (O = Math.cos(u - l) * d),
          l &&
            ((f *= fi),
            (k = Math.tan(l - f)),
            (k = Math.sqrt(1 + k * k)),
            (x *= k),
            (O *= k),
            f &&
              ((k = Math.tan(f)),
              (k = Math.sqrt(1 + k * k)),
              (w *= k),
              (C *= k))),
          (w = ye(w)),
          (C = ye(C)),
          (x = ye(x)),
          (O = ye(O)))
        : ((w = _), (O = d), (C = x = 0)),
      ((S && !~(s + "").indexOf("px")) || (v && !~(o + "").indexOf("px"))) &&
        ((S = Sr(c, "x", s, "px")), (v = Sr(c, "y", o, "px"))),
      (p || h || m || T) &&
        ((S = ye(S + p - (p * w + h * x) + m)),
        (v = ye(v + h - (p * C + h * O) + T))),
      (i || n) &&
        ((k = c.getBBox()),
        (S = ye(S + (i / 100) * k.width)),
        (v = ye(v + (n / 100) * k.height))),
      (k =
        "matrix(" + w + "," + C + "," + x + "," + O + "," + S + "," + v + ")"),
      c.setAttribute("transform", k),
      b && (c.style[fe] = k);
  },
  wl = function (e, r, t, i, n) {
    var s = 360,
      o = Re(n),
      u = parseFloat(n) * (o && ~n.indexOf("rad") ? zr : 1),
      l = u - i,
      f = i + l + "deg",
      _,
      d;
    return (
      o &&
        ((_ = n.split("_")[1]),
        _ === "short" && ((l %= s), l !== l % (s / 2) && (l += l < 0 ? s : -s)),
        _ === "cw" && l < 0
          ? (l = ((l + s * po) % s) - ~~(l / s) * s)
          : _ === "ccw" && l > 0 && (l = ((l - s * po) % s) - ~~(l / s) * s)),
      (e._pt = d = new lt(e._pt, r, t, i, l, ol)),
      (d.e = f),
      (d.u = "deg"),
      e._props.push(t),
      d
    );
  },
  To = function (e, r) {
    for (var t in r) e[t] = r[t];
    return e;
  },
  Sl = function (e, r, t) {
    var i = To({}, t._gsap),
      n = "perspective,force3D,transformOrigin,svgOrigin",
      s = t.style,
      o,
      u,
      l,
      f,
      _,
      d,
      c,
      p;
    i.svg
      ? ((l = t.getAttribute("transform")),
        t.setAttribute("transform", ""),
        (s[fe] = r),
        (o = en(t, 1)),
        Gr(t, fe),
        t.setAttribute("transform", l))
      : ((l = getComputedStyle(t)[fe]),
        (s[fe] = r),
        (o = en(t, 1)),
        (s[fe] = l));
    for (u in ar)
      (l = i[u]),
        (f = o[u]),
        l !== f &&
          n.indexOf(u) < 0 &&
          ((c = $e(l)),
          (p = $e(f)),
          (_ = c !== p ? Sr(t, u, l, p) : parseFloat(l)),
          (d = parseFloat(f)),
          (e._pt = new lt(e._pt, o, u, _, d - _, vs)),
          (e._pt.u = p || 0),
          e._props.push(u));
    To(o, i);
  };
ut("padding,margin,Width,Radius", function (a, e) {
  var r = "Top",
    t = "Right",
    i = "Bottom",
    n = "Left",
    s = (e < 3 ? [r, t, i, n] : [r + n, r + t, i + t, i + n]).map(function (o) {
      return e < 2 ? a + o : "border" + o + a;
    });
  Fn[e > 1 ? "border" + a : a] = function (o, u, l, f, _) {
    var d, c;
    if (arguments.length < 4)
      return (
        (d = s.map(function (p) {
          return rr(o, p, l);
        })),
        (c = d.join(" ")),
        c.split(d[0]).length === 5 ? d[0] : c
      );
    (d = (f + "").split(" ")),
      (c = {}),
      s.forEach(function (p, h) {
        return (c[p] = d[h] = d[h] || d[((h - 1) / 2) | 0]);
      }),
      o.init(u, c, _);
  };
});
var Ba = {
  name: "css",
  register: bs,
  targetTest: function (e) {
    return e.style && e.nodeType;
  },
  init: function (e, r, t, i, n) {
    var s = this._props,
      o = e.style,
      u = t.vars.startAt,
      l,
      f,
      _,
      d,
      c,
      p,
      h,
      m,
      T,
      b,
      S,
      v,
      w,
      C,
      x,
      O;
    Gs || bs(),
      (this.styles = this.styles || Aa(e)),
      (O = this.styles.props),
      (this.tween = t);
    for (h in r)
      if (h !== "autoRound" && ((f = r[h]), !(mt[h] && Ta(h, r, t, i, e, n)))) {
        if (
          ((c = typeof f),
          (p = Fn[h]),
          c === "function" && ((f = f.call(t, i, e, n)), (c = typeof f)),
          c === "string" && ~f.indexOf("random(") && (f = Qi(f)),
          p)
        )
          p(this, e, h, f, t) && (x = 1);
        else if (h.substr(0, 2) === "--")
          (l = (getComputedStyle(e).getPropertyValue(h) + "").trim()),
            (f += ""),
            (br.lastIndex = 0),
            br.test(l) || ((m = $e(l)), (T = $e(f))),
            T ? m !== T && (l = Sr(e, h, l, T) + T) : m && (f += m),
            this.add(o, "setProperty", l, f, i, n, 0, 0, h),
            s.push(h),
            O.push(h, 0, o[h]);
        else if (c !== "undefined") {
          if (
            (u && h in u
              ? ((l = typeof u[h] == "function" ? u[h].call(t, i, e, n) : u[h]),
                Re(l) && ~l.indexOf("random(") && (l = Qi(l)),
                $e(l + "") ||
                  l === "auto" ||
                  (l += Tt.units[h] || $e(rr(e, h)) || ""),
                (l + "").charAt(1) === "=" && (l = rr(e, h)))
              : (l = rr(e, h)),
            (d = parseFloat(l)),
            (b = c === "string" && f.charAt(1) === "=" && f.substr(0, 2)),
            b && (f = f.substr(2)),
            (_ = parseFloat(f)),
            h in Wt &&
              (h === "autoAlpha" &&
                (d === 1 && rr(e, "visibility") === "hidden" && _ && (d = 0),
                O.push("visibility", 0, o.visibility),
                mr(
                  this,
                  o,
                  "visibility",
                  d ? "inherit" : "hidden",
                  _ ? "inherit" : "hidden",
                  !_
                )),
              h !== "scale" &&
                h !== "transform" &&
                ((h = Wt[h]), ~h.indexOf(",") && (h = h.split(",")[0]))),
            (S = h in ar),
            S)
          ) {
            if (
              (this.styles.save(h),
              v ||
                ((w = e._gsap),
                (w.renderTransform && !r.parseTransform) ||
                  en(e, r.parseTransform),
                (C = r.smoothOrigin !== !1 && w.smooth),
                (v = this._pt =
                  new lt(this._pt, o, fe, 0, 1, w.renderTransform, w, 0, -1)),
                (v.dep = 1)),
              h === "scale")
            )
              (this._pt = new lt(
                this._pt,
                w,
                "scaleY",
                w.scaleY,
                (b ? ui(w.scaleY, b + _) : _) - w.scaleY || 0,
                vs
              )),
                (this._pt.u = 0),
                s.push("scaleY", h),
                (h += "X");
            else if (h === "transformOrigin") {
              O.push(ft, 0, o[ft]),
                (f = vl(f)),
                w.svg
                  ? Ts(e, f, 0, C, 0, this)
                  : ((T = parseFloat(f.split(" ")[2]) || 0),
                    T !== w.zOrigin && mr(this, w, "zOrigin", w.zOrigin, T),
                    mr(this, o, h, Ln(l), Ln(f)));
              continue;
            } else if (h === "svgOrigin") {
              Ts(e, f, 1, C, 0, this);
              continue;
            } else if (h in Ia) {
              wl(this, w, h, d, b ? ui(d, b + f) : f);
              continue;
            } else if (h === "smoothOrigin") {
              mr(this, w, "smooth", w.smooth, f);
              continue;
            } else if (h === "force3D") {
              w[h] = f;
              continue;
            } else if (h === "transform") {
              Sl(this, f, e);
              continue;
            }
          } else h in o || (h = vi(h) || h);
          if (S || ((_ || _ === 0) && (d || d === 0) && !sl.test(f) && h in o))
            (m = (l + "").substr((d + "").length)),
              _ || (_ = 0),
              (T = $e(f) || (h in Tt.units ? Tt.units[h] : m)),
              m !== T && (d = Sr(e, h, l, T)),
              (this._pt = new lt(
                this._pt,
                S ? w : o,
                h,
                d,
                (b ? ui(d, b + _) : _) - d,
                !S && (T === "px" || h === "zIndex") && r.autoRound !== !1
                  ? ul
                  : vs
              )),
              (this._pt.u = T || 0),
              m !== T && T !== "%" && ((this._pt.b = l), (this._pt.r = al));
          else if (h in o) yl.call(this, e, h, l, b ? b + f : f);
          else if (h in e) this.add(e, h, l || e[h], b ? b + f : f, i, n);
          else if (h !== "parseTransform") {
            Is(h, f);
            continue;
          }
          S ||
            (h in o
              ? O.push(h, 0, o[h])
              : typeof e[h] == "function"
              ? O.push(h, 2, e[h]())
              : O.push(h, 1, l || e[h])),
            s.push(h);
        }
      }
    x && Oa(this);
  },
  render: function (e, r) {
    if (r.tween._time || !Hs())
      for (var t = r._pt; t; ) t.r(e, t.d), (t = t._next);
    else r.styles.revert();
  },
  get: rr,
  aliases: Wt,
  getSetter: function (e, r, t) {
    var i = Wt[r];
    return (
      i && i.indexOf(",") < 0 && (r = i),
      r in ar && r !== ft && (e._gsap.x || rr(e, "x"))
        ? t && _o === t
          ? r === "scale"
            ? hl
            : cl
          : (_o = t || {}) && (r === "scale" ? _l : dl)
        : e.style && !zs(e.style[r])
        ? ll
        : ~r.indexOf("-")
        ? fl
        : $s(e, r)
    );
  },
  core: { _removeProperty: Gr, _getMatrix: Ks },
};
ct.utils.checkPrefix = vi;
ct.core.getStyleSaver = Aa;
(function (a, e, r, t) {
  var i = ut(a + "," + e + "," + r, function (n) {
    ar[n] = 1;
  });
  ut(e, function (n) {
    (Tt.units[n] = "deg"), (Ia[n] = 1);
  }),
    (Wt[i[13]] = a + "," + e),
    ut(t, function (n) {
      var s = n.split(":");
      Wt[s[1]] = i[s[0]];
    });
})(
  "x,y,z,scale,scaleX,scaleY,xPercent,yPercent",
  "rotation,rotationX,rotationY,skewX,skewY",
  "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",
  "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY"
);
ut(
  "x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective",
  function (a) {
    Tt.units[a] = "px";
  }
);
ct.registerPlugin(Ba);
var dr = ct.registerPlugin(Ba) || ct;
dr.core.Tween;
function kl(a, e) {
  for (var r = 0; r < e.length; r++) {
    var t = e[r];
    (t.enumerable = t.enumerable || !1),
      (t.configurable = !0),
      "value" in t && (t.writable = !0),
      Object.defineProperty(a, t.key, t);
  }
}
function Cl(a, e, r) {
  return e && kl(a.prototype, e), a;
}
/*!
 * Observer 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */ var Le,
  Sn,
  xt,
  yr,
  vr,
  ci,
  Xa,
  Fr,
  Yi,
  Va,
  nr,
  Nt,
  Ua,
  $a = function () {
    return (
      Le ||
      (typeof window < "u" && (Le = window.gsap) && Le.registerPlugin && Le)
    );
  },
  Wa = 1,
  ai = [],
  V = [],
  qt = [],
  Bi = Date.now,
  ws = function (e, r) {
    return r;
  },
  Pl = function () {
    var e = Yi.core,
      r = e.bridge || {},
      t = e._scrollers,
      i = e._proxies;
    t.push.apply(t, V),
      i.push.apply(i, qt),
      (V = t),
      (qt = i),
      (ws = function (s, o) {
        return r[s](o);
      });
  },
  Tr = function (e, r) {
    return ~qt.indexOf(e) && qt[qt.indexOf(e) + 1][r];
  },
  Xi = function (e) {
    return !!~Va.indexOf(e);
  },
  Je = function (e, r, t, i, n) {
    return e.addEventListener(r, t, { passive: i !== !1, capture: !!n });
  },
  Ze = function (e, r, t, i) {
    return e.removeEventListener(r, t, !!i);
  },
  ln = "scrollLeft",
  fn = "scrollTop",
  Ss = function () {
    return (nr && nr.isPressed) || V.cache++;
  },
  In = function (e, r) {
    var t = function i(n) {
      if (n || n === 0) {
        Wa && (xt.history.scrollRestoration = "manual");
        var s = nr && nr.isPressed;
        (n = i.v = Math.round(n) || (nr && nr.iOS ? 1 : 0)),
          e(n),
          (i.cacheID = V.cache),
          s && ws("ss", n);
      } else
        (r || V.cache !== i.cacheID || ws("ref")) &&
          ((i.cacheID = V.cache), (i.v = e()));
      return i.v + i.offset;
    };
    return (t.offset = 0), e && t;
  },
  it = {
    s: ln,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: In(function (a) {
      return arguments.length
        ? xt.scrollTo(a, Pe.sc())
        : xt.pageXOffset || yr[ln] || vr[ln] || ci[ln] || 0;
    }),
  },
  Pe = {
    s: fn,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: it,
    sc: In(function (a) {
      return arguments.length
        ? xt.scrollTo(it.sc(), a)
        : xt.pageYOffset || yr[fn] || vr[fn] || ci[fn] || 0;
    }),
  },
  ot = function (e, r) {
    return (
      ((r && r._ctx && r._ctx.selector) || Le.utils.toArray)(e)[0] ||
      (typeof e == "string" && Le.config().nullTargetWarn !== !1
        ? console.warn("Element not found:", e)
        : null)
    );
  },
  kr = function (e, r) {
    var t = r.s,
      i = r.sc;
    Xi(e) && (e = yr.scrollingElement || vr);
    var n = V.indexOf(e),
      s = i === Pe.sc ? 1 : 2;
    !~n && (n = V.push(e) - 1), V[n + s] || Je(e, "scroll", Ss);
    var o = V[n + s],
      u =
        o ||
        (V[n + s] =
          In(Tr(e, t), !0) ||
          (Xi(e)
            ? i
            : In(function (l) {
                return arguments.length ? (e[t] = l) : e[t];
              })));
    return (
      (u.target = e),
      o || (u.smooth = Le.getProperty(e, "scrollBehavior") === "smooth"),
      u
    );
  },
  ks = function (e, r, t) {
    var i = e,
      n = e,
      s = Bi(),
      o = s,
      u = r || 50,
      l = Math.max(500, u * 3),
      f = function (p, h) {
        var m = Bi();
        h || m - s > u
          ? ((n = i), (i = p), (o = s), (s = m))
          : t
          ? (i += p)
          : (i = n + ((p - n) / (m - o)) * (s - o));
      },
      _ = function () {
        (n = i = t ? 0 : i), (o = s = 0);
      },
      d = function (p) {
        var h = o,
          m = n,
          T = Bi();
        return (
          (p || p === 0) && p !== i && f(p),
          s === o || T - o > l
            ? 0
            : ((i + (t ? m : -m)) / ((t ? T : s) - h)) * 1e3
        );
      };
    return { update: f, reset: _, getVelocity: d };
  },
  Pi = function (e, r) {
    return (
      r && !e._gsapAllow && e.preventDefault(),
      e.changedTouches ? e.changedTouches[0] : e
    );
  },
  wo = function (e) {
    var r = Math.max.apply(Math, e),
      t = Math.min.apply(Math, e);
    return Math.abs(r) >= Math.abs(t) ? r : t;
  },
  Ga = function () {
    (Yi = Le.core.globals().ScrollTrigger), Yi && Yi.core && Pl();
  },
  Ha = function (e) {
    return (
      (Le = e || $a()),
      !Sn &&
        Le &&
        typeof document < "u" &&
        document.body &&
        ((xt = window),
        (yr = document),
        (vr = yr.documentElement),
        (ci = yr.body),
        (Va = [xt, yr, vr, ci]),
        Le.utils.clamp,
        (Ua = Le.core.context || function () {}),
        (Fr = "onpointerenter" in ci ? "pointer" : "mouse"),
        (Xa = ve.isTouch =
          xt.matchMedia &&
          xt.matchMedia("(hover: none), (pointer: coarse)").matches
            ? 1
            : "ontouchstart" in xt ||
              navigator.maxTouchPoints > 0 ||
              navigator.msMaxTouchPoints > 0
            ? 2
            : 0),
        (Nt = ve.eventTypes =
          (
            "ontouchstart" in vr
              ? "touchstart,touchmove,touchcancel,touchend"
              : "onpointerdown" in vr
              ? "pointerdown,pointermove,pointercancel,pointerup"
              : "mousedown,mousemove,mouseup,mouseup"
          ).split(",")),
        setTimeout(function () {
          return (Wa = 0);
        }, 500),
        Ga(),
        (Sn = 1)),
      Sn
    );
  };
it.op = Pe;
V.cache = 0;
var ve = (function () {
  function a(r) {
    this.init(r);
  }
  var e = a.prototype;
  return (
    (e.init = function (t) {
      Sn || Ha(Le) || console.warn("Please gsap.registerPlugin(Observer)"),
        Yi || Ga();
      var i = t.tolerance,
        n = t.dragMinimum,
        s = t.type,
        o = t.target,
        u = t.lineHeight,
        l = t.debounce,
        f = t.preventDefault,
        _ = t.onStop,
        d = t.onStopDelay,
        c = t.ignore,
        p = t.wheelSpeed,
        h = t.event,
        m = t.onDragStart,
        T = t.onDragEnd,
        b = t.onDrag,
        S = t.onPress,
        v = t.onRelease,
        w = t.onRight,
        C = t.onLeft,
        x = t.onUp,
        O = t.onDown,
        k = t.onChangeX,
        P = t.onChangeY,
        F = t.onChange,
        M = t.onToggleX,
        W = t.onToggleY,
        U = t.onHover,
        K = t.onHoverEnd,
        G = t.onMove,
        z = t.ignoreCheck,
        Z = t.isNormalizer,
        ne = t.onGestureStart,
        g = t.onGestureEnd,
        se = t.onWheel,
        He = t.onEnable,
        Rt = t.onDisable,
        ce = t.onClick,
        Ae = t.scrollSpeed,
        qe = t.capture,
        xe = t.allowClicks,
        Ke = t.lockAxis,
        Ne = t.onLockAxis;
      (this.target = o = ot(o) || vr),
        (this.vars = t),
        c && (c = Le.utils.toArray(c)),
        (i = i || 1e-9),
        (n = n || 0),
        (p = p || 1),
        (Ae = Ae || 1),
        (s = s || "wheel,touch,pointer"),
        (l = l !== !1),
        u || (u = parseFloat(xt.getComputedStyle(ci).lineHeight) || 22);
      var ur,
        Qe,
        nt,
        Q,
        de,
        st,
        ht,
        y = this,
        _t = 0,
        Qt = 0,
        lr = t.passive || (!f && t.passive !== !1),
        pe = kr(o, it),
        Zt = kr(o, Pe),
        fr = pe(),
        Pr = Zt(),
        Oe =
          ~s.indexOf("touch") &&
          !~s.indexOf("pointer") &&
          Nt[0] === "pointerdown",
        cr = Xi(o),
        ge = o.ownerDocument || yr,
        At = [0, 0, 0],
        kt = [0, 0, 0],
        Jt = 0,
        bi = function () {
          return (Jt = Bi());
        },
        be = function (A, J) {
          return (
            ((y.event = A) && c && ~c.indexOf(A.target)) ||
            (J && Oe && A.pointerType !== "touch") ||
            (z && z(A, J))
          );
        },
        sn = function () {
          y._vx.reset(), y._vy.reset(), Qe.pause(), _ && _(y);
        },
        jt = function () {
          var A = (y.deltaX = wo(At)),
            J = (y.deltaY = wo(kt)),
            D = Math.abs(A) >= i,
            L = Math.abs(J) >= i;
          F && (D || L) && F(y, A, J, At, kt),
            D &&
              (w && y.deltaX > 0 && w(y),
              C && y.deltaX < 0 && C(y),
              k && k(y),
              M && y.deltaX < 0 != _t < 0 && M(y),
              (_t = y.deltaX),
              (At[0] = At[1] = At[2] = 0)),
            L &&
              (O && y.deltaY > 0 && O(y),
              x && y.deltaY < 0 && x(y),
              P && P(y),
              W && y.deltaY < 0 != Qt < 0 && W(y),
              (Qt = y.deltaY),
              (kt[0] = kt[1] = kt[2] = 0)),
            (Q || nt) &&
              (G && G(y),
              nt && (m && nt === 1 && m(y), b && b(y), (nt = 0)),
              (Q = !1)),
            st && !(st = !1) && Ne && Ne(y),
            de && (se(y), (de = !1)),
            (ur = 0);
        },
        Zr = function (A, J, D) {
          (At[D] += A),
            (kt[D] += J),
            y._vx.update(A),
            y._vy.update(J),
            l ? ur || (ur = requestAnimationFrame(jt)) : jt();
        },
        Jr = function (A, J) {
          Ke &&
            !ht &&
            ((y.axis = ht = Math.abs(A) > Math.abs(J) ? "x" : "y"), (st = !0)),
            ht !== "y" && ((At[2] += A), y._vx.update(A, !0)),
            ht !== "x" && ((kt[2] += J), y._vy.update(J, !0)),
            l ? ur || (ur = requestAnimationFrame(jt)) : jt();
        },
        hr = function (A) {
          if (!be(A, 1)) {
            A = Pi(A, f);
            var J = A.clientX,
              D = A.clientY,
              L = J - y.x,
              R = D - y.y,
              I = y.isDragging;
            (y.x = J),
              (y.y = D),
              (I ||
                ((L || R) &&
                  (Math.abs(y.startX - J) >= n ||
                    Math.abs(y.startY - D) >= n))) &&
                ((nt = I ? 2 : 1), I || (y.isDragging = !0), Jr(L, R));
          }
        },
        Or = (y.onPress = function (N) {
          be(N, 1) ||
            (N && N.button) ||
            ((y.axis = ht = null),
            Qe.pause(),
            (y.isPressed = !0),
            (N = Pi(N)),
            (_t = Qt = 0),
            (y.startX = y.x = N.clientX),
            (y.startY = y.y = N.clientY),
            y._vx.reset(),
            y._vy.reset(),
            Je(Z ? o : ge, Nt[1], hr, lr, !0),
            (y.deltaX = y.deltaY = 0),
            S && S(y));
        }),
        $ = (y.onRelease = function (N) {
          if (!be(N, 1)) {
            Ze(Z ? o : ge, Nt[1], hr, !0);
            var A = !isNaN(y.y - y.startY),
              J = y.isDragging,
              D =
                J &&
                (Math.abs(y.x - y.startX) > 3 || Math.abs(y.y - y.startY) > 3),
              L = Pi(N);
            !D &&
              A &&
              (y._vx.reset(),
              y._vy.reset(),
              f &&
                xe &&
                Le.delayedCall(0.08, function () {
                  if (Bi() - Jt > 300 && !N.defaultPrevented) {
                    if (N.target.click) N.target.click();
                    else if (ge.createEvent) {
                      var R = ge.createEvent("MouseEvents");
                      R.initMouseEvent(
                        "click",
                        !0,
                        !0,
                        xt,
                        1,
                        L.screenX,
                        L.screenY,
                        L.clientX,
                        L.clientY,
                        !1,
                        !1,
                        !1,
                        !1,
                        0,
                        null
                      ),
                        N.target.dispatchEvent(R);
                    }
                  }
                })),
              (y.isDragging = y.isGesturing = y.isPressed = !1),
              _ && J && !Z && Qe.restart(!0),
              nt && jt(),
              T && J && T(y),
              v && v(y, D);
          }
        }),
        Mr = function (A) {
          return (
            A.touches &&
            A.touches.length > 1 &&
            (y.isGesturing = !0) &&
            ne(A, y.isDragging)
          );
        },
        zt = function () {
          return (y.isGesturing = !1) || g(y);
        },
        Ft = function (A) {
          if (!be(A)) {
            var J = pe(),
              D = Zt();
            Zr((J - fr) * Ae, (D - Pr) * Ae, 1),
              (fr = J),
              (Pr = D),
              _ && Qe.restart(!0);
          }
        },
        Lt = function (A) {
          if (!be(A)) {
            (A = Pi(A, f)), se && (de = !0);
            var J =
              (A.deltaMode === 1 ? u : A.deltaMode === 2 ? xt.innerHeight : 1) *
              p;
            Zr(A.deltaX * J, A.deltaY * J, 0), _ && !Z && Qe.restart(!0);
          }
        },
        Dr = function (A) {
          if (!be(A)) {
            var J = A.clientX,
              D = A.clientY,
              L = J - y.x,
              R = D - y.y;
            (y.x = J),
              (y.y = D),
              (Q = !0),
              _ && Qe.restart(!0),
              (L || R) && Jr(L, R);
          }
        },
        jr = function (A) {
          (y.event = A), U(y);
        },
        er = function (A) {
          (y.event = A), K(y);
        },
        Ti = function (A) {
          return be(A) || (Pi(A, f) && ce(y));
        };
      (Qe = y._dc = Le.delayedCall(d || 0.25, sn).pause()),
        (y.deltaX = y.deltaY = 0),
        (y._vx = ks(0, 50, !0)),
        (y._vy = ks(0, 50, !0)),
        (y.scrollX = pe),
        (y.scrollY = Zt),
        (y.isDragging = y.isGesturing = y.isPressed = !1),
        Ua(this),
        (y.enable = function (N) {
          return (
            y.isEnabled ||
              (Je(cr ? ge : o, "scroll", Ss),
              s.indexOf("scroll") >= 0 && Je(cr ? ge : o, "scroll", Ft, lr, qe),
              s.indexOf("wheel") >= 0 && Je(o, "wheel", Lt, lr, qe),
              ((s.indexOf("touch") >= 0 && Xa) || s.indexOf("pointer") >= 0) &&
                (Je(o, Nt[0], Or, lr, qe),
                Je(ge, Nt[2], $),
                Je(ge, Nt[3], $),
                xe && Je(o, "click", bi, !0, !0),
                ce && Je(o, "click", Ti),
                ne && Je(ge, "gesturestart", Mr),
                g && Je(ge, "gestureend", zt),
                U && Je(o, Fr + "enter", jr),
                K && Je(o, Fr + "leave", er),
                G && Je(o, Fr + "move", Dr)),
              (y.isEnabled = !0),
              (y.isDragging = y.isGesturing = y.isPressed = Q = nt = !1),
              y._vx.reset(),
              y._vy.reset(),
              (fr = pe()),
              (Pr = Zt()),
              N && N.type && Or(N),
              He && He(y)),
            y
          );
        }),
        (y.disable = function () {
          y.isEnabled &&
            (ai.filter(function (N) {
              return N !== y && Xi(N.target);
            }).length || Ze(cr ? ge : o, "scroll", Ss),
            y.isPressed &&
              (y._vx.reset(), y._vy.reset(), Ze(Z ? o : ge, Nt[1], hr, !0)),
            Ze(cr ? ge : o, "scroll", Ft, qe),
            Ze(o, "wheel", Lt, qe),
            Ze(o, Nt[0], Or, qe),
            Ze(ge, Nt[2], $),
            Ze(ge, Nt[3], $),
            Ze(o, "click", bi, !0),
            Ze(o, "click", Ti),
            Ze(ge, "gesturestart", Mr),
            Ze(ge, "gestureend", zt),
            Ze(o, Fr + "enter", jr),
            Ze(o, Fr + "leave", er),
            Ze(o, Fr + "move", Dr),
            (y.isEnabled = y.isPressed = y.isDragging = !1),
            Rt && Rt(y));
        }),
        (y.kill = y.revert =
          function () {
            y.disable();
            var N = ai.indexOf(y);
            N >= 0 && ai.splice(N, 1), nr === y && (nr = 0);
          }),
        ai.push(y),
        Z && Xi(o) && (nr = y),
        y.enable(h);
    }),
    Cl(a, [
      {
        key: "velocityX",
        get: function () {
          return this._vx.getVelocity();
        },
      },
      {
        key: "velocityY",
        get: function () {
          return this._vy.getVelocity();
        },
      },
    ]),
    a
  );
})();
ve.version = "3.12.7";
ve.create = function (a) {
  return new ve(a);
};
ve.register = Ha;
ve.getAll = function () {
  return ai.slice();
};
ve.getById = function (a) {
  return ai.filter(function (e) {
    return e.vars.id === a;
  })[0];
};
$a() && Le.registerPlugin(ve);
/*!
 * ScrollTrigger 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */ var E,
  ii,
  X,
  ie,
  yt,
  j,
  Qs,
  Nn,
  tn,
  Vi,
  Ei,
  cn,
  Ve,
  Wn,
  Cs,
  et,
  So,
  ko,
  ni,
  qa,
  ts,
  Ka,
  je,
  Ps,
  Qa,
  Za,
  _r,
  Os,
  Zs,
  hi,
  Js,
  Yn,
  Ms,
  rs,
  hn = 1,
  Ue = Date.now,
  is = Ue(),
  Et = 0,
  Ri = 0,
  Co = function (e, r, t) {
    var i = gt(e) && (e.substr(0, 6) === "clamp(" || e.indexOf("max") > -1);
    return (t["_" + r + "Clamp"] = i), i ? e.substr(6, e.length - 7) : e;
  },
  Po = function (e, r) {
    return r && (!gt(e) || e.substr(0, 6) !== "clamp(")
      ? "clamp(" + e + ")"
      : e;
  },
  Ol = function a() {
    return Ri && requestAnimationFrame(a);
  },
  Oo = function () {
    return (Wn = 1);
  },
  Mo = function () {
    return (Wn = 0);
  },
  Ut = function (e) {
    return e;
  },
  Ai = function (e) {
    return Math.round(e * 1e5) / 1e5 || 0;
  },
  Ja = function () {
    return typeof window < "u";
  },
  ja = function () {
    return E || (Ja() && (E = window.gsap) && E.registerPlugin && E);
  },
  Hr = function (e) {
    return !!~Qs.indexOf(e);
  },
  eu = function (e) {
    return (
      (e === "Height" ? Js : X["inner" + e]) ||
      yt["client" + e] ||
      j["client" + e]
    );
  },
  tu = function (e) {
    return (
      Tr(e, "getBoundingClientRect") ||
      (Hr(e)
        ? function () {
            return (Mn.width = X.innerWidth), (Mn.height = Js), Mn;
          }
        : function () {
            return ir(e);
          })
    );
  },
  Ml = function (e, r, t) {
    var i = t.d,
      n = t.d2,
      s = t.a;
    return (s = Tr(e, "getBoundingClientRect"))
      ? function () {
          return s()[i];
        }
      : function () {
          return (r ? eu(n) : e["client" + n]) || 0;
        };
  },
  Dl = function (e, r) {
    return !r || ~qt.indexOf(e)
      ? tu(e)
      : function () {
          return Mn;
        };
  },
  Gt = function (e, r) {
    var t = r.s,
      i = r.d2,
      n = r.d,
      s = r.a;
    return Math.max(
      0,
      (t = "scroll" + i) && (s = Tr(e, t))
        ? s() - tu(e)()[n]
        : Hr(e)
        ? (yt[t] || j[t]) - eu(i)
        : e[t] - e["offset" + i]
    );
  },
  _n = function (e, r) {
    for (var t = 0; t < ni.length; t += 3)
      (!r || ~r.indexOf(ni[t + 1])) && e(ni[t], ni[t + 1], ni[t + 2]);
  },
  gt = function (e) {
    return typeof e == "string";
  },
  We = function (e) {
    return typeof e == "function";
  },
  zi = function (e) {
    return typeof e == "number";
  },
  Lr = function (e) {
    return typeof e == "object";
  },
  Oi = function (e, r, t) {
    return e && e.progress(r ? 0 : 1) && t && e.pause();
  },
  ns = function (e, r) {
    if (e.enabled) {
      var t = e._ctx
        ? e._ctx.add(function () {
            return r(e);
          })
        : r(e);
      t && t.totalTime && (e.callbackAnimation = t);
    }
  },
  ti = Math.abs,
  ru = "left",
  iu = "top",
  js = "right",
  eo = "bottom",
  Ur = "width",
  $r = "height",
  Ui = "Right",
  $i = "Left",
  Wi = "Top",
  Gi = "Bottom",
  Te = "padding",
  Pt = "margin",
  xi = "Width",
  to = "Height",
  Ce = "px",
  Ot = function (e) {
    return X.getComputedStyle(e);
  },
  El = function (e) {
    var r = Ot(e).position;
    e.style.position = r === "absolute" || r === "fixed" ? r : "relative";
  },
  Do = function (e, r) {
    for (var t in r) t in e || (e[t] = r[t]);
    return e;
  },
  ir = function (e, r) {
    var t =
        r &&
        Ot(e)[Cs] !== "matrix(1, 0, 0, 1, 0, 0)" &&
        E.to(e, {
          x: 0,
          y: 0,
          xPercent: 0,
          yPercent: 0,
          rotation: 0,
          rotationX: 0,
          rotationY: 0,
          scale: 1,
          skewX: 0,
          skewY: 0,
        }).progress(1),
      i = e.getBoundingClientRect();
    return t && t.progress(0).kill(), i;
  },
  Bn = function (e, r) {
    var t = r.d2;
    return e["offset" + t] || e["client" + t] || 0;
  },
  nu = function (e) {
    var r = [],
      t = e.labels,
      i = e.duration(),
      n;
    for (n in t) r.push(t[n] / i);
    return r;
  },
  Rl = function (e) {
    return function (r) {
      return E.utils.snap(nu(e), r);
    };
  },
  ro = function (e) {
    var r = E.utils.snap(e),
      t =
        Array.isArray(e) &&
        e.slice(0).sort(function (i, n) {
          return i - n;
        });
    return t
      ? function (i, n, s) {
          s === void 0 && (s = 0.001);
          var o;
          if (!n) return r(i);
          if (n > 0) {
            for (i -= s, o = 0; o < t.length; o++) if (t[o] >= i) return t[o];
            return t[o - 1];
          } else for (o = t.length, i += s; o--; ) if (t[o] <= i) return t[o];
          return t[0];
        }
      : function (i, n, s) {
          s === void 0 && (s = 0.001);
          var o = r(i);
          return !n || Math.abs(o - i) < s || o - i < 0 == n < 0
            ? o
            : r(n < 0 ? i - e : i + e);
        };
  },
  Al = function (e) {
    return function (r, t) {
      return ro(nu(e))(r, t.direction);
    };
  },
  dn = function (e, r, t, i) {
    return t.split(",").forEach(function (n) {
      return e(r, n, i);
    });
  },
  Ee = function (e, r, t, i, n) {
    return e.addEventListener(r, t, { passive: !i, capture: !!n });
  },
  De = function (e, r, t, i) {
    return e.removeEventListener(r, t, !!i);
  },
  pn = function (e, r, t) {
    (t = t && t.wheelHandler), t && (e(r, "wheel", t), e(r, "touchmove", t));
  },
  Eo = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal",
  },
  gn = { toggleActions: "play", anticipatePin: 0 },
  Xn = { top: 0, left: 0, center: 0.5, bottom: 1, right: 1 },
  kn = function (e, r) {
    if (gt(e)) {
      var t = e.indexOf("="),
        i = ~t ? +(e.charAt(t - 1) + 1) * parseFloat(e.substr(t + 1)) : 0;
      ~t && (e.indexOf("%") > t && (i *= r / 100), (e = e.substr(0, t - 1))),
        (e =
          i +
          (e in Xn
            ? Xn[e] * r
            : ~e.indexOf("%")
            ? (parseFloat(e) * r) / 100
            : parseFloat(e) || 0));
    }
    return e;
  },
  mn = function (e, r, t, i, n, s, o, u) {
    var l = n.startColor,
      f = n.endColor,
      _ = n.fontSize,
      d = n.indent,
      c = n.fontWeight,
      p = ie.createElement("div"),
      h = Hr(t) || Tr(t, "pinType") === "fixed",
      m = e.indexOf("scroller") !== -1,
      T = h ? j : t,
      b = e.indexOf("start") !== -1,
      S = b ? l : f,
      v =
        "border-color:" +
        S +
        ";font-size:" +
        _ +
        ";color:" +
        S +
        ";font-weight:" +
        c +
        ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    return (
      (v += "position:" + ((m || u) && h ? "fixed;" : "absolute;")),
      (m || u || !h) &&
        (v += (i === Pe ? js : eo) + ":" + (s + parseFloat(d)) + "px;"),
      o &&
        (v +=
          "box-sizing:border-box;text-align:left;width:" +
          o.offsetWidth +
          "px;"),
      (p._isStart = b),
      p.setAttribute("class", "gsap-marker-" + e + (r ? " marker-" + r : "")),
      (p.style.cssText = v),
      (p.innerText = r || r === 0 ? e + "-" + r : e),
      T.children[0] ? T.insertBefore(p, T.children[0]) : T.appendChild(p),
      (p._offset = p["offset" + i.op.d2]),
      Cn(p, 0, i, b),
      p
    );
  },
  Cn = function (e, r, t, i) {
    var n = { display: "block" },
      s = t[i ? "os2" : "p2"],
      o = t[i ? "p2" : "os2"];
    (e._isFlipped = i),
      (n[t.a + "Percent"] = i ? -100 : 0),
      (n[t.a] = i ? "1px" : 0),
      (n["border" + s + xi] = 1),
      (n["border" + o + xi] = 0),
      (n[t.p] = r + "px"),
      E.set(e, n);
  },
  B = [],
  Ds = {},
  rn,
  Ro = function () {
    return Ue() - Et > 34 && (rn || (rn = requestAnimationFrame(sr)));
  },
  ri = function () {
    (!je || !je.isPressed || je.startX > j.clientWidth) &&
      (V.cache++,
      je ? rn || (rn = requestAnimationFrame(sr)) : sr(),
      Et || Kr("scrollStart"),
      (Et = Ue()));
  },
  ss = function () {
    (Za = X.innerWidth), (Qa = X.innerHeight);
  },
  Fi = function (e) {
    V.cache++,
      (e === !0 ||
        (!Ve &&
          !Ka &&
          !ie.fullscreenElement &&
          !ie.webkitFullscreenElement &&
          (!Ps ||
            Za !== X.innerWidth ||
            Math.abs(X.innerHeight - Qa) > X.innerHeight * 0.25))) &&
        Nn.restart(!0);
  },
  qr = {},
  zl = [],
  su = function a() {
    return De(Y, "scrollEnd", a) || Nr(!0);
  },
  Kr = function (e) {
    return (
      (qr[e] &&
        qr[e].map(function (r) {
          return r();
        })) ||
      zl
    );
  },
  pt = [],
  ou = function (e) {
    for (var r = 0; r < pt.length; r += 5)
      (!e || (pt[r + 4] && pt[r + 4].query === e)) &&
        ((pt[r].style.cssText = pt[r + 1]),
        pt[r].getBBox && pt[r].setAttribute("transform", pt[r + 2] || ""),
        (pt[r + 3].uncache = 1));
  },
  io = function (e, r) {
    var t;
    for (et = 0; et < B.length; et++)
      (t = B[et]),
        t && (!r || t._ctx === r) && (e ? t.kill(1) : t.revert(!0, !0));
    (Yn = !0), r && ou(r), r || Kr("revert");
  },
  au = function (e, r) {
    V.cache++,
      (r || !tt) &&
        V.forEach(function (t) {
          return We(t) && t.cacheID++ && (t.rec = 0);
        }),
      gt(e) && (X.history.scrollRestoration = Zs = e);
  },
  tt,
  Wr = 0,
  Ao,
  Fl = function () {
    if (Ao !== Wr) {
      var e = (Ao = Wr);
      requestAnimationFrame(function () {
        return e === Wr && Nr(!0);
      });
    }
  },
  uu = function () {
    j.appendChild(hi),
      (Js = (!je && hi.offsetHeight) || X.innerHeight),
      j.removeChild(hi);
  },
  zo = function (e) {
    return tn(
      ".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end"
    ).forEach(function (r) {
      return (r.style.display = e ? "none" : "block");
    });
  },
  Nr = function (e, r) {
    if (
      ((yt = ie.documentElement),
      (j = ie.body),
      (Qs = [X, ie, yt, j]),
      Et && !e && !Yn)
    ) {
      Ee(Y, "scrollEnd", su);
      return;
    }
    uu(),
      (tt = Y.isRefreshing = !0),
      V.forEach(function (i) {
        return We(i) && ++i.cacheID && (i.rec = i());
      });
    var t = Kr("refreshInit");
    qa && Y.sort(),
      r || io(),
      V.forEach(function (i) {
        We(i) && (i.smooth && (i.target.style.scrollBehavior = "auto"), i(0));
      }),
      B.slice(0).forEach(function (i) {
        return i.refresh();
      }),
      (Yn = !1),
      B.forEach(function (i) {
        if (i._subPinOffset && i.pin) {
          var n = i.vars.horizontal ? "offsetWidth" : "offsetHeight",
            s = i.pin[n];
          i.revert(!0, 1), i.adjustPinSpacing(i.pin[n] - s), i.refresh();
        }
      }),
      (Ms = 1),
      zo(!0),
      B.forEach(function (i) {
        var n = Gt(i.scroller, i._dir),
          s = i.vars.end === "max" || (i._endClamp && i.end > n),
          o = i._startClamp && i.start >= n;
        (s || o) &&
          i.setPositions(
            o ? n - 1 : i.start,
            s ? Math.max(o ? n : i.start + 1, n) : i.end,
            !0
          );
      }),
      zo(!1),
      (Ms = 0),
      t.forEach(function (i) {
        return i && i.render && i.render(-1);
      }),
      V.forEach(function (i) {
        We(i) &&
          (i.smooth &&
            requestAnimationFrame(function () {
              return (i.target.style.scrollBehavior = "smooth");
            }),
          i.rec && i(i.rec));
      }),
      au(Zs, 1),
      Nn.pause(),
      Wr++,
      (tt = 2),
      sr(2),
      B.forEach(function (i) {
        return We(i.vars.onRefresh) && i.vars.onRefresh(i);
      }),
      (tt = Y.isRefreshing = !1),
      Kr("refresh");
  },
  Es = 0,
  Pn = 1,
  Hi,
  sr = function (e) {
    if (e === 2 || (!tt && !Yn)) {
      (Y.isUpdating = !0), Hi && Hi.update(0);
      var r = B.length,
        t = Ue(),
        i = t - is >= 50,
        n = r && B[0].scroll();
      if (
        ((Pn = Es > n ? -1 : 1),
        tt || (Es = n),
        i &&
          (Et && !Wn && t - Et > 200 && ((Et = 0), Kr("scrollEnd")),
          (Ei = is),
          (is = t)),
        Pn < 0)
      ) {
        for (et = r; et-- > 0; ) B[et] && B[et].update(0, i);
        Pn = 1;
      } else for (et = 0; et < r; et++) B[et] && B[et].update(0, i);
      Y.isUpdating = !1;
    }
    rn = 0;
  },
  Rs = [
    ru,
    iu,
    eo,
    js,
    Pt + Gi,
    Pt + Ui,
    Pt + Wi,
    Pt + $i,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order",
  ],
  On = Rs.concat([
    Ur,
    $r,
    "boxSizing",
    "max" + xi,
    "max" + to,
    "position",
    Pt,
    Te,
    Te + Wi,
    Te + Ui,
    Te + Gi,
    Te + $i,
  ]),
  Ll = function (e, r, t) {
    _i(t);
    var i = e._gsap;
    if (i.spacerIsNative) _i(i.spacerState);
    else if (e._gsap.swappedIn) {
      var n = r.parentNode;
      n && (n.insertBefore(e, r), n.removeChild(r));
    }
    e._gsap.swappedIn = !1;
  },
  os = function (e, r, t, i) {
    if (!e._gsap.swappedIn) {
      for (var n = Rs.length, s = r.style, o = e.style, u; n--; )
        (u = Rs[n]), (s[u] = t[u]);
      (s.position = t.position === "absolute" ? "absolute" : "relative"),
        t.display === "inline" && (s.display = "inline-block"),
        (o[eo] = o[js] = "auto"),
        (s.flexBasis = t.flexBasis || "auto"),
        (s.overflow = "visible"),
        (s.boxSizing = "border-box"),
        (s[Ur] = Bn(e, it) + Ce),
        (s[$r] = Bn(e, Pe) + Ce),
        (s[Te] = o[Pt] = o[iu] = o[ru] = "0"),
        _i(i),
        (o[Ur] = o["max" + xi] = t[Ur]),
        (o[$r] = o["max" + to] = t[$r]),
        (o[Te] = t[Te]),
        e.parentNode !== r &&
          (e.parentNode.insertBefore(r, e), r.appendChild(e)),
        (e._gsap.swappedIn = !0);
    }
  },
  Il = /([A-Z])/g,
  _i = function (e) {
    if (e) {
      var r = e.t.style,
        t = e.length,
        i = 0,
        n,
        s;
      for ((e.t._gsap || E.core.getCache(e.t)).uncache = 1; i < t; i += 2)
        (s = e[i + 1]),
          (n = e[i]),
          s
            ? (r[n] = s)
            : r[n] && r.removeProperty(n.replace(Il, "-$1").toLowerCase());
    }
  },
  yn = function (e) {
    for (var r = On.length, t = e.style, i = [], n = 0; n < r; n++)
      i.push(On[n], t[On[n]]);
    return (i.t = e), i;
  },
  Nl = function (e, r, t) {
    for (var i = [], n = e.length, s = t ? 8 : 0, o; s < n; s += 2)
      (o = e[s]), i.push(o, o in r ? r[o] : e[s + 1]);
    return (i.t = e.t), i;
  },
  Mn = { left: 0, top: 0 },
  Fo = function (e, r, t, i, n, s, o, u, l, f, _, d, c, p) {
    We(e) && (e = e(u)),
      gt(e) &&
        e.substr(0, 3) === "max" &&
        (e = d + (e.charAt(4) === "=" ? kn("0" + e.substr(3), t) : 0));
    var h = c ? c.time() : 0,
      m,
      T,
      b;
    if ((c && c.seek(0), isNaN(e) || (e = +e), zi(e)))
      c &&
        (e = E.utils.mapRange(
          c.scrollTrigger.start,
          c.scrollTrigger.end,
          0,
          d,
          e
        )),
        o && Cn(o, t, i, !0);
    else {
      We(r) && (r = r(u));
      var S = (e || "0").split(" "),
        v,
        w,
        C,
        x;
      (b = ot(r, u) || j),
        (v = ir(b) || {}),
        (!v || (!v.left && !v.top)) &&
          Ot(b).display === "none" &&
          ((x = b.style.display),
          (b.style.display = "block"),
          (v = ir(b)),
          x ? (b.style.display = x) : b.style.removeProperty("display")),
        (w = kn(S[0], v[i.d])),
        (C = kn(S[1] || "0", t)),
        (e = v[i.p] - l[i.p] - f + w + n - C),
        o && Cn(o, C, i, t - C < 20 || (o._isStart && C > 20)),
        (t -= t - C);
    }
    if ((p && ((u[p] = e || -0.001), e < 0 && (e = 0)), s)) {
      var O = e + t,
        k = s._isStart;
      (m = "scroll" + i.d2),
        Cn(
          s,
          O,
          i,
          (k && O > 20) ||
            (!k && (_ ? Math.max(j[m], yt[m]) : s.parentNode[m]) <= O + 1)
        ),
        _ &&
          ((l = ir(o)),
          _ && (s.style[i.op.p] = l[i.op.p] - i.op.m - s._offset + Ce));
    }
    return (
      c &&
        b &&
        ((m = ir(b)),
        c.seek(d),
        (T = ir(b)),
        (c._caScrollDist = m[i.p] - T[i.p]),
        (e = (e / c._caScrollDist) * d)),
      c && c.seek(h),
      c ? e : Math.round(e)
    );
  },
  Yl = /(webkit|moz|length|cssText|inset)/i,
  Lo = function (e, r, t, i) {
    if (e.parentNode !== r) {
      var n = e.style,
        s,
        o;
      if (r === j) {
        (e._stOrig = n.cssText), (o = Ot(e));
        for (s in o)
          !+s &&
            !Yl.test(s) &&
            o[s] &&
            typeof n[s] == "string" &&
            s !== "0" &&
            (n[s] = o[s]);
        (n.top = t), (n.left = i);
      } else n.cssText = e._stOrig;
      (E.core.getCache(e).uncache = 1), r.appendChild(e);
    }
  },
  lu = function (e, r, t) {
    var i = r,
      n = i;
    return function (s) {
      var o = Math.round(e());
      return (
        o !== i &&
          o !== n &&
          Math.abs(o - i) > 3 &&
          Math.abs(o - n) > 3 &&
          ((s = o), t && t()),
        (n = i),
        (i = Math.round(s)),
        i
      );
    };
  },
  vn = function (e, r, t) {
    var i = {};
    (i[r.p] = "+=" + t), E.set(e, i);
  },
  Io = function (e, r) {
    var t = kr(e, r),
      i = "_scroll" + r.p2,
      n = function s(o, u, l, f, _) {
        var d = s.tween,
          c = u.onComplete,
          p = {};
        l = l || t();
        var h = lu(t, l, function () {
          d.kill(), (s.tween = 0);
        });
        return (
          (_ = (f && _) || 0),
          (f = f || o - l),
          d && d.kill(),
          (u[i] = o),
          (u.inherit = !1),
          (u.modifiers = p),
          (p[i] = function () {
            return h(l + f * d.ratio + _ * d.ratio * d.ratio);
          }),
          (u.onUpdate = function () {
            V.cache++, s.tween && sr();
          }),
          (u.onComplete = function () {
            (s.tween = 0), c && c.call(d);
          }),
          (d = s.tween = E.to(e, u)),
          d
        );
      };
    return (
      (e[i] = t),
      (t.wheelHandler = function () {
        return n.tween && n.tween.kill() && (n.tween = 0);
      }),
      Ee(e, "wheel", t.wheelHandler),
      Y.isTouch && Ee(e, "touchmove", t.wheelHandler),
      n
    );
  },
  Y = (function () {
    function a(r, t) {
      ii ||
        a.register(E) ||
        console.warn("Please gsap.registerPlugin(ScrollTrigger)"),
        Os(this),
        this.init(r, t);
    }
    var e = a.prototype;
    return (
      (e.init = function (t, i) {
        if (
          ((this.progress = this.start = 0),
          this.vars && this.kill(!0, !0),
          !Ri)
        ) {
          this.update = this.refresh = this.kill = Ut;
          return;
        }
        t = Do(gt(t) || zi(t) || t.nodeType ? { trigger: t } : t, gn);
        var n = t,
          s = n.onUpdate,
          o = n.toggleClass,
          u = n.id,
          l = n.onToggle,
          f = n.onRefresh,
          _ = n.scrub,
          d = n.trigger,
          c = n.pin,
          p = n.pinSpacing,
          h = n.invalidateOnRefresh,
          m = n.anticipatePin,
          T = n.onScrubComplete,
          b = n.onSnapComplete,
          S = n.once,
          v = n.snap,
          w = n.pinReparent,
          C = n.pinSpacer,
          x = n.containerAnimation,
          O = n.fastScrollEnd,
          k = n.preventOverlaps,
          P =
            t.horizontal || (t.containerAnimation && t.horizontal !== !1)
              ? it
              : Pe,
          F = !_ && _ !== 0,
          M = ot(t.scroller || X),
          W = E.core.getCache(M),
          U = Hr(M),
          K =
            ("pinType" in t
              ? t.pinType
              : Tr(M, "pinType") || (U && "fixed")) === "fixed",
          G = [t.onEnter, t.onLeave, t.onEnterBack, t.onLeaveBack],
          z = F && t.toggleActions.split(" "),
          Z = "markers" in t ? t.markers : gn.markers,
          ne = U ? 0 : parseFloat(Ot(M)["border" + P.p2 + xi]) || 0,
          g = this,
          se =
            t.onRefreshInit &&
            function () {
              return t.onRefreshInit(g);
            },
          He = Ml(M, U, P),
          Rt = Dl(M, U),
          ce = 0,
          Ae = 0,
          qe = 0,
          xe = kr(M, P),
          Ke,
          Ne,
          ur,
          Qe,
          nt,
          Q,
          de,
          st,
          ht,
          y,
          _t,
          Qt,
          lr,
          pe,
          Zt,
          fr,
          Pr,
          Oe,
          cr,
          ge,
          At,
          kt,
          Jt,
          bi,
          be,
          sn,
          jt,
          Zr,
          Jr,
          hr,
          Or,
          $,
          Mr,
          zt,
          Ft,
          Lt,
          Dr,
          jr,
          er;
        if (
          ((g._startClamp = g._endClamp = !1),
          (g._dir = P),
          (m *= 45),
          (g.scroller = M),
          (g.scroll = x ? x.time.bind(x) : xe),
          (Qe = xe()),
          (g.vars = t),
          (i = i || t.animation),
          "refreshPriority" in t &&
            ((qa = 1), t.refreshPriority === -9999 && (Hi = g)),
          (W.tweenScroll = W.tweenScroll || {
            top: Io(M, Pe),
            left: Io(M, it),
          }),
          (g.tweenTo = Ke = W.tweenScroll[P.p]),
          (g.scrubDuration = function (D) {
            (Mr = zi(D) && D),
              Mr
                ? $
                  ? $.duration(D)
                  : ($ = E.to(i, {
                      ease: "expo",
                      totalProgress: "+=0",
                      inherit: !1,
                      duration: Mr,
                      paused: !0,
                      onComplete: function () {
                        return T && T(g);
                      },
                    }))
                : ($ && $.progress(1).kill(), ($ = 0));
          }),
          i &&
            ((i.vars.lazy = !1),
            (i._initted && !g.isReverted) ||
              (i.vars.immediateRender !== !1 &&
                t.immediateRender !== !1 &&
                i.duration() &&
                i.render(0, !0, !0)),
            (g.animation = i.pause()),
            (i.scrollTrigger = g),
            g.scrubDuration(_),
            (hr = 0),
            u || (u = i.vars.id)),
          v &&
            ((!Lr(v) || v.push) && (v = { snapTo: v }),
            "scrollBehavior" in j.style &&
              E.set(U ? [j, yt] : M, { scrollBehavior: "auto" }),
            V.forEach(function (D) {
              return (
                We(D) &&
                D.target === (U ? ie.scrollingElement || yt : M) &&
                (D.smooth = !1)
              );
            }),
            (ur = We(v.snapTo)
              ? v.snapTo
              : v.snapTo === "labels"
              ? Rl(i)
              : v.snapTo === "labelsDirectional"
              ? Al(i)
              : v.directional !== !1
              ? function (D, L) {
                  return ro(v.snapTo)(D, Ue() - Ae < 500 ? 0 : L.direction);
                }
              : E.utils.snap(v.snapTo)),
            (zt = v.duration || { min: 0.1, max: 2 }),
            (zt = Lr(zt) ? Vi(zt.min, zt.max) : Vi(zt, zt)),
            (Ft = E.delayedCall(v.delay || Mr / 2 || 0.1, function () {
              var D = xe(),
                L = Ue() - Ae < 500,
                R = Ke.tween;
              if (
                (L || Math.abs(g.getVelocity()) < 10) &&
                !R &&
                !Wn &&
                ce !== D
              ) {
                var I = (D - Q) / pe,
                  Me = i && !F ? i.totalProgress() : I,
                  H = L ? 0 : ((Me - Or) / (Ue() - Ei)) * 1e3 || 0,
                  me = E.utils.clamp(-I, 1 - I, (ti(H / 2) * H) / 0.185),
                  Ye = I + (v.inertia === !1 ? 0 : me),
                  he,
                  oe,
                  ee = v,
                  It = ee.onStart,
                  ue = ee.onInterrupt,
                  dt = ee.onComplete;
                if (
                  ((he = ur(Ye, g)),
                  zi(he) || (he = Ye),
                  (oe = Math.max(0, Math.round(Q + he * pe))),
                  D <= de && D >= Q && oe !== D)
                ) {
                  if (R && !R._initted && R.data <= ti(oe - D)) return;
                  v.inertia === !1 && (me = he - I),
                    Ke(
                      oe,
                      {
                        duration: zt(
                          ti(
                            (Math.max(ti(Ye - Me), ti(he - Me)) * 0.185) /
                              H /
                              0.05 || 0
                          )
                        ),
                        ease: v.ease || "power3",
                        data: ti(oe - D),
                        onInterrupt: function () {
                          return Ft.restart(!0) && ue && ue(g);
                        },
                        onComplete: function () {
                          g.update(),
                            (ce = xe()),
                            i &&
                              !F &&
                              ($
                                ? $.resetTo(
                                    "totalProgress",
                                    he,
                                    i._tTime / i._tDur
                                  )
                                : i.progress(he)),
                            (hr = Or =
                              i && !F ? i.totalProgress() : g.progress),
                            b && b(g),
                            dt && dt(g);
                        },
                      },
                      D,
                      me * pe,
                      oe - D - me * pe
                    ),
                    It && It(g, Ke.tween);
                }
              } else g.isActive && ce !== D && Ft.restart(!0);
            }).pause())),
          u && (Ds[u] = g),
          (d = g.trigger = ot(d || (c !== !0 && c))),
          (er = d && d._gsap && d._gsap.stRevert),
          er && (er = er(g)),
          (c = c === !0 ? d : ot(c)),
          gt(o) && (o = { targets: d, className: o }),
          c &&
            (p === !1 ||
              p === Pt ||
              (p =
                !p &&
                c.parentNode &&
                c.parentNode.style &&
                Ot(c.parentNode).display === "flex"
                  ? !1
                  : Te),
            (g.pin = c),
            (Ne = E.core.getCache(c)),
            Ne.spacer
              ? (Zt = Ne.pinState)
              : (C &&
                  ((C = ot(C)),
                  C && !C.nodeType && (C = C.current || C.nativeElement),
                  (Ne.spacerIsNative = !!C),
                  C && (Ne.spacerState = yn(C))),
                (Ne.spacer = Oe = C || ie.createElement("div")),
                Oe.classList.add("pin-spacer"),
                u && Oe.classList.add("pin-spacer-" + u),
                (Ne.pinState = Zt = yn(c))),
            t.force3D !== !1 && E.set(c, { force3D: !0 }),
            (g.spacer = Oe = Ne.spacer),
            (Jr = Ot(c)),
            (bi = Jr[p + P.os2]),
            (ge = E.getProperty(c)),
            (At = E.quickSetter(c, P.a, Ce)),
            os(c, Oe, Jr),
            (Pr = yn(c))),
          Z)
        ) {
          (Qt = Lr(Z) ? Do(Z, Eo) : Eo),
            (y = mn("scroller-start", u, M, P, Qt, 0)),
            (_t = mn("scroller-end", u, M, P, Qt, 0, y)),
            (cr = y["offset" + P.op.d2]);
          var Ti = ot(Tr(M, "content") || M);
          (st = this.markerStart = mn("start", u, Ti, P, Qt, cr, 0, x)),
            (ht = this.markerEnd = mn("end", u, Ti, P, Qt, cr, 0, x)),
            x && (jr = E.quickSetter([st, ht], P.a, Ce)),
            !K &&
              !(qt.length && Tr(M, "fixedMarkers") === !0) &&
              (El(U ? j : M),
              E.set([y, _t], { force3D: !0 }),
              (sn = E.quickSetter(y, P.a, Ce)),
              (Zr = E.quickSetter(_t, P.a, Ce)));
        }
        if (x) {
          var N = x.vars.onUpdate,
            A = x.vars.onUpdateParams;
          x.eventCallback("onUpdate", function () {
            g.update(0, 0, 1), N && N.apply(x, A || []);
          });
        }
        if (
          ((g.previous = function () {
            return B[B.indexOf(g) - 1];
          }),
          (g.next = function () {
            return B[B.indexOf(g) + 1];
          }),
          (g.revert = function (D, L) {
            if (!L) return g.kill(!0);
            var R = D !== !1 || !g.enabled,
              I = Ve;
            R !== g.isReverted &&
              (R &&
                ((Lt = Math.max(xe(), g.scroll.rec || 0)),
                (qe = g.progress),
                (Dr = i && i.progress())),
              st &&
                [st, ht, y, _t].forEach(function (Me) {
                  return (Me.style.display = R ? "none" : "block");
                }),
              R && ((Ve = g), g.update(R)),
              c &&
                (!w || !g.isActive) &&
                (R ? Ll(c, Oe, Zt) : os(c, Oe, Ot(c), be)),
              R || g.update(R),
              (Ve = I),
              (g.isReverted = R));
          }),
          (g.refresh = function (D, L, R, I) {
            if (!((Ve || !g.enabled) && !L)) {
              if (c && D && Et) {
                Ee(a, "scrollEnd", su);
                return;
              }
              !tt && se && se(g),
                (Ve = g),
                Ke.tween && !R && (Ke.tween.kill(), (Ke.tween = 0)),
                $ && $.pause(),
                h && i && i.revert({ kill: !1 }).invalidate(),
                g.isReverted || g.revert(!0, !0),
                (g._subPinOffset = !1);
              var Me = He(),
                H = Rt(),
                me = x ? x.duration() : Gt(M, P),
                Ye = pe <= 0.01,
                he = 0,
                oe = I || 0,
                ee = Lr(R) ? R.end : t.end,
                It = t.endTrigger || d,
                ue = Lr(R)
                  ? R.start
                  : t.start || (t.start === 0 || !d ? 0 : c ? "0 0" : "0 100%"),
                dt = (g.pinnedContainer =
                  t.pinnedContainer && ot(t.pinnedContainer, g)),
                Yt = (d && Math.max(0, B.indexOf(g))) || 0,
                ze = Yt,
                Fe,
                Be,
                Er,
                on,
                Xe,
                ke,
                Bt,
                Gn,
                no,
                wi,
                Xt,
                Si,
                an;
              for (
                Z &&
                Lr(R) &&
                ((Si = E.getProperty(y, P.p)), (an = E.getProperty(_t, P.p)));
                ze-- > 0;

              )
                (ke = B[ze]),
                  ke.end || ke.refresh(0, 1) || (Ve = g),
                  (Bt = ke.pin),
                  Bt &&
                    (Bt === d || Bt === c || Bt === dt) &&
                    !ke.isReverted &&
                    (wi || (wi = []), wi.unshift(ke), ke.revert(!0, !0)),
                  ke !== B[ze] && (Yt--, ze--);
              for (
                We(ue) && (ue = ue(g)),
                  ue = Co(ue, "start", g),
                  Q =
                    Fo(
                      ue,
                      d,
                      Me,
                      P,
                      xe(),
                      st,
                      y,
                      g,
                      H,
                      ne,
                      K,
                      me,
                      x,
                      g._startClamp && "_startClamp"
                    ) || (c ? -0.001 : 0),
                  We(ee) && (ee = ee(g)),
                  gt(ee) &&
                    !ee.indexOf("+=") &&
                    (~ee.indexOf(" ")
                      ? (ee = (gt(ue) ? ue.split(" ")[0] : "") + ee)
                      : ((he = kn(ee.substr(2), Me)),
                        (ee = gt(ue)
                          ? ue
                          : (x
                              ? E.utils.mapRange(
                                  0,
                                  x.duration(),
                                  x.scrollTrigger.start,
                                  x.scrollTrigger.end,
                                  Q
                                )
                              : Q) + he),
                        (It = d))),
                  ee = Co(ee, "end", g),
                  de =
                    Math.max(
                      Q,
                      Fo(
                        ee || (It ? "100% 0" : me),
                        It,
                        Me,
                        P,
                        xe() + he,
                        ht,
                        _t,
                        g,
                        H,
                        ne,
                        K,
                        me,
                        x,
                        g._endClamp && "_endClamp"
                      )
                    ) || -0.001,
                  he = 0,
                  ze = Yt;
                ze--;

              )
                (ke = B[ze]),
                  (Bt = ke.pin),
                  Bt &&
                    ke.start - ke._pinPush <= Q &&
                    !x &&
                    ke.end > 0 &&
                    ((Fe =
                      ke.end -
                      (g._startClamp ? Math.max(0, ke.start) : ke.start)),
                    ((Bt === d && ke.start - ke._pinPush < Q) || Bt === dt) &&
                      isNaN(ue) &&
                      (he += Fe * (1 - ke.progress)),
                    Bt === c && (oe += Fe));
              if (
                ((Q += he),
                (de += he),
                g._startClamp && (g._startClamp += he),
                g._endClamp &&
                  !tt &&
                  ((g._endClamp = de || -0.001), (de = Math.min(de, Gt(M, P)))),
                (pe = de - Q || ((Q -= 0.01) && 0.001)),
                Ye && (qe = E.utils.clamp(0, 1, E.utils.normalize(Q, de, Lt))),
                (g._pinPush = oe),
                st &&
                  he &&
                  ((Fe = {}),
                  (Fe[P.a] = "+=" + he),
                  dt && (Fe[P.p] = "-=" + xe()),
                  E.set([st, ht], Fe)),
                c && !(Ms && g.end >= Gt(M, P)))
              )
                (Fe = Ot(c)),
                  (on = P === Pe),
                  (Er = xe()),
                  (kt = parseFloat(ge(P.a)) + oe),
                  !me &&
                    de > 1 &&
                    ((Xt = (U ? ie.scrollingElement || yt : M).style),
                    (Xt = {
                      style: Xt,
                      value: Xt["overflow" + P.a.toUpperCase()],
                    }),
                    U &&
                      Ot(j)["overflow" + P.a.toUpperCase()] !== "scroll" &&
                      (Xt.style["overflow" + P.a.toUpperCase()] = "scroll")),
                  os(c, Oe, Fe),
                  (Pr = yn(c)),
                  (Be = ir(c, !0)),
                  (Gn = K && kr(M, on ? it : Pe)()),
                  p
                    ? ((be = [p + P.os2, pe + oe + Ce]),
                      (be.t = Oe),
                      (ze = p === Te ? Bn(c, P) + pe + oe : 0),
                      ze &&
                        (be.push(P.d, ze + Ce),
                        Oe.style.flexBasis !== "auto" &&
                          (Oe.style.flexBasis = ze + Ce)),
                      _i(be),
                      dt &&
                        B.forEach(function (ki) {
                          ki.pin === dt &&
                            ki.vars.pinSpacing !== !1 &&
                            (ki._subPinOffset = !0);
                        }),
                      K && xe(Lt))
                    : ((ze = Bn(c, P)),
                      ze &&
                        Oe.style.flexBasis !== "auto" &&
                        (Oe.style.flexBasis = ze + Ce)),
                  K &&
                    ((Xe = {
                      top: Be.top + (on ? Er - Q : Gn) + Ce,
                      left: Be.left + (on ? Gn : Er - Q) + Ce,
                      boxSizing: "border-box",
                      position: "fixed",
                    }),
                    (Xe[Ur] = Xe["max" + xi] = Math.ceil(Be.width) + Ce),
                    (Xe[$r] = Xe["max" + to] = Math.ceil(Be.height) + Ce),
                    (Xe[Pt] =
                      Xe[Pt + Wi] =
                      Xe[Pt + Ui] =
                      Xe[Pt + Gi] =
                      Xe[Pt + $i] =
                        "0"),
                    (Xe[Te] = Fe[Te]),
                    (Xe[Te + Wi] = Fe[Te + Wi]),
                    (Xe[Te + Ui] = Fe[Te + Ui]),
                    (Xe[Te + Gi] = Fe[Te + Gi]),
                    (Xe[Te + $i] = Fe[Te + $i]),
                    (fr = Nl(Zt, Xe, w)),
                    tt && xe(0)),
                  i
                    ? ((no = i._initted),
                      ts(1),
                      i.render(i.duration(), !0, !0),
                      (Jt = ge(P.a) - kt + pe + oe),
                      (jt = Math.abs(pe - Jt) > 1),
                      K && jt && fr.splice(fr.length - 2, 2),
                      i.render(0, !0, !0),
                      no || i.invalidate(!0),
                      i.parent || i.totalTime(i.totalTime()),
                      ts(0))
                    : (Jt = pe),
                  Xt &&
                    (Xt.value
                      ? (Xt.style["overflow" + P.a.toUpperCase()] = Xt.value)
                      : Xt.style.removeProperty("overflow-" + P.a));
              else if (d && xe() && !x)
                for (Be = d.parentNode; Be && Be !== j; )
                  Be._pinOffset &&
                    ((Q -= Be._pinOffset), (de -= Be._pinOffset)),
                    (Be = Be.parentNode);
              wi &&
                wi.forEach(function (ki) {
                  return ki.revert(!1, !0);
                }),
                (g.start = Q),
                (g.end = de),
                (Qe = nt = tt ? Lt : xe()),
                !x && !tt && (Qe < Lt && xe(Lt), (g.scroll.rec = 0)),
                g.revert(!1, !0),
                (Ae = Ue()),
                Ft && ((ce = -1), Ft.restart(!0)),
                (Ve = 0),
                i &&
                  F &&
                  (i._initted || Dr) &&
                  i.progress() !== Dr &&
                  i.progress(Dr || 0, !0).render(i.time(), !0, !0),
                (Ye || qe !== g.progress || x || h || (i && !i._initted)) &&
                  (i &&
                    !F &&
                    i.totalProgress(
                      x && Q < -0.001 && !qe ? E.utils.normalize(Q, de, 0) : qe,
                      !0
                    ),
                  (g.progress = Ye || (Qe - Q) / pe === qe ? 0 : qe)),
                c && p && (Oe._pinOffset = Math.round(g.progress * Jt)),
                $ && $.invalidate(),
                isNaN(Si) ||
                  ((Si -= E.getProperty(y, P.p)),
                  (an -= E.getProperty(_t, P.p)),
                  vn(y, P, Si),
                  vn(st, P, Si - (I || 0)),
                  vn(_t, P, an),
                  vn(ht, P, an - (I || 0))),
                Ye && !tt && g.update(),
                f && !tt && !lr && ((lr = !0), f(g), (lr = !1));
            }
          }),
          (g.getVelocity = function () {
            return ((xe() - nt) / (Ue() - Ei)) * 1e3 || 0;
          }),
          (g.endAnimation = function () {
            Oi(g.callbackAnimation),
              i &&
                ($
                  ? $.progress(1)
                  : i.paused()
                  ? F || Oi(i, g.direction < 0, 1)
                  : Oi(i, i.reversed()));
          }),
          (g.labelToScroll = function (D) {
            return (
              (i &&
                i.labels &&
                (Q || g.refresh() || Q) + (i.labels[D] / i.duration()) * pe) ||
              0
            );
          }),
          (g.getTrailing = function (D) {
            var L = B.indexOf(g),
              R = g.direction > 0 ? B.slice(0, L).reverse() : B.slice(L + 1);
            return (
              gt(D)
                ? R.filter(function (I) {
                    return I.vars.preventOverlaps === D;
                  })
                : R
            ).filter(function (I) {
              return g.direction > 0 ? I.end <= Q : I.start >= de;
            });
          }),
          (g.update = function (D, L, R) {
            if (!(x && !R && !D)) {
              var I = tt === !0 ? Lt : g.scroll(),
                Me = D ? 0 : (I - Q) / pe,
                H = Me < 0 ? 0 : Me > 1 ? 1 : Me || 0,
                me = g.progress,
                Ye,
                he,
                oe,
                ee,
                It,
                ue,
                dt,
                Yt;
              if (
                (L &&
                  ((nt = Qe),
                  (Qe = x ? xe() : I),
                  v && ((Or = hr), (hr = i && !F ? i.totalProgress() : H))),
                m &&
                  c &&
                  !Ve &&
                  !hn &&
                  Et &&
                  (!H && Q < I + ((I - nt) / (Ue() - Ei)) * m
                    ? (H = 1e-4)
                    : H === 1 &&
                      de > I + ((I - nt) / (Ue() - Ei)) * m &&
                      (H = 0.9999)),
                H !== me && g.enabled)
              ) {
                if (
                  ((Ye = g.isActive = !!H && H < 1),
                  (he = !!me && me < 1),
                  (ue = Ye !== he),
                  (It = ue || !!H != !!me),
                  (g.direction = H > me ? 1 : -1),
                  (g.progress = H),
                  It &&
                    !Ve &&
                    ((oe = H && !me ? 0 : H === 1 ? 1 : me === 1 ? 2 : 3),
                    F &&
                      ((ee =
                        (!ue && z[oe + 1] !== "none" && z[oe + 1]) || z[oe]),
                      (Yt =
                        i &&
                        (ee === "complete" || ee === "reset" || ee in i)))),
                  k &&
                    (ue || Yt) &&
                    (Yt || _ || !i) &&
                    (We(k)
                      ? k(g)
                      : g.getTrailing(k).forEach(function (Er) {
                          return Er.endAnimation();
                        })),
                  F ||
                    ($ && !Ve && !hn
                      ? ($._dp._time - $._start !== $._time &&
                          $.render($._dp._time - $._start),
                        $.resetTo
                          ? $.resetTo("totalProgress", H, i._tTime / i._tDur)
                          : (($.vars.totalProgress = H),
                            $.invalidate().restart()))
                      : i && i.totalProgress(H, !!(Ve && (Ae || D)))),
                  c)
                ) {
                  if ((D && p && (Oe.style[p + P.os2] = bi), !K))
                    At(Ai(kt + Jt * H));
                  else if (It) {
                    if (
                      ((dt = !D && H > me && de + 1 > I && I + 1 >= Gt(M, P)),
                      w)
                    )
                      if (!D && (Ye || dt)) {
                        var ze = ir(c, !0),
                          Fe = I - Q;
                        Lo(
                          c,
                          j,
                          ze.top + (P === Pe ? Fe : 0) + Ce,
                          ze.left + (P === Pe ? 0 : Fe) + Ce
                        );
                      } else Lo(c, Oe);
                    _i(Ye || dt ? fr : Pr),
                      (jt && H < 1 && Ye) || At(kt + (H === 1 && !dt ? Jt : 0));
                  }
                }
                v && !Ke.tween && !Ve && !hn && Ft.restart(!0),
                  o &&
                    (ue || (S && H && (H < 1 || !rs))) &&
                    tn(o.targets).forEach(function (Er) {
                      return Er.classList[Ye || S ? "add" : "remove"](
                        o.className
                      );
                    }),
                  s && !F && !D && s(g),
                  It && !Ve
                    ? (F &&
                        (Yt &&
                          (ee === "complete"
                            ? i.pause().totalProgress(1)
                            : ee === "reset"
                            ? i.restart(!0).pause()
                            : ee === "restart"
                            ? i.restart(!0)
                            : i[ee]()),
                        s && s(g)),
                      (ue || !rs) &&
                        (l && ue && ns(g, l),
                        G[oe] && ns(g, G[oe]),
                        S && (H === 1 ? g.kill(!1, 1) : (G[oe] = 0)),
                        ue || ((oe = H === 1 ? 1 : 3), G[oe] && ns(g, G[oe]))),
                      O &&
                        !Ye &&
                        Math.abs(g.getVelocity()) > (zi(O) ? O : 2500) &&
                        (Oi(g.callbackAnimation),
                        $
                          ? $.progress(1)
                          : Oi(i, ee === "reverse" ? 1 : !H, 1)))
                    : F && s && !Ve && s(g);
              }
              if (Zr) {
                var Be = x ? (I / x.duration()) * (x._caScrollDist || 0) : I;
                sn(Be + (y._isFlipped ? 1 : 0)), Zr(Be);
              }
              jr && jr((-I / x.duration()) * (x._caScrollDist || 0));
            }
          }),
          (g.enable = function (D, L) {
            g.enabled ||
              ((g.enabled = !0),
              Ee(M, "resize", Fi),
              U || Ee(M, "scroll", ri),
              se && Ee(a, "refreshInit", se),
              D !== !1 && ((g.progress = qe = 0), (Qe = nt = ce = xe())),
              L !== !1 && g.refresh());
          }),
          (g.getTween = function (D) {
            return D && Ke ? Ke.tween : $;
          }),
          (g.setPositions = function (D, L, R, I) {
            if (x) {
              var Me = x.scrollTrigger,
                H = x.duration(),
                me = Me.end - Me.start;
              (D = Me.start + (me * D) / H), (L = Me.start + (me * L) / H);
            }
            g.refresh(
              !1,
              !1,
              {
                start: Po(D, R && !!g._startClamp),
                end: Po(L, R && !!g._endClamp),
              },
              I
            ),
              g.update();
          }),
          (g.adjustPinSpacing = function (D) {
            if (be && D) {
              var L = be.indexOf(P.d) + 1;
              (be[L] = parseFloat(be[L]) + D + Ce),
                (be[1] = parseFloat(be[1]) + D + Ce),
                _i(be);
            }
          }),
          (g.disable = function (D, L) {
            if (
              g.enabled &&
              (D !== !1 && g.revert(!0, !0),
              (g.enabled = g.isActive = !1),
              L || ($ && $.pause()),
              (Lt = 0),
              Ne && (Ne.uncache = 1),
              se && De(a, "refreshInit", se),
              Ft && (Ft.pause(), Ke.tween && Ke.tween.kill() && (Ke.tween = 0)),
              !U)
            ) {
              for (var R = B.length; R--; )
                if (B[R].scroller === M && B[R] !== g) return;
              De(M, "resize", Fi), U || De(M, "scroll", ri);
            }
          }),
          (g.kill = function (D, L) {
            g.disable(D, L), $ && !L && $.kill(), u && delete Ds[u];
            var R = B.indexOf(g);
            R >= 0 && B.splice(R, 1),
              R === et && Pn > 0 && et--,
              (R = 0),
              B.forEach(function (I) {
                return I.scroller === g.scroller && (R = 1);
              }),
              R || tt || (g.scroll.rec = 0),
              i &&
                ((i.scrollTrigger = null),
                D && i.revert({ kill: !1 }),
                L || i.kill()),
              st &&
                [st, ht, y, _t].forEach(function (I) {
                  return I.parentNode && I.parentNode.removeChild(I);
                }),
              Hi === g && (Hi = 0),
              c &&
                (Ne && (Ne.uncache = 1),
                (R = 0),
                B.forEach(function (I) {
                  return I.pin === c && R++;
                }),
                R || (Ne.spacer = 0)),
              t.onKill && t.onKill(g);
          }),
          B.push(g),
          g.enable(!1, !1),
          er && er(g),
          i && i.add && !pe)
        ) {
          var J = g.update;
          (g.update = function () {
            (g.update = J), V.cache++, Q || de || g.refresh();
          }),
            E.delayedCall(0.01, g.update),
            (pe = 0.01),
            (Q = de = 0);
        } else g.refresh();
        c && Fl();
      }),
      (a.register = function (t) {
        return (
          ii ||
            ((E = t || ja()), Ja() && window.document && a.enable(), (ii = Ri)),
          ii
        );
      }),
      (a.defaults = function (t) {
        if (t) for (var i in t) gn[i] = t[i];
        return gn;
      }),
      (a.disable = function (t, i) {
        (Ri = 0),
          B.forEach(function (s) {
            return s[i ? "kill" : "disable"](t);
          }),
          De(X, "wheel", ri),
          De(ie, "scroll", ri),
          clearInterval(cn),
          De(ie, "touchcancel", Ut),
          De(j, "touchstart", Ut),
          dn(De, ie, "pointerdown,touchstart,mousedown", Oo),
          dn(De, ie, "pointerup,touchend,mouseup", Mo),
          Nn.kill(),
          _n(De);
        for (var n = 0; n < V.length; n += 3)
          pn(De, V[n], V[n + 1]), pn(De, V[n], V[n + 2]);
      }),
      (a.enable = function () {
        if (
          ((X = window),
          (ie = document),
          (yt = ie.documentElement),
          (j = ie.body),
          E &&
            ((tn = E.utils.toArray),
            (Vi = E.utils.clamp),
            (Os = E.core.context || Ut),
            (ts = E.core.suppressOverwrites || Ut),
            (Zs = X.history.scrollRestoration || "auto"),
            (Es = X.pageYOffset || 0),
            E.core.globals("ScrollTrigger", a),
            j))
        ) {
          (Ri = 1),
            (hi = document.createElement("div")),
            (hi.style.height = "100vh"),
            (hi.style.position = "absolute"),
            uu(),
            Ol(),
            ve.register(E),
            (a.isTouch = ve.isTouch),
            (_r =
              ve.isTouch &&
              /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent)),
            (Ps = ve.isTouch === 1),
            Ee(X, "wheel", ri),
            (Qs = [X, ie, yt, j]),
            E.matchMedia
              ? ((a.matchMedia = function (l) {
                  var f = E.matchMedia(),
                    _;
                  for (_ in l) f.add(_, l[_]);
                  return f;
                }),
                E.addEventListener("matchMediaInit", function () {
                  return io();
                }),
                E.addEventListener("matchMediaRevert", function () {
                  return ou();
                }),
                E.addEventListener("matchMedia", function () {
                  Nr(0, 1), Kr("matchMedia");
                }),
                E.matchMedia().add("(orientation: portrait)", function () {
                  return ss(), ss;
                }))
              : console.warn("Requires GSAP 3.11.0 or later"),
            ss(),
            Ee(ie, "scroll", ri);
          var t = j.hasAttribute("style"),
            i = j.style,
            n = i.borderTopStyle,
            s = E.core.Animation.prototype,
            o,
            u;
          for (
            s.revert ||
              Object.defineProperty(s, "revert", {
                value: function () {
                  return this.time(-0.01, !0);
                },
              }),
              i.borderTopStyle = "solid",
              o = ir(j),
              Pe.m = Math.round(o.top + Pe.sc()) || 0,
              it.m = Math.round(o.left + it.sc()) || 0,
              n ? (i.borderTopStyle = n) : i.removeProperty("border-top-style"),
              t || (j.setAttribute("style", ""), j.removeAttribute("style")),
              cn = setInterval(Ro, 250),
              E.delayedCall(0.5, function () {
                return (hn = 0);
              }),
              Ee(ie, "touchcancel", Ut),
              Ee(j, "touchstart", Ut),
              dn(Ee, ie, "pointerdown,touchstart,mousedown", Oo),
              dn(Ee, ie, "pointerup,touchend,mouseup", Mo),
              Cs = E.utils.checkPrefix("transform"),
              On.push(Cs),
              ii = Ue(),
              Nn = E.delayedCall(0.2, Nr).pause(),
              ni = [
                ie,
                "visibilitychange",
                function () {
                  var l = X.innerWidth,
                    f = X.innerHeight;
                  ie.hidden
                    ? ((So = l), (ko = f))
                    : (So !== l || ko !== f) && Fi();
                },
                ie,
                "DOMContentLoaded",
                Nr,
                X,
                "load",
                Nr,
                X,
                "resize",
                Fi,
              ],
              _n(Ee),
              B.forEach(function (l) {
                return l.enable(0, 1);
              }),
              u = 0;
            u < V.length;
            u += 3
          )
            pn(De, V[u], V[u + 1]), pn(De, V[u], V[u + 2]);
        }
      }),
      (a.config = function (t) {
        "limitCallbacks" in t && (rs = !!t.limitCallbacks);
        var i = t.syncInterval;
        (i && clearInterval(cn)) || ((cn = i) && setInterval(Ro, i)),
          "ignoreMobileResize" in t &&
            (Ps = a.isTouch === 1 && t.ignoreMobileResize),
          "autoRefreshEvents" in t &&
            (_n(De) || _n(Ee, t.autoRefreshEvents || "none"),
            (Ka = (t.autoRefreshEvents + "").indexOf("resize") === -1));
      }),
      (a.scrollerProxy = function (t, i) {
        var n = ot(t),
          s = V.indexOf(n),
          o = Hr(n);
        ~s && V.splice(s, o ? 6 : 2),
          i && (o ? qt.unshift(X, i, j, i, yt, i) : qt.unshift(n, i));
      }),
      (a.clearMatchMedia = function (t) {
        B.forEach(function (i) {
          return i._ctx && i._ctx.query === t && i._ctx.kill(!0, !0);
        });
      }),
      (a.isInViewport = function (t, i, n) {
        var s = (gt(t) ? ot(t) : t).getBoundingClientRect(),
          o = s[n ? Ur : $r] * i || 0;
        return n
          ? s.right - o > 0 && s.left + o < X.innerWidth
          : s.bottom - o > 0 && s.top + o < X.innerHeight;
      }),
      (a.positionInViewport = function (t, i, n) {
        gt(t) && (t = ot(t));
        var s = t.getBoundingClientRect(),
          o = s[n ? Ur : $r],
          u =
            i == null
              ? o / 2
              : i in Xn
              ? Xn[i] * o
              : ~i.indexOf("%")
              ? (parseFloat(i) * o) / 100
              : parseFloat(i) || 0;
        return n ? (s.left + u) / X.innerWidth : (s.top + u) / X.innerHeight;
      }),
      (a.killAll = function (t) {
        if (
          (B.slice(0).forEach(function (n) {
            return n.vars.id !== "ScrollSmoother" && n.kill();
          }),
          t !== !0)
        ) {
          var i = qr.killAll || [];
          (qr = {}),
            i.forEach(function (n) {
              return n();
            });
        }
      }),
      a
    );
  })();
Y.version = "3.12.7";
Y.saveStyles = function (a) {
  return a
    ? tn(a).forEach(function (e) {
        if (e && e.style) {
          var r = pt.indexOf(e);
          r >= 0 && pt.splice(r, 5),
            pt.push(
              e,
              e.style.cssText,
              e.getBBox && e.getAttribute("transform"),
              E.core.getCache(e),
              Os()
            );
        }
      })
    : pt;
};
Y.revert = function (a, e) {
  return io(!a, e);
};
Y.create = function (a, e) {
  return new Y(a, e);
};
Y.refresh = function (a) {
  return a ? Fi(!0) : (ii || Y.register()) && Nr(!0);
};
Y.update = function (a) {
  return ++V.cache && sr(a === !0 ? 2 : 0);
};
Y.clearScrollMemory = au;
Y.maxScroll = function (a, e) {
  return Gt(a, e ? it : Pe);
};
Y.getScrollFunc = function (a, e) {
  return kr(ot(a), e ? it : Pe);
};
Y.getById = function (a) {
  return Ds[a];
};
Y.getAll = function () {
  return B.filter(function (a) {
    return a.vars.id !== "ScrollSmoother";
  });
};
Y.isScrolling = function () {
  return !!Et;
};
Y.snapDirectional = ro;
Y.addEventListener = function (a, e) {
  var r = qr[a] || (qr[a] = []);
  ~r.indexOf(e) || r.push(e);
};
Y.removeEventListener = function (a, e) {
  var r = qr[a],
    t = r && r.indexOf(e);
  t >= 0 && r.splice(t, 1);
};
Y.batch = function (a, e) {
  var r = [],
    t = {},
    i = e.interval || 0.016,
    n = e.batchMax || 1e9,
    s = function (l, f) {
      var _ = [],
        d = [],
        c = E.delayedCall(i, function () {
          f(_, d), (_ = []), (d = []);
        }).pause();
      return function (p) {
        _.length || c.restart(!0),
          _.push(p.trigger),
          d.push(p),
          n <= _.length && c.progress(1);
      };
    },
    o;
  for (o in e)
    t[o] =
      o.substr(0, 2) === "on" && We(e[o]) && o !== "onRefreshInit"
        ? s(o, e[o])
        : e[o];
  return (
    We(n) &&
      ((n = n()),
      Ee(Y, "refresh", function () {
        return (n = e.batchMax());
      })),
    tn(a).forEach(function (u) {
      var l = {};
      for (o in t) l[o] = t[o];
      (l.trigger = u), r.push(Y.create(l));
    }),
    r
  );
};
var No = function (e, r, t, i) {
    return (
      r > i ? e(i) : r < 0 && e(0),
      t > i ? (i - r) / (t - r) : t < 0 ? r / (r - t) : 1
    );
  },
  as = function a(e, r) {
    r === !0
      ? e.style.removeProperty("touch-action")
      : (e.style.touchAction =
          r === !0
            ? "auto"
            : r
            ? "pan-" + r + (ve.isTouch ? " pinch-zoom" : "")
            : "none"),
      e === yt && a(j, r);
  },
  xn = { auto: 1, scroll: 1 },
  Bl = function (e) {
    var r = e.event,
      t = e.target,
      i = e.axis,
      n = (r.changedTouches ? r.changedTouches[0] : r).target,
      s = n._gsap || E.core.getCache(n),
      o = Ue(),
      u;
    if (!s._isScrollT || o - s._isScrollT > 2e3) {
      for (
        ;
        n &&
        n !== j &&
        ((n.scrollHeight <= n.clientHeight && n.scrollWidth <= n.clientWidth) ||
          !(xn[(u = Ot(n)).overflowY] || xn[u.overflowX]));

      )
        n = n.parentNode;
      (s._isScroll =
        n &&
        n !== t &&
        !Hr(n) &&
        (xn[(u = Ot(n)).overflowY] || xn[u.overflowX])),
        (s._isScrollT = o);
    }
    (s._isScroll || i === "x") && (r.stopPropagation(), (r._gsapAllow = !0));
  },
  fu = function (e, r, t, i) {
    return ve.create({
      target: e,
      capture: !0,
      debounce: !1,
      lockAxis: !0,
      type: r,
      onWheel: (i = i && Bl),
      onPress: i,
      onDrag: i,
      onScroll: i,
      onEnable: function () {
        return t && Ee(ie, ve.eventTypes[0], Bo, !1, !0);
      },
      onDisable: function () {
        return De(ie, ve.eventTypes[0], Bo, !0);
      },
    });
  },
  Xl = /(input|label|select|textarea)/i,
  Yo,
  Bo = function (e) {
    var r = Xl.test(e.target.tagName);
    (r || Yo) && ((e._gsapAllow = !0), (Yo = r));
  },
  Vl = function (e) {
    Lr(e) || (e = {}),
      (e.preventDefault = e.isNormalizer = e.allowClicks = !0),
      e.type || (e.type = "wheel,touch"),
      (e.debounce = !!e.debounce),
      (e.id = e.id || "normalizer");
    var r = e,
      t = r.normalizeScrollX,
      i = r.momentum,
      n = r.allowNestedScroll,
      s = r.onRelease,
      o,
      u,
      l = ot(e.target) || yt,
      f = E.core.globals().ScrollSmoother,
      _ = f && f.get(),
      d =
        _r &&
        ((e.content && ot(e.content)) ||
          (_ && e.content !== !1 && !_.smooth() && _.content())),
      c = kr(l, Pe),
      p = kr(l, it),
      h = 1,
      m =
        (ve.isTouch && X.visualViewport
          ? X.visualViewport.scale * X.visualViewport.width
          : X.outerWidth) / X.innerWidth,
      T = 0,
      b = We(i)
        ? function () {
            return i(o);
          }
        : function () {
            return i || 2.8;
          },
      S,
      v,
      w = fu(l, e.type, !0, n),
      C = function () {
        return (v = !1);
      },
      x = Ut,
      O = Ut,
      k = function () {
        (u = Gt(l, Pe)),
          (O = Vi(_r ? 1 : 0, u)),
          t && (x = Vi(0, Gt(l, it))),
          (S = Wr);
      },
      P = function () {
        (d._gsap.y = Ai(parseFloat(d._gsap.y) + c.offset) + "px"),
          (d.style.transform =
            "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " +
            parseFloat(d._gsap.y) +
            ", 0, 1)"),
          (c.offset = c.cacheID = 0);
      },
      F = function () {
        if (v) {
          requestAnimationFrame(C);
          var Z = Ai(o.deltaY / 2),
            ne = O(c.v - Z);
          if (d && ne !== c.v + c.offset) {
            c.offset = ne - c.v;
            var g = Ai((parseFloat(d && d._gsap.y) || 0) - c.offset);
            (d.style.transform =
              "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " +
              g +
              ", 0, 1)"),
              (d._gsap.y = g + "px"),
              (c.cacheID = V.cache),
              sr();
          }
          return !0;
        }
        c.offset && P(), (v = !0);
      },
      M,
      W,
      U,
      K,
      G = function () {
        k(),
          M.isActive() &&
            M.vars.scrollY > u &&
            (c() > u ? M.progress(1) && c(u) : M.resetTo("scrollY", u));
      };
    return (
      d && E.set(d, { y: "+=0" }),
      (e.ignoreCheck = function (z) {
        return (
          (_r && z.type === "touchmove" && F()) ||
          (h > 1.05 && z.type !== "touchstart") ||
          o.isGesturing ||
          (z.touches && z.touches.length > 1)
        );
      }),
      (e.onPress = function () {
        v = !1;
        var z = h;
        (h = Ai(((X.visualViewport && X.visualViewport.scale) || 1) / m)),
          M.pause(),
          z !== h && as(l, h > 1.01 ? !0 : t ? !1 : "x"),
          (W = p()),
          (U = c()),
          k(),
          (S = Wr);
      }),
      (e.onRelease = e.onGestureStart =
        function (z, Z) {
          if ((c.offset && P(), !Z)) K.restart(!0);
          else {
            V.cache++;
            var ne = b(),
              g,
              se;
            t &&
              ((g = p()),
              (se = g + (ne * 0.05 * -z.velocityX) / 0.227),
              (ne *= No(p, g, se, Gt(l, it))),
              (M.vars.scrollX = x(se))),
              (g = c()),
              (se = g + (ne * 0.05 * -z.velocityY) / 0.227),
              (ne *= No(c, g, se, Gt(l, Pe))),
              (M.vars.scrollY = O(se)),
              M.invalidate().duration(ne).play(0.01),
              ((_r && M.vars.scrollY >= u) || g >= u - 1) &&
                E.to({}, { onUpdate: G, duration: ne });
          }
          s && s(z);
        }),
      (e.onWheel = function () {
        M._ts && M.pause(), Ue() - T > 1e3 && ((S = 0), (T = Ue()));
      }),
      (e.onChange = function (z, Z, ne, g, se) {
        if (
          (Wr !== S && k(),
          Z && t && p(x(g[2] === Z ? W + (z.startX - z.x) : p() + Z - g[1])),
          ne)
        ) {
          c.offset && P();
          var He = se[2] === ne,
            Rt = He ? U + z.startY - z.y : c() + ne - se[1],
            ce = O(Rt);
          He && Rt !== ce && (U += ce - Rt), c(ce);
        }
        (ne || Z) && sr();
      }),
      (e.onEnable = function () {
        as(l, t ? !1 : "x"),
          Y.addEventListener("refresh", G),
          Ee(X, "resize", G),
          c.smooth &&
            ((c.target.style.scrollBehavior = "auto"),
            (c.smooth = p.smooth = !1)),
          w.enable();
      }),
      (e.onDisable = function () {
        as(l, !0),
          De(X, "resize", G),
          Y.removeEventListener("refresh", G),
          w.kill();
      }),
      (e.lockAxis = e.lockAxis !== !1),
      (o = new ve(e)),
      (o.iOS = _r),
      _r && !c() && c(1),
      _r && E.ticker.add(Ut),
      (K = o._dc),
      (M = E.to(o, {
        ease: "power4",
        paused: !0,
        inherit: !1,
        scrollX: t ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
          scrollY: lu(c, c(), function () {
            return M.pause();
          }),
        },
        onUpdate: sr,
        onComplete: K.vars.onComplete,
      })),
      o
    );
  };
Y.sort = function (a) {
  if (We(a)) return B.sort(a);
  var e = X.pageYOffset || 0;
  return (
    Y.getAll().forEach(function (r) {
      return (r._sortY = r.trigger
        ? e + r.trigger.getBoundingClientRect().top
        : r.start + X.innerHeight);
    }),
    B.sort(
      a ||
        function (r, t) {
          return (
            (r.vars.refreshPriority || 0) * -1e6 +
            (r.vars.containerAnimation ? 1e6 : r._sortY) -
            ((t.vars.containerAnimation ? 1e6 : t._sortY) +
              (t.vars.refreshPriority || 0) * -1e6)
          );
        }
    )
  );
};
Y.observe = function (a) {
  return new ve(a);
};
Y.normalizeScroll = function (a) {
  if (typeof a > "u") return je;
  if (a === !0 && je) return je.enable();
  if (a === !1) {
    je && je.kill(), (je = a);
    return;
  }
  var e = a instanceof ve ? a : Vl(a);
  return je && je.target === e.target && je.kill(), Hr(e.target) && (je = e), e;
};
Y.core = {
  _getVelocityProp: ks,
  _inputObserver: fu,
  _scrollers: V,
  _proxies: qt,
  bridge: {
    ss: function () {
      Et || Kr("scrollStart"), (Et = Ue());
    },
    ref: function () {
      return Ve;
    },
  },
};
ja() && E.registerPlugin(Y);
dr.registerPlugin(Y);
const Xo = {
    layout: [
      () => Y.saveStyles(".mobile, .desktop"),
      () =>
        Y.matchMedia({
          "(min-width: 800px)": function () {
            dr.to("header", {
              height: 36,
              scrollTrigger: {
                trigger: "header",
                scrub: 0.3,
                start: "top top",
                end: "bottom top",
              },
              onUpdate: function () {
                // DBEUG
                console.log(this.targets()[0].offsetHeight);
                document.body.style.setProperty(
                  "--header-height",
                  `${this.targets()[0].offsetHeight}px`
                );
              },
            }),
              dr.to("header .left img", {
                height: 12,
                scrollTrigger: {
                  trigger: "header",
                  scrub: 0.3,
                  start: "top top",
                  end: "bottom top",
                },
              });
          },
          "(max-width: 799px)": function () {},
          all: function () {
            // Initialize header height CSS variable
            document.body.style.setProperty(
              "--header-height",
              `${document.querySelector("header").offsetHeight}px`
            );
          },
        }),
    ],
    home: [
      () =>
        Y.matchMedia({
          "(min-width: 800px)": function () {
            dr.to(".media-section .media-block:first-child", {
              xPercent: -100,
              scrollTrigger: {
                trigger: ".media-section",
                scrub: 0.3,
                start: "top top",
                end: "200% 50%",
              },
            }),
              dr.to(".media-section .media-block:last-child", {
                xPercent: 100,
                scrollTrigger: {
                  trigger: ".media-section",
                  scrub: 0.3,
                  start: "top top",
                  end: "200% 50%",
                },
              }),
              dr.to(".media-section .media-block:nth-child(2)", {
                yPercent: -100,
                scrollTrigger: {
                  trigger: ".media-section",
                  scrub: 0.3,
                  start: "top top",
                  end: "200% 50%",
                },
              });
          },
          "(max-width: 799px)": function () {},
          all: function () {},
        }),
    ],
    productList: [
      () =>
        Y.matchMedia({
          "(min-width: 800px)": function () {},
          "(max-width: 799px)": function () {},
          all: function () {},
        }),
    ],
    about: [],
  },
  Ul = {
    animations: Xo,
    play(a, e = null) {
      let r = [];
      return (
        Xo[a].forEach((t) => {
          r.push(t(e));
        }),
        r
      );
    },
    destroy(a) {
      a &&
        a.forEach((e) => {
          !e ||
            !e.targets ||
            (dr.set(e.targets(), { clearProps: "all" }), e.kill());
        });
    },
  };
export { Ul as g };
